
import React, { useEffect, useMemo, useRef, useState } from "react";
import DataTable from "components/Core/DataTable";

import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  ModalFooter,
  Modal,
  CustomInput,
  Nav,
  NavItem,
  NavLink,
  Container,
  Collapse,
} from "reactstrap";
import { MotionButton } from "../components/Core/MotionStrap";
import NotificationAlert from "react-notification-alert";
import Catalogs from "../lib/Core/Backend/Controllers/Catalogs";
import Purchaser from "../lib/Core/Backend/Controllers/Purchaser";
import PurchaseOrder from "../lib/Core/Backend/Controllers/PurchaseOrder";
import Notify from "../lib/Utils/Alert";
import Utils from "../lib/Utils/Utils";
import ContactsCtl from "../components/Supplier/ContactsCtl";
import BrandsCtl from "../components/Purchaser/BrandsCtl";
import BestBrandsCtl from "components/Purchaser/BestBrandsCtl";
import Brand from "../lib/Core/Backend/Controllers/Brand";
import FormValidator from "../lib/Utils/FormValidator";
import BaseModal from "../components/Core/BaseModal";
import CardType from "../lib/Core/Backend/Controllers/CardType";
import PurchaserManager from "components/Purchaser/PurchaserManager";
import PurchaseOrdersByPurchaser from "components/Purchaser/PurchaseOrdersByPurchaser";
import BrandList from "components/Purchaser/BrandList";
import Auth from "../lib/Core/Backend/Controllers/Auth";
import ContactManager from "components/Purchaser/ContactManager";
import PaymentManager from "components/Purchaser/PaymentManager ";
import InvoiceManeger from "components/Purchaser/InvoiceManeger";
import PurchaserNotification from "../components/Purchaser/PurchaserNotification";
import $, { data } from "jquery";
import InternalPurchaseOrderForm from "../components/PurchaseOrder/InternalPurchaseOrderForm";
import InternalShoppingCart from "../lib/Core/Backend/Controllers/InternalShoppingCart";
import Papa from "papaparse";
import Select from "react-select";
import ModalHistorySKU from "components/Purchaser/ModalHistorySKU";
import ModalConfirm from "components/Purchaser/ModalConfirm";
import ConfirmationAlert from "../components/ConfirmationAlert/ConfirmationAlert";
import Supplier from "lib/Core/Backend/Controllers/Supplier";
import Category from "lib/Core/Backend/Controllers/Category";
import useCatalogs from "hooks/useCatalogs";
import * as modalCSVcss from "../components/Supplier/css/modalUploadCSV.module.css";
import { ReactComponent as UploadIcon } from "../assets/img/upload.svg";
import APICredential from "components/Supplier/APICredential";
import UploadCsv from "components/Purchaser/uploadCsv";
import okIMG from "../assets/img/ok.png";
import "../../src/assets/scss/react/_buttons.scss"
import ReactNotificationAlert from "react-notification-alert";
import { Radio, RadioGroup } from "@mui/material";
import { BsInfoCircle } from "react-icons/bs";
import Spinner from 'react-bootstrap/Spinner';
const mapKeys = {
  mainPhone: "mainPhone",
  name: "name",
  website: "website",
  id: "id",
  city: "city",
  billingCity: "billingCity",
  billingPostalCode: "billingPostalCode",
  countryId: "countryId",
  billingCoutryId: "billingCoutryId",
  postalCode: "zipcode",
  street: "street",
  billingAddress: "billingAddress",
  email: "email",
  paymentOptionId: "paymentTypeId",
  currencyId: "currency",
  thresholdAmount: "paymentTypeAmount",
  purchaseDiscount: "purchaseDiscount",
  purchaseFee: "purchaseFee",
  funds: "fundAmount",
  active:"Fundstatus",
  creditLimit: "creditLimit",
  creditThreshold: "creditThreshold",
  prepaidFunds: "prepaidFunds",
  minimumAmount: "minimumAmount",
  maximumAmount: "maximumAmount",
  minimumQuantity: "minimumQuantity",
  maximumQuantity: "maximumQuantity",
};

function PurchaserView(props) {
  const [fileCsv, setFileCsv] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const { token, accessRoles } = props;
  const { currencies } = useCatalogs();
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const supplierCtl = useMemo(() => new Supplier(token), [token]);
  const catalogsCtl = useMemo(() => new Catalogs(token), [token]);
  const cardTypeCtl = useMemo(() => new CardType(token), [token]);
  const brandsCtl = useMemo(() => new Brand(token), [token]);
  const authCtl = useMemo(() => new Auth(token), [token]);
  const categoriesCtl = new Category(token);
  const [selectedRadio, setSelectedRadio] = React.useState({
    cardDelivery: [],
    orderConfirmation: [],
    proformaInvoice: [],
    orderInvoice: [],
  });
  const internalShoppingCartCtl = useMemo(
    () => new InternalShoppingCart(token),
    [token]
  );
  const [showBrandsNav, setShowBrandsNav] = useState(false)
  const [modal, setModal] = useState(false);
  const [upload, setUpload] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [purchaseOrdersModal, setPurchaseOrdersModal] = useState(false);
  const [createPurchaseOrderModal, setCreatePurchaseOrderModal] =
    useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [invoiceModal, setInvoiceModal] = useState(false)
  const [updateFunds, setUpdateFunds] = useState();
  const [fundsFile, setFundsFile] = useState(null);
  const [name, setname] = useState("");

  const [reload, setReload] = useState(false);
  const triggerReload = () => setReload(!reload);

  const toggle = () => setModal(!modal);
  const toggleUpload = () => setUpload(!upload);
  const toggleConfirm = () => setConfirmModal(!confirmModal);
  const togglePurchaseOrders = () =>
    setPurchaseOrdersModal(!purchaseOrdersModal);
  
    
  const toggleCreatePurchaseOrder = () => {
    setCreatePurchaseOrderModal(!createPurchaseOrderModal);
    cleanFeeDisc();
  };
  const toggleDetails = () => setDetailsModal(!detailsModal);
  const toggleInvoice = () => {
    setInvoiceModal(false)
    setPayment([]);
    setInvoiceData([])
    setUpdateData([]);
    setPaymentNav(true)
    setInvoiceNav(false)
    
  };
  const toggleUpdateFunds = () => setUpdateFunds(!updateFunds);
  const [showmail, setShowEmail] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeOp, setActiveOp] = useState("");
  const [activeOpText, setActiveOpText] = useState("");
  const [operativeRow, setOperativeRow] = useState(null);
  const [currentRow,setCurrentRow] = useState(null)
  const [isEmpty, setIsEmpty] = useState(true);

  const isMounted = useRef(null);

  const form = useRef();
  const table = useRef();
  const alert = useRef();
  const contactTable = useRef();
  const contactForm = useRef();
  const brandTable = useRef();
  const inventoryBrandTable = useRef();
  const inventoryWhiteBrandTable = useRef();
  const orderThresholdTable = useRef()
  const bestBrandTable = useRef();
  const brandSelect = useRef();
  const bestBrandSelect = useRef();
  const supplierSelect = useRef();
  const quantity = useRef();
  const ValueRef = useRef();
  const DateRef = useRef();
  const priorityRef = useRef();
  const fundTable = useRef();
  const thirdinfoTable = useRef();

  const cardTypeTable = useRef();
  const brandForm = useRef();
  const bestBrandForm = useRef();
  const cardTypeForm = useRef();
  const purchaserUsersForm = useRef();
  const purchaserUsersTable = useRef();
  const brands = useRef(null);
  const paymentOptions = useRef([]);
  const cardTypes = useRef([]);
  const tableDiscFee = useRef(null);
  const [brandFilter, setBrandFilter] = useState([]);
  const [brandOption,setBrandOption] = useState([]);
  const [barndDataTwo,setBrandDataTwo] = useState([]);
  const [brandDataWhiteTwo,setBrandDataWhiteTwo] = useState([])
  const [selectedRefIds, setSelectedRefIds] = useState([]);
  const [selectedWhiteRefIds,setSelectedWhiteRefIds] = useState([])
  const [brandDiasbled,setBrandDiabled] = useState(false);
  const [rowId,setRowId] = useState('');
  const [inventoryBrandName,setInventoryBrandName] = useState('')
  const [inventoryWhiteBrandName,setInventoryWhiteBrandName] = useState('')
  const [rowIdWhite,setRowIdWhite] = useState('')
  const countriesInfo = useRef([]);
  const [countries, setCountries] = useState([]);
  const [contactType, setContactType] = useState([]);
  const [activeContact, setActiveContact] = useState(null);
  const [contactModal, setContactModal] = useState(false);
  const [activeBrand, setActiveBrand] = useState(null);
  const [brandModal, setBrandModal] = useState(false);
  const [inventoryBrandModal,setInventoryBrandModal] = useState(false);
  const [inventoryWhiteModal,setInventoryWhiteModal] = useState(false)
  const [inventoryEditBrandModal,setInventoryEditBrandModal] = useState(false)
  const [inventoryWhiteEditModal,setInventoryWhiteEditModal] = useState(false)
  const [bestBrandModal, setBestBrandModal] = useState(false);

  const [supplierModal, setSupplierModal] = useState(false);
  const [brandOperation, setBrandOperation] = useState({});
  const [purchaserToManage, setPurchaserToManage] = useState([null]);
  const [contacts, setContacts] = useState([]);
  const [payment, setPayment] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [modalHistory, setModalHistory] = useState(false);
  const [brandsFeeDisc, setBrandsFeeDisc] = useState([]);

  const [contactNav, setContactNav] = useState(true);
  const [notificationNav, setNotificationNav] = useState(false);
  const [paymentNav, setPaymentNav] = useState(true);
  const [invoiceNav, setInvoiceNav] = useState(false)
  const [brandsNav, setBrandsNav] = useState(false);
  const [usersNav, setUsersNav] = useState(false);
  const [contactActionType, setContactActionType] = useState({});
  const [newValue,setNewValue] = useState()
 
  

  const [purchaser, setPurchaser] = useState([
    { value: 1, name: "All Orders", label: "All Orders" },
  ]);

  // const toggleModalCSV = () => setUploadModalCsv(!uploadModalCsv)

  const stayModal = () => setShowAlertMessage(false);
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const [brandSelects, setBrandSelects] = useState([]);
  const [supplierInformation, setSupplierInformation] = useState({});
  const [apiDataAdd, setApiDataAdd] = useState(false)
  const [updateData, setUpdateData] = useState("")
  const [modalConfirm, setModalConfirm] = useState(false);
  const modalConfirmToggle = () => setModalConfirm(!modalConfirm);
  const [dataModalConfirm, setDataModalConfirm] = useState([]);
  const [termsofUseShow,setTermsofUseShow] = useState(false);
  const [selectBr, setSelectBr] = useState("");
  const [referenceValue, setReferenceValue] = useState('');
  const [platForm,setPlatForm] = useState("Admin");
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [filteredData, setFilteredData] = useState(brandsFeeDisc);
  // const [purchaserId,setPurchaserId] = useState("");
  const [loadThirdParty, setLoadThirdParty]=useState(false)
  const [loadFunds, setLoadFunds] =useState(false)
  const [loadConfirmFinish, setLoadConfirmFinish]=useState(false)
  const [loaderSave, setLoaderSave]=useState(false)
  const [loaderSave1, setLoaderSave1]=useState(false)
  const [loaderSave2, setLoaderSave2]=useState(false)
  const [loaderSave3, setLoaderSave3]=useState(false)
  const [loaderSave4, setLoaderSave4]=useState(false)
  const [loaderSave5, setLoaderSave5]=useState(false)
  const [loaderSave6, setLoaderSave6]=useState(false)
  const [loaderSave7, setLoaderSave7]=useState(false)
  const [loaderSave8, setLoaderSave8]=useState(false)
  const [loaderSave9, setLoaderSave9]=useState(false)
  const [loaderSave10, setLoaderSave10]=useState(false)
  const [loaderSave11, setLoaderSave11]=useState(false)
  const [loaderSave12, setLoaderSave12]=useState(false)
  const [loaderSave13, setLoaderSave13]=useState(false)
  const [loaderSave14, setLoaderSave14]=useState(false)
  const [showTooltip, setShowTooltip] = useState(false);
const onBrandNavClick =()=> {
  setDetailsModal(false);
  setShowBrandsNav(!showBrandsNav)
}

  const handleReferenceValueChange = (newValue) => {
    setReferenceValue(newValue); 
  };

  const onModalConfirmBack = () => {
    modalConfirmToggle();
    toggleCreatePurchaseOrder();
  };
  const onModalConfirmDone = () => {
    modalConfirmToggle();
    createPurchaseOrder();
  };
  const modalOrderToConfirm = () => {
    if (dataModalConfirm.length > 0) {
      modalConfirmToggle();
      setTermsofUseShow(true)
      toggleCreatePurchaseOrder();
    } else {
      Notify(alert, "danger", "Please make a order");
    }
  };

  // Brands Fee and Discount start

  const [brandFee, setBrandFee] = useState("");
  const [brandDisc, setBrandDisc] = useState("");
  const [brandRSelect, setBrandRSelect] = useState(null);
  const [brandSelectThreshold,setBrandSelectThreshold] = useState(null)
  const [brandValue,setBrandValue] = useState(null)
  const [brandsPurchaser, setBrandsPurchaser] = useState([]);
  const [brandsFromPurchaser, setBrandsFromPurchaser] = useState([]);
  const [brandList, setBrandList] = useState({});
  // const [orderThreshold, setOrderThreshold] = useState('')
  const [shouldDeleteBand, setShouldDeleteBand] = useState(false);
  const cardTypeInput = useRef();
  const [shouldClean, setShouldClean] = useState(false);
  const defaultBannedActions = { add: [], delete: [] };
  const [pendingBandActions, setPendingBandActions] =
    useState(defaultBannedActions);
  const [purchaserAddresTemp, setPurchaserAddresTemp] = useState({});
  const [initialCardsByPurchaser, setInitialCardsByPurchaser] = useState([]);
  const [bannEntryBrand, setBannEntryBrand] = useState([]);
  const [bestSupplier, setbestSupplier] = useState("");
  const [currency, setCurrency] = useState("");

  const [minimumAmount, setMinimumAmount] = useState("");
  const [maximumAmount, setMaximumAmount] = useState("");
  const [minimumQuantity, setMinimumQuantity] = useState("");
  const [maximumQuantity, setMaximumQuantity] = useState("");
  const [minimumAmountOrder, setMinimumAmountOrder] = useState("");
  const [maximumAmountOrder, setMaximumAmountOrder] = useState("");
  const [minimumQuantityOrder, setMinimumQuantityOrder] = useState("");
  const [maximumQuantityOrder, setMaximumQuantityOrder] = useState("");
  const [supplierName, setSupplierName] = useState();
  const [supplierNameData, setSupplierNameData] = useState();
  const [sendID, setSendID] = useState("")
  const [purchaserName,setPurchaserName] = useState("");
  const [bulkLayout, setBulkLayout] = useState(null);
  const [topup, setTopUp] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [countryData, setCountryData] = useState("");
  const [country, setCountry] = useState([]);
  const [reference, setReference] = useState("")
  const [postal, setPostal] = useState("");
  const [billingInfo, setBillingInfo] = useState(false);
  const [apiCredInfo, setApiCredInfo] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [quantityVal,setQuantityVal] = useState(null);
  const [value,setValue] = useState(null);
  const [timeLapse,setTimeLapse] = useState("");
  const [priority,setPriority] = useState()
  const [brandSelectedOption, setBrandSelectedOption] = useState(null);
  const [categoryOption,setCategoryOption] = useState([]);
  const [currencyValue,setCurrencyValue] =  useState("");
  const [fundStat,setFundStat] = useState(true);
  const [disabled,setDisabled] = useState(false)
  const [fundTableData,setFundTableData] = useState([])
  const [fundDetailsData,setFundDetailsData] = useState([]);
  const [fundShow,setFundShow] = useState(false);
  const [fundValue,setFundValue] = useState("")
  const [creditValue,setCreditValue] = useState("")
  const [thresholdValue,setThresholdValue] = useState("")
  const [prepareValue,setPrepareValue] = useState("");
  const [threshold,setThreshold] = useState("")
  const  [addFund,setAddFund] = useState(false);
  const [fundID,setFundID] = useState()
  const [currOption,setCurrOption] = useState([])
  const [currencyID,setCurrencyID] = useState()
  const [addFundValue,setAddFundValue] = useState("")
  const [addCreditValue, setAddCreditValue] = useState("");
  const [addThresholdValue, setAddThresholdValue] = useState("");
  const [addPrepareValue, setAddPrepareValue] = useState(""); 
  const [defaultCurrency,setDefaultCurrency] = useState("");
  const [taxId,setTaxId] = useState("");
  const [clientProgramNumber,setClientProgramNumber] = useState("");
  const [company,setCompany] = useState("");
  const [contact,setContact] = useState("");
  const [lineOne,setLineOne] = useState("");
  const [lineTwo,setLineTwo] = useState("");
  const [lineThree,setLineThree] = useState("");
  const [thirdPartyCity,setThirdPartyCity] = useState("");
  const [postalCodeThird,setPostalCodeThird] = useState("");
  const [postalExt,setPostalExt] = useState("")
  const [currencyOptionThird,setCurrencyOptionThird] = useState([])
  const [regionOption,setRegionOption] = useState([])
  const [disable,setDisable] = useState(false);
  const [thirdCountryValue,setThirdCountryValue] = useState("")
  const [thirdRegionValue,setThirdRegionValue] = useState("")
  const [thirdCountryId,setThirdCountryId] = useState("")
  const [thirdRegionId,setThirdRegionId] = useState("");
  const [paymentModalTwo,setPaymentModalTwo] = useState(false);
  const [cancelOrder, setCancelOrder] = useState(false);
  
  const [defaultRegion,setDefaultRegion] = useState(null)
  const [defaultCountryThird,setDefaultCountryThird] = useState(null);
  const [thirdpartyId,setThirdpartyId] = useState();
  const [errorMessage,setErrorMessage] = useState("")
  const [responseData,setResponseData] = useState([])
  const [finishOpen,setFinishOpen] = useState(false)
  const [editFinish,setEditFinish] = useState(false);
  const [addressModal,setAddressModal] = useState(false);
  const [billingModal,setBillingModal] = useState(false);
  const [paymentOptionModal,setPaymentOptionModal] = useState(false);
  const [contactFinishModal,setContactFinishModal] = useState(false);
  const [brandId,setBrandId] = useState();
  const [brandName,setBrandName] = useState("");
  const [refID,setRefID] = useState('');
  const [brandIdTwo,setBrandIdTwo] = useState('')
  const [brandNameTwo,setBrandNameTwo] = useState('')
  const [refIDTwo,setRefIDTwo] = useState('')
  const [refLabel,setRefLabel] = useState('');
  const [inventoryData,setInventoryData] = useState([])
  const [inventoryWhiteData,setInventoryWhiteData] = useState([])
  const [brandData,setBrandData] = useState([])
  const [whiteBrandData,setWhiteBrandData] = useState([])
  const [orderThresData,setOrderThresData] = useState([])
  const [getThresholdData,setGetThresholdData]= useState([])
  const [refOption,setRefOption] = useState([]);
  const [warningModal,setWarningModal] = useState(false)
  const [buttonLoader,setButtonLoader] = useState(false);
  const [orderThresholdModal,setOrderThrsholdModal] = useState(false)
  const [passCurrency,setPassCurrency] = useState("")
  const [creditModal,setCreditModal] = useState(false)
  const [creditType,setCreditType] = useState("Add")
  const [updateCreditValue,setUpdateCreditValue] = useState()
  const [dropdownCall,setdropdownCall] = useState(false)
  const [depositeLoader,setDepositeLoader] = useState(false);
  const [edit,setEdit]= useState(false)
  const [purchaseId,setPurchaseId] = useState(null);
  const [id,setId] = useState(null)
  const [loader,setLoader] = useState(true)
  const [loaderTwo,setLoaderTwo] = useState(true);
  const [payload,setPayload] = useState({})
  const [productName,setProductName] = useState("")
  const [cardId,setCardId] = useState()
  const [feeInput,setFeeInput] = useState("AMOUNT")
  


  const toggleRegister = () => setPaymentModal(!paymentModal);
  const toggleFund = () => setFundShow(!fundShow)
   const toggleAddFundModal = () =>setAddFund(!addFund)
   const toggleFinishModal = () => setFinishOpen(!finishOpen);
   const toggleEditFinishModal = () =>setEditFinish(!editFinish);
   const toggleAdressFinishModal = () =>setAddressModal(!addressModal);
   const toggleBillingFinishModal = () => setBillingModal(!billingModal);
   const togglepaymentoptins = () => setPaymentOptionModal(!paymentOptionModal);
   const toggleContactFinishModal = () => setContactFinishModal(!contactFinishModal)
   const toggleInventoryBrand = () => setInventoryBrandModal(!inventoryBrandModal)
   const toggleInventoryWhite = () =>setInventoryWhiteModal(!inventoryWhiteModal)
   const toggleInventoryBrandEdit = ()=>setInventoryEditBrandModal(!inventoryEditBrandModal)
   const toggleInventoryWhiteEdit = ()=>setInventoryWhiteEditModal(!inventoryWhiteEditModal)
   const toggleOrderThreshold = () => setOrderThrsholdModal(!orderThresholdModal);
   const toggleWarning = () => setWarningModal(!warningModal);
   const toggleCreditThreshold = () => setCreditModal(!creditModal)
  const addPayment = () => {
    setdropdownCall(true)
    toggleRegister()
    purchaserCtl.findCurrency(sendID, (dat) => {
      if (dat && !dat.error) {
        const currecyData = dat.map(item => ({
          
          value: item.currencyId,
          label: item.currencyCode
        }))
        setCategoryOption(currecyData)
      } else {
        setCategoryOption([]);
      }
    });
  }

 

  const handleCurrency = (options) =>{
    const currencyoptions = options?.value
    setCurrencyValue(currencyoptions)
  }

  useEffect(() => {
    setBrandsFeeDisc(
      brandsFromPurchaser.map((i) => ({
        id: i.id,
        brandName: brandList[i.brandId],
        brandId: i.brandId,
        purchaserFee: i.purchaseFeeType === "AMOUNT" ?" $  " + i.purchaseFee.toFixed(2): i.purchaseFee.toFixed(2) + "%",
        purchaserDiscount: i.purchaseDiscount.toFixed(2),
        currency:i.currency,
        minimumAmount: i.minimumAmount,
        maximumAmount: i.maximumAmount,
        minimumQuantity: i.minimumQuantity,
        maximumQuantity: i.maximumQuantity,
      }))
    );
  }, [brandsFromPurchaser]); //, orderThreshold: i.orderThreshold,
  useEffect(() => {
    
    tableDiscFee.current &&
      tableDiscFee.current.dataTable.clear().rows.add(brandsFeeDisc).draw();
  }, [brandsFeeDisc]);

  useEffect(()=>{
    setFundTableData(
      fundDetailsData.map((i)=>({
        purchaserName: i?.purchaserName,
        funds: i?.funds,
        creditThreshold: i?.creditThreshold,
        currency: i?.currencyName,
        currencyID:i?.currencyId,
        prepaidFunds: i?.prepaidFunds,
        creditLimit: i?.creditLimit,
        id:i?.id,
        paymentOptionId:i?.paymentOptionId,
        lowFundAlert:i?.lowFundAlert
      }))
    )
   
  },[fundDetailsData])



 

  useEffect(() => {
    if(fundTable.current){
  fundTable.current.dataTable.clear().rows.add(fundTableData).draw();
 } 
 
  },[fundTableData])

  const toggleModalHistory = () => setModalHistory(!modalHistory);

  const cleanFeeDisc = () => {
    setBrandRSelect(null);
    setBrandDisc("");
    setBrandFee("");
    // setOrderThreshold('')
    setMinimumAmount("");
    setMaximumAmount("");
    setMinimumQuantity("");
    setMaximumQuantity("");
  };

  const cleanTemporaryBanedCards = () => {
    shouldClean ? setShouldClean(false) : cleanBanState();
  };
  const cleanBanState = () => {
    setPendingBandActions({ add: [], delete: [] });
    setBannEntryBrand([]);
  };

  const [purchaserId, setPurchaserId] = useState();
  const loaderSavingAll4=()=>{
    setTimeout(()=>{
      setLoaderSave4(false)
    },1500)
  }
  const addBrandToBrandList = (dt) => {
    setLoaderSave4(true)
    const id = dt.data().id;
    if ((Boolean(brandFee) || Boolean(brandDisc)) && Boolean(brandRSelect)) {
      //&& Boolean(orderThreshold)
      if (parseFloat(brandFee) >= 0 || parseFloat(brandDisc) >= 0) {
        // && parseFloat(orderThreshold) >= 0
        createBrandLimit({
          brandId: brandRSelect.value,
          // orderThreshold: parseFloat(orderThreshold),
          purchaseDiscount: parseFloat(brandDisc),
          purchaseFee: parseFloat(brandFee),
          purchaseFeeType:feeInput,
          currency:brandRSelect.value ?? "USD",
          purchaserId: id,
          minimumAmount: parseFloat(minimumAmount) || 1,
          maximumAmount: parseFloat(maximumAmount) || 100000,
          minimumQuantity: parseFloat(minimumQuantity) || 1,
          maximumQuantity: parseFloat(maximumQuantity) || 100000,
        });
        cleanFeeDisc();
        Notify(
          alert,
          "success",
          "Purchaser fee and discounts successfully added"
        );
        loaderSavingAll4()
      } else {
        Notify(
          alert,
          "danger",
          "Fee, Order threshold or discount is not an integer or decimal number"
        );
        loaderSavingAll4()
      }
    } else {
      Notify(
        alert,
        "danger",
        "Brand, Fee or discount Order threshold  is required"
      );
      loaderSavingAll4()
    }
    loaderSavingAll4()
  };


  const createBrandLimit = async (dt) => {
    await purchaserCtl.createBrandsLimits(dt, (data) => {
      
      if (data && !data.error) {
        const obj = {
          id: data.id,
          brandName: brandList[data.brandId],
          brandId: data.brandId,
          purchaserFee: data?.purchaseFeeType === "PERCENTAGE" ? data?.purchaseFee.toFixed(2) + "%" : "$ " + data.purchaseFee.toFixed(2),
          purchaserDiscount: data.purchaseDiscount.toFixed(2),
          currency: data.currency ?? "USD",
          minimumAmount: data.minimumAmount,
          maximumAmount: data.maximumAmount,
          minimumQuantity: data.minimumQuantity,
          maximumQuantity: data.maximumQuantity,
        };

        const updatedBrandsFeeDisc = brandsFeeDisc.map((item) =>
          item.brandId === obj.brandId ? obj : item
        );

        if (updatedBrandsFeeDisc.some((item) => item.brandId === obj.brandId)) {
          setBrandsFeeDisc(updatedBrandsFeeDisc);
        } else {
          setBrandsFeeDisc([...brandsFeeDisc, obj]);
        }
      }
    });
  };

  useEffect(()=>{
    if(modal === false){
      setThirdpartyId("")
      setTaxId("");
      setClientProgramNumber("");
      setCompany("");
      setContact("");
      setLineOne("");
      setLineTwo("");
      setLineThree("");
      setThirdPartyCity("");
      setPostalCodeThird("");
      setPostalExt("");
      setThirdCountryValue("")
      setThirdRegionValue("")
      setThirdRegionId("");
      setThirdCountryId("");
      setDefaultRegion("");
      setDefaultCountryThird("")
    }
  },[modal])
  const handleCountryChange = (event) => {
    const selectedCountryId = event.target.value;

    setCountryData(selectedCountryId);
  };


  const downloadFile = (data, filename) => {
    const csvData = convertToCSV(data);
    const url = window.URL.createObjectURL(new Blob([csvData]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((obj) => Object.values(obj).join(","));
    return `${header}\n${rows.join("\n")}`;
  };

  const downloadBrandLimit = async () => {
    const rowData = operativeRow.data();
    const id = rowData.id;
    await purchaserCtl.downloadBrandLimits(id, (dat) => {
      if (dat && !dat.error) {
        const name = rowData.name;
        downloadFile(dat, `${name}-${id}.csv`);
      }
    });
    Notify(alert, "success", "File Succesfully Download");
  };
  const uploadBrandLimit = async () => {
    const rowData = operativeRow.data();
    const id = rowData.id;
    await purchaserCtl.uploadBrandLimits(id, async (response) => {
      const csvData = response;
    });
  };
  const [supplierLoading, setSupplierLoading] = useState(true);
  const [purchaserIDs, setPurchaserIds] = useState("");
  const getSupplier = () => {
    setSupplierLoading(true);
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}private/backoffice/supplier/all`,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setSupplierName(data);
        setSupplierLoading(false);
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  const [supplyLoad, setSupplyLoad] = useState(true);
  const getSuppliers = (dt) => {
    const id = dt.data().id;
    setSupplyLoad(true);
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser-supplier-detail/purchaser/${id}`,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setSupplierNameData(data);
        setSupplyLoad(false);
      })
      .catch((error) => {
        console.error(`Error: ${error}`);
        setSupplyLoad(false);
      });
  };
  let supplierNameDatas = supplierName;

  useEffect(() => {
    getSupplier();
    //   getSuppliers();
  }, []);

  //   delete function

  const deleteBrandLimits = (id) => {
    let idd = id.data();
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser-supplier-detail/${idd.id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response) {
          Notify(alert, "danger", "Supplier removed successfully");
          getSuppliers(operativeRow);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  // delete function

  const handleFileRead = async (event) => {
    const content = event.target.result;
    // Process the CSV content here (e.g., parse it, send it to the server, etc.)

    const rowData = operativeRow.data();
    const id = rowData.id;
    const data = await purchaserCtl.uploadBrandLimits(
      id,
      content,
      async (response) => {
        const csvData = response;
      }
    );
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  // csv modal

  const deleteBrandLimit = async (dt) => {

    const id = dt.data().id;
    await purchaserCtl.deteleBrandsLimits(id, (data) => {
      dt.remove().draw();
      setBrandsFeeDisc(
        tableDiscFee.current.dataTable.rows().data().toArray()
      );
      Notify(
        alert,
        "success",
        "Purchaser fee and discounts succesfully removed"
      );
    });
  };

  const deleteFundLimit = async (del) =>{
    const id = del.data().id
    await purchaserCtl.deleteFundsdetails(id,(data)=> {
      del.remove().draw();
      setFundTableData(fundTable.current.dataTable.rows().data().toArray())
      Notify(alert, "success","Fund details successfully removed");
    });
   
 }

  const EditFundData = (row) =>{
    const rowData = row.data()
    const id = rowData?.id
    setFundID(id)
    toggleFund()
    setDisabled(true)
    setFundValue(rowData.funds)
    setThresholdValue(rowData.creditThreshold)
    setCreditValue(rowData.creditLimit)
    setPrepareValue(rowData.prepaidFunds)
    setCurrencyID(rowData.currencyID)
    setThreshold(rowData.lowFundAlert);
    const currency = {
      value:rowData.currencyID,
      label:rowData.currency
    }
    setDefaultCurrency(currency)
   }

  const getBrands = async (dt) => {
    const id = dt.data().id;
    setPurchaserId(id)
    await purchaserCtl.supplierAvailableBrands(id, (data) => {
      if (data && !data.error) {
        setBrandList(data.brandList);
        setBrandsPurchaser(
          Object.keys(data.brandList).map((brandId) => ({
            value: brandId,
            label: data.brandList[brandId],
          }))
        );

        const sortedBrands = data.brands.sort((a, b) => a.name.localeCompare(b.name));

        // Use a temporary object to track unique brand names
        const uniqueBrands = sortedBrands.filter((brand, index, self) =>
          index === self.findIndex((t) => (
            t.name === brand.name
          ))
        );

        setBrandSelects(
          uniqueBrands.map((purchase) => ({
            value: purchase.id,
            label: purchase.name,
          }))
        );


        purchaserCtl.getAllBrandsLimits(id, (dat) => {
          if (dat && !dat.error) {
            setBrandsFromPurchaser(dat);
            setLoaderTwo(false)
          } else {
            setBrandsFromPurchaser([]);
            setTimeout(() => {
              setLoaderTwo(false)
            }, 1500);
          }
        });
      }
    });
  };

  const getFunds = async (dat) =>{
    const id = dat.data().id;
   await purchaserCtl.getFundDetails(id,(data)=>{
        if(data && !data.error){
          setFundDetailsData(data)
        }else{
          setFundDetailsData([])
        }
      })
  }

  const brandsPurchaserClean = brandsPurchaser.filter((e) => {
    let done = true;
    for (let i = 0; i < brandsFeeDisc.length; i++) {
      if (brandsFeeDisc[i].brandId === e.value) done = false;
    }
    return done;
  });

  // Brands Fee and Discount end

  const header = [
    {
      title: "Name",
      data: "name",
      sortable: true,
      searchable: true,
      render: $.fn.dataTable.render.text(),
      renderForSelect: (data) => ({ label: data, value: data }),
    },
    {
      title: "Primary Phone No",
      data: "mainPhone",
      sortable: true,
      searchable: true,
      render: $.fn.dataTable.render.text(),
      renderForSelect: (data) => ({ label: data, value: data }),
    },
    {
      title: "Website",
      data: "website",
      sortable: true,
      searchable: true,
      render: $.fn.dataTable.render.text(),
      renderForSelect: (data) => ({ label: data, value: data }),
    },
    {
      title: "Status",
      data: "active",
      sortable: true,
      searchable: true,
      render: (data) => {
        if (data) return "Active";
        return "Disabled";
      },
      renderForSelect: (data) => ({
        label: data ? "Active" : "Disabled",
        value: data ? "Active" : "Disabled",
      }),
    },
    {
      title: 'Action',
      data: 'status',
      sortable:false,
      render: (data, _, rowData) => {
        const dropdownOptions = generateDropdownOptions(data);

        // Render the dropdown
        return `
        <div class="d-flex justify-content-center w-100">
        <div class="main_class">
        <p><span></span><span></span><span></span></p>
        
        <select onchange="{() => handleMainDropdownChange}" class="dropdown_value" style="width:20px;cursor:pointer">
         ${dropdownOptions.map((option) => (

          `<option value="${option.value}" data-action="${option.action ? option.action.name : ''}">
				  ${option.label}
				</option>`
        )).join('')}
			</select></div>
      </div>
			  
			
			  `;
      },
    },
  ];

  function setPurchasers(data) {
    setLoader(false)
    if (table.current && data && data.length > 0)
      table.current.dataTable.clear().rows.add(data).draw();
  };

  function generateDropdownOptions(data) {
    const options = [];
    options.push({
      label: 'Select an action',
      value: 'select_action',
      action: null
    });

    options.push({
      label: 'Payment and invoice',
      value: 'Payment_details',

    });
    options.push({
      label: "Brands",
      value: "brands"
    })
    options.push({
      label: "Users",
      value: "more_details",

    });
    options.push({
      label: "Edit",
      value: "edit_purchaser",
    });
    options.push({
      label: "Delete",
      value: "delete_purchaser"
    })

    return options;
  };

  const handleMainDropdownChange = (selectedValue, row) => {
    switch (selectedValue) {
      case 'Payment_details':
        addModal(row);
        break;
      case 'brands':
        onBrandNavClick();
        purchaserBrandsDetails(row)
        break;
      case 'more_details':
        prepareDetails(row);
        break;
      case 'edit_purchaser':
        prepareToEdit(row);
        break;
      case 'delete_purchaser':
        removePurchaser(row);
        break;
      default:
        break;
    }
  }


  function onRowCreated(row) {


    row.classList.add("ncentiva-datatable-row");
    row.addEventListener("click", () => {
      const thisRow = table.current.dataTable.row(row);
      if (thisRow.child.isShown()) {
        thisRow.child.hide();
      } else {
        thisRow.child.show();
      }
    });
  }

  /**
   * Method that create a purchaser oder with the cards before added
   */
  const createPurchaseOrder = () => {
    internalShoppingCartCtl.purchaseShoppingCart(name, referenceValue, (data) => {
      if(data?.status === 403){
        toggleWarning();
        return;
      }
      if (data && !data.error) {
        Notify(alert, "success", "Order Created");
      } else {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      }
    });
  };

  function onChildRow(_e, show, row) {
    if (show) {
      const rowData = row.data();
      const addressBlock = document.getElementById(`address-${rowData.id}`);
      const contactsBlock = document.getElementById(`contacts-${rowData.id}`);
      const thresholdBlock = document.getElementById(`payment-${rowData.id}`);
      if (addressBlock.dataset.loaded === "false") {
        purchaserCtl.address(rowData.id, (data) => {
          if (data && !data.error) {
            let country = countriesInfo.current.find(
              (item) => item.id === data.countryId
            );
            let billingCountry = countriesInfo.current.find(
              (item) => item.id === data.billingCoutryId
            )
            if (!billingCountry) billingCountry = { name: "No country information" }
            if (!country) country = { name: "No country information" };
            addressBlock.innerText = `Street: ${data.street}\nCity: ${data.city}\nPostal Code: ${data.postalCode}\nCountry: ${country.name}`;
            addressBlock.dataset.loaded = "true";
          } else {
            setPurchaserAddresTemp(data);
            addressBlock.innerText = `Error retrieving data: ${data.errorMessage || data.error
              }`;
          }
        });
      }
      if (contactsBlock.dataset.loaded === "false") {
        purchaserCtl.contacts(rowData.id, (data) => {
          if (data && !data.error) {
            if (data.length > 0) {
              const primary = data.find(
                (item) => item.purchaserContactTypeId === 1
              );
              if (!!primary) {
                contactsBlock.innerText = `Primary Contact: ${primary.contactFirstName} ${primary.contactLastName} \n email: ${primary.email}\nPhone: ${primary.phone}\nMobile: ${primary.mobile}`;
              } else {
                contactsBlock.innerText = `No primary contact found`;
              }
            } else {
              contactsBlock.innerText =
                "There are no contacts associated with this purchaser.";
            }
            contactsBlock.dataset.loaded = "true";
          } else {
            contactsBlock.innerText = `Contact not found`;
          }
        });
      }
      if (thresholdBlock.dataset.loaded === "false") {
        thresholdBlock.innerText = "";
        purchaserCtl.getpaymentmode(rowData.id,(data)=>{
          if(data && !data.error){
            if(data?.paymentOptionId === 2){
              purchaserCtl.getFundDetails(rowData.id, (data) => {
                if (data && !data.error) {
                  const usdDataArray = data?.filter(item => item.currencyName === "USD");
                  usdDataArray.forEach(usdData => {
                  const paymentType = paymentOptions.current.find(
                    (item) => item.id === usdData.paymentOptionId
                  );
      
                  if (paymentType) {
                    
                   if (usdData?.creditThreshold === 0) {
      
                        thresholdBlock.innerText = `Funds on Account: $${usdData?.funds?.toFixed(2).length > 5 ? usdData?.funds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                        usdData?.funds?.toFixed(2)}\nPrepaid Funds: $${(usdData?.prepaidFunds).toFixed(2).length > 5 ? (usdData?.prepaidFunds).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                            (usdData?.prepaidFunds).toFixed(2)}`;
                      } else {
      
                        thresholdBlock.innerText = `Funds on Account: $${usdData?.funds?.toFixed(2).length > 5 ? usdData?.funds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                        usdData?.funds?.toFixed(2)}\nCredit Threshold: $${usdData?.creditThreshold.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}\nPrepaid Funds: $${usdData?.prepaidFunds?.toFixed(2).length > 5 ? usdData?.prepaidFunds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                        usdData?.prepaidFunds?.toFixed(2)}\nCredit Limit: $${usdData?.creditLimit?.toFixed(2).length > 5 ? usdData?.creditLimit?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                        usdData?.creditLimit?.toFixed(2)}`;
                      }
                    
                    thresholdBlock.dataset.loaded = "true";
                    }
                  else {
                    thresholdBlock.innerText = "No payment information available";
                  }
                })
                } else {
                  const dynamicValueRegex = /Fund not found Against the purchaser (\d+)/;
                  const errorMessage = data?.errorMessage;
                  const match = errorMessage.match(dynamicValueRegex);
                   if (match && match[1]) {
                    thresholdBlock.innerText = `Funds not Active`;
                } else {
                  thresholdBlock.innerText = `Error retrieving data: ${data.errorMessage}`;
                }
                  
                }
              });
            }else{
              if(data?.paymentOptionId === 1){
                thresholdBlock.innerText = "PaymentType is Invoice"
              }else{
                thresholdBlock.innerText = "PaymentType is Credit"
              }
            }
          }
        })
       
      }

    }
  }

  function prepareToEdit(row) {
    if(accessRoles.includes("SUPPLIER_MANAGER") || accessRoles.includes("COMMERCIAL_MANAGER") || accessRoles.includes("CUSTOMER_SERVICE")) {
        toggleWarning();
        return;
      }
    const Data = row.data().id
    const name = row.data().name;
   setPurchaserName(name)
    setSendID(Data)
     toggle();
     getFunds(row)
   catalogsCtl.currencies(data => {
			if(!(data.error || data.errorMessage)){
        
        const currecyData = data?.map(item=>({
          value: item.id,
          label: item.name
        }))
				setCurrOption(currecyData)
        
			}else{
        setCurrOption([])
        
      }
		})

    purchaserCtl.getThirdPartyinfo(Data,(data)=>{
      if(data || !data.error){
        setResponseData(data)
        const item = data[0];
        setThirdpartyId(item?.id)
        setTaxId(item?.taxId );
        setClientProgramNumber(item?.clientProgramNumber );
        setCompany(item?.company );
        setContact(item?.contact );
        setLineOne(item?.line1 );
        setLineTwo(item?.line2 );
        setLineThree(item?.line3 );
        setThirdPartyCity(item?.city );
        setPostalCodeThird(item?.postalCode );
        setPostalExt(item?.postalCodeExt);
        setThirdCountryValue(item?.country)
        setThirdRegionValue(item?.region)
        setThirdRegionId(item?.regionId);
        setThirdCountryId(item?.countryId);
        const countryValue = {
          value:item?.countryId,
          label:item?.country

        }
        
        setDefaultCountryThird(countryValue)
      const regionValue = {
          value:item?.regionId,
          label:item?.region
        }
        setDefaultRegion(regionValue)
      }else{
       
      }
    })

    purchaserCtl.thirdinforCountry((data)=>{
      if(data && !data.error){
        const countryOption = data?.map(item=>({
          value:item.id,
          label:item.code
        }))
        setCurrencyOptionThird(countryOption) 
      }else{
        setCurrencyOptionThird([])
      }
    })

    if (isMounted.current) {
      setActiveOp("Edit");
      setActiveOpText("Edit the information of the purchaser.");
      setOperativeRow(row);
      getBrands(row);
      getSuppliers(row);
    }
  }

  function onDraw() {
    if (table.current) {
      table.current.dataTable
        .rows()
        .eq(0)
        .each((i) => {
          const row = table.current.dataTable.row(i);
          const rowData = row.data();
          if (rowData) {
            let child = `<div class="row">
							<div class="col-4" id="address-${rowData.id}" data-loaded="false">Loading info...</div>
							<div class="col-4" id="contacts-${rowData.id}" data-loaded="false">Loading info...</div>
							<div class="col-4" id="payment-${rowData.id}" data-loaded="false">Loading info...</div>
						</div>`;
            row.child(child).hide();
            row.child().addClass("ncentiva-datatable-child-row");
          }
        });
    }
  }

  function cancelOperation(e) {
    e.preventDefault();
    e.stopPropagation();
    if (activeOp === "Add New") {
      let hasChanges = false;
      form.current.forEach((el) => {
        if (!!el.value && el.value !== "-1") {
          hasChanges = true;
        }
      });

      if (hasChanges) {
        setShowAlertMessage(true);
      } else {
        setModal(false);
      }
    } else {
      const formHasChanges = modelChange(
        {
          ...operativeRow.data(),
          ...supplierInformation,
        },
        form.current
      );

      if (formHasChanges) {
        setShowAlertMessage(true);
      } else {
        setModal(!modal);
      }
    }
    cleanFeeDisc();
  }

  function prepareToAdd() {
  if(accessRoles.includes("ACCOUNTANT_MANAGER") || accessRoles.includes("SUPPLIER_MANAGER") 
    || accessRoles.includes("COMMERCIAL_MANAGER") || accessRoles.includes("CUSTOMER_SERVICE") || accessRoles.includes("INTERNAL_MANAGER")) {
      toggleWarning();
      return;
    }
    toggle();

    catalogsCtl.currencies(data => {
			if(!(data.error || data.errorMessage)){
        
        const currecyData = data.map(item=>({
          value: item.id,
          label: item.name
        }))
				// setCurrOption(currecyData)
			}else{
        // setCurrOption([])
      }
		})

    purchaserCtl.thirdinforCountry((data)=>{
      if(data && !data.error){
        const countryOption = data?.map(item=>({
          value:item.id,
          label:item.code
        }))
        setCurrencyOptionThird(countryOption) 
      }else{
        setCurrencyOptionThird([])
      }
    })

    if (isMounted.current) {
      setActiveOp("Add New");
      setActiveOpText(
        "Please provide the information for the purchaser you want to add."
      );
      setOperativeRow(null);
    }
  }


  const compareData = (post, get) => {
    const keys = Object.keys(post);
    for (let key of keys) {
      if (post[key] !== get[key]) {
        return true; // Data has changed
      }
    }
    return false; // No data has changed
  };
  const loadingThirdParty=()=>{
    setTimeout(()=>{
      setLoadThirdParty(false)
    },1500)
  }
  
const addThirdpartyInfo = () =>{
  setLoadThirdParty(true)
  const payload = {
    taxId,
    clientProgramNumber,
    company,
    contact,
    line1: lineOne,
    line2: lineTwo,
    line3: lineThree,
    city: thirdPartyCity,
    postalCode: postalCodeThird,
    postalCodeExt: postalExt ,
    country: thirdCountryValue,
    region: thirdRegionValue,
    purchaserId:sendID,
    regionId:thirdRegionId,
    countryId:thirdCountryId
  };

  const { purchaserId, ...payloadWithoutId } = payload;

  const allFieldsEmpty = Object.values(payloadWithoutId).every(value => value === '' || value === null || value === undefined);
  

  if (allFieldsEmpty) {
    // Notify(alert,"danger","Validation failed");
    setLoadThirdParty(false)
    } else {

      if (taxId && !/^\d{1,9}$/.test(taxId)) {
        Notify(alert,"danger","Tax Id must be 9 digits", );
        loadingThirdParty()
        return;
      }
    else  if (clientProgramNumber && !/^\d{8}$/.test(clientProgramNumber) || clientProgramNumber  == undefined) {
        Notify(alert,"danger","Client Program Number must be exactly 8 digits", );
        loadingThirdParty()
        return ;
      }

   
   else  if (thirdPartyCity && thirdPartyCity.length > 30 || thirdPartyCity == undefined) {
        Notify(alert,"danger","City must be 30 characters or less", );
        loadingThirdParty()
        return ;
      }
    else if (thirdCountryValue?.length == 0 || thirdCountryValue == undefined){
        Notify(alert,"danger","Country can not be empty and Country must be 30 characters or less")
        loadingThirdParty()
        return;
      }
      else if(thirdRegionValue?.length == 0 || thirdRegionValue == undefined){
        Notify(alert,"danger","Region can not be empty and  Must be a valid 2-character uppercase")
        loadingThirdParty()
        return;
      }   
   else  if (postalCodeThird && !/^\d{1,10}$/.test(postalCodeThird) || postalCodeThird == undefined) {
        Notify(alert,"danger","Postal Code must be a valid number and must be 10 characters or less", );
        loadingThirdParty()
        return ;
      }
    else {
      purchaserCtl.ThirdPartyInfo(payload,(data)=>{
        if(data && !data.error){
          Notify(alert,"success","Third-Party-Info is svaed successfully")
          // toggle()
          loadingThirdParty()
          }else{
          Notify(alert,"danger",data?.errorMessage)
          setErrorMessage(data?.errorMessage)
          
        }
      })
    } 
    loadingThirdParty()
  }
}

const updateThirdpartyinfo = () =>{
  setLoadThirdParty(true);
  const payload = {
    id:thirdpartyId,
    taxId,
    clientProgramNumber,
    company,
    contact,
    line1: lineOne,
    line2: lineTwo,
    line3: lineThree,
    city: thirdPartyCity,
    postalCode: postalCodeThird,
    postalCodeExt: postalExt ,
    country: thirdCountryValue,
    region: thirdRegionValue,
    purchaserId:sendID,
    regionId:thirdRegionId,
    countryId:thirdCountryId
  };

  const { purchaserId, ...payloadWithoutId } = payload;

  const allFieldsEmpty = Object.values(payloadWithoutId).every(value => value === '' || value === null || value === undefined);

  if (allFieldsEmpty) {
    // Notify(alert,"danger","Validation failed");
    } else {

      if (taxId && !/^\d{1,9}$/.test(taxId) || taxId?.length == 0) {
        Notify(alert,"danger","Tax Id must be 9 digits", );
        loadingThirdParty()
        return;
      }
    else  if (clientProgramNumber && !/^\d{8}$/.test(clientProgramNumber) || clientProgramNumber?.length == 0) {
        Notify(alert,"danger","Client Program Number must be exactly 8 digits", );
        loadingThirdParty()
        return ;
      }
 
   else  if (thirdPartyCity && thirdPartyCity.length > 30 || thirdPartyCity?.length == 0) {
        Notify(alert,"danger","City must be 30 characters or less", );
        loadingThirdParty()
        return ;
      }
     else if (thirdCountryValue?.length == 0 || thirdCountryValue == undefined){
        Notify(alert,"danger","Country can not be empty and Country must be 30 characters or less")
        loadingThirdParty()
        return;
      }
      else if(thirdRegionValue?.length == 0 || thirdRegionValue == undefined){
        Notify(alert,"danger","Region can not be empty and  Must be a valid 2-character uppercase")
        loadingThirdParty()
        return;
      } 
   else  if (postalCodeThird && !/^\d{1,10}$/.test(postalCodeThird) || postalCodeThird?.length == 0) {
        Notify(alert,"danger","Postal Code must be a valid number and must be 10 characters or less", );
        loadingThirdParty()
        return ;
      }
  
  else {
      purchaserCtl.infoUpdate(payload,(data)=>{
        if(data && !data.error){
          if (compareData(payload, responseData[0])) {
            Notify(alert, "success", "Third-Party-Info is saved successfully");
            loadingThirdParty()
          }
          // toggle()
          }else{
          Notify(alert,"danger",data?.errorMessage)
          setErrorMessage(data?.errorMessage)
        }
      })
    }  
    loadingThirdParty()
  }
}

const handleThirdPartyinfo = () =>{
  if(responseData && responseData?.length > 0){
    updateThirdpartyinfo()
  }else{
    addThirdpartyInfo()
  }
 }

 const openConfirmforSave = () => {
  toggleFinishModal();
 }
const loadingFinallySave=()=>{
  setTimeout(()=>{
    setLoadConfirmFinish(false)
  },1500)
}
  function finishOperation(e) {
    setLoadConfirmFinish(true)
    cleanFeeDisc();
    e.preventDefault();
    e.stopPropagation();

    const fv = new FormValidator(
      form.current,
      (type, message) => Notify(alert, type, message),
      [
        { label: "Purchaser Name", property: "name", required: true },
        {
          label: "Main Phone",
          property: "mainPhone",
          required: true,
          type: "phone",
        },
        { label: "Website", property: "website", required: false, type: "url" },
        {
          label: "Active Purchaser",
          property: "active",
          required: false,
          type: "check",
        },
        {
          label: "Purchase Fee",
          property: "purchaseFee",
          required: false,
          type: "n",
        },
      ]
    );

    if (!fv.isFormValid()) {
      loadingFinallySave()
      return
    };

    const av = new FormValidator(
      form.current,
      (type, message) => Notify(alert, type, message),
      [
        { label: "Street and Number", property: "street", required: true },
        { label: "City", property: "city", required: true },
        {
          label: "Postal or Zip Code",
          property: "postalCode",
          input: "zipcode",
          required: true,
        },
        {
          label: "Country",
          property: "countryId",
          required: true,
          noVal: "-1",
        },
      ]
    );
    if (!av.isFormValid()) {
      loadingFinallySave()
      return
    };


    const billingValidator = new FormValidator(
      form.current,
      (type, message) => Notify(alert, type, message),
      [

        { label: "Address", property: "billingAddress", required: true },
        { label: "City", property: "billingCity", required: true },
        {
          label: "Postal or Zip Code",
          property: "billingPostalCode",
          input: "billingPostalCode",
          required: true,
        },
        {
          label: "Country",
          property: "billingCoutryId",
          required: true,
          noVal: "-1",
        },
      ]
    );


    const FOV = new FormValidator(
      form.current,
      (type, message) => Notify(alert, type, message),
      [
        {
          label: "Payment Option",
          property: "paymentOptionId",
          input: "paymentTypeId",
          required: true,
          noVal: "-1",
        },
        {
          label: "Credit Limit",
          property: "creditLimit",
          input: "creditLimit",
          required: true,
          conditions: [
            { op: "gt", value: "0" },
            { op: "lt", value: "10000000" },
          ],
          ignoreCondition: {
            input: "paymentTypeId",
            type: "select",
            negate: true,
            value: "3",
          },
          defaultValue: "0",
        },
      ]
    );
    
    if (!FOV.isFormValid()) {
      loadingFinallySave()      
      return
    };
    

    

   
    const purchaserData = {
      ...FOV.getDTO(),
      ...fv.getDTO(),
      purchaseDiscount: 0,
      purchaseFee: 0,
    };

    const count = contactTable.current.dataTable
      .data()
      .toArray()
      .filter(
        (purchaserContactType) =>
          purchaserContactType.purchaserContactTypeId === 1
      ).length;
    if (count > 1) {
      Notify(alert, "danger", "Cannot Be More Then One Primary Contact");
      loadingFinallySave()
      return;
    }

    if (
      !contactTable.current.dataTable
        .data()
        .toArray()
        .find((item) => parseInt(item.purchaserContactTypeId) === 1)
    ) {
      Notify(
        alert,
        "danger",
        "The purchaser must have at least a Primary Contact"
      );
      loadingFinallySave()
      return;
    }
    // if(responseData.length < 1 || responseData.length === undefined){
    //   addThirdpartyInfo()
    // }
    
    switch (activeOp) {
      case "Add New":
     purchaserCtl.add(purchaserData, (data) => {
           if(data?.status === 403){
            toggleWarning();
           }
          if (data.errorMessage || data.error) {
            if(data?.error === "Server error response code: 403. Unable to parse response body."){

            }else{
              Notify(alert, "danger", data.errorMessage ?? data.error);
              loadingFinallySave()
            }
            
          } else {
            const addressInfo = av.getDTO();
            addressInfo.purchaserId = data.id;
            toggleFinishModal()
            loadingFinallySave()
            addBannedCards(data.id);
            // addThirdpartyInfo()
            if (bannEntryBrand.length > 0) {
              addEntryBannedBrand(data.id);
            }
            purchaserCtl.addAddress(addressInfo, (addressData) => {
              // if(addressData?.status === 403){
              //   toggleWarning(); 
              // }
              if (addressData.errorMessage || addressData.error) {

                if(addressData?.error === "Server error response code: 403. Unable to parse response body."){

								}else{
									Notify(alert, "danger", addressData.errorMessage ?? addressData.error);
                  loadingFinallySave()
								}
              } else {
                addressData.id = addressData.addressId;
                sendContacts(
                  contactTable.current.dataTable.data().toArray(),
                  data,
                  () => {
                    Notify(alert, "info", "Purchaser saved successfully");
                    loadingFinallySave()
                    toggle()
                    // {(errorMessage?.length) > 0 || (allFieldsEmpty) &&  toggle()}
                   }
                );
              }
            });
          }
        });
        break;

      case "Edit":
        const addressInfo = av.getDTO();
        const billingAdressinfo = billingValidator.getDTO()
        purchaserData.id = operativeRow.data().id;
        purchaserData.purchaserAddressId = purchaserAddresTemp.addressId;
        addressInfo.id = purchaserAddresTemp.addressId;
        addressInfo.addressId = purchaserAddresTemp.addressId;
        purchaserData.purchaserAddressId = parseInt(
          purchaserData.purchaserAddressId
        );
        purchaserCtl.update(purchaserData, (data) => {
          if(data?.status === 403){
            toggleWarning();
            loadingFinallySave()
          }
          if (data.errorMessage || data.error) {
            if(data?.error === "Server error response code: 403. Unable to parse response body."){

            }else{
              Notify(alert, "danger", data.errorMessage ?? data.error);
              loadingFinallySave()
            }
            
          } else {
            addressInfo.purchaserId = data.id;
            addressInfo.countryId = parseInt(addressInfo.countryId);
            addBannedCards(operativeRow.data().id);
            deleteBannedCards();
            toggleFinishModal()
            loadingFinallySave()
          //  if(responseData.length > 0 && responseData !== undefined){
          //   updateThirdpartyinfo()
          //  }
            if (bannEntryBrand.length > 0) {
              addEntryBannedBrand(operativeRow.data().id);
            }
              const operation = purchaserAddresTemp.addressId
              ? "updateAddress"
              : "addAddress";

            validateAddress(purchaserAddresTemp, addressInfo, operation, data);
            updateBillAdd(billingAdressinfo)
          }
        });
        break;

      default:
    }
  }

  const AddFundDetails = () =>{
    toggleAddFundModal()
    
    
  }

  const UpdateFundDetails = () =>{

    const uov = new FormValidator(
      form.current,
      (type,message) => Notify(alert,type,message),
      [
        {
          label: "Payment Option",
          property: "paymentOptionId",
          input: "paymentTypeId",
          required: true,
          noVal: "-1",
        },
        {
          label: "funds status",
          property: "active",
          input: "Fundstatus",
          defaultValue: true
        },
        
      ]
    )

    const fundData = uov.getDTO()
    
    let obj ={
      "funds": parseFloat(fundValue),
      "creditThreshold":parseFloat(thresholdValue),
      "prepaidFunds":parseFloat(prepareValue),
      "creditLimit":parseFloat(creditValue),
      "currencyId":currencyID,
      "purchaserId":sendID,
      "lowFundAlert":parseFloat(threshold)
    }
    Object.assign(fundData,obj)

    purchaserCtl.updateFund(fundData,fundID,(data)=>{
      if(data && !data.error){
        Notify(alert,"success","Update fund successfully")
        toggleFund();
        const updateFund = {
          purchaserName: data?.purchaserName,
          id: data?.id,
          funds: data?.funds,
          creditThreshold: data?.creditThreshold,
          currency: data?.currencyName,
          paymentOptionId: data?.paymentOptionId,
          currencyID:data?.currencyId,
          prepaidFunds: data?.prepaidFunds,
          creditLimit: data?.creditLimit,
          lowFundAlert:data?.lowFundAlert
        };
        
        const rowIndex = fundTableData.findIndex(item => item.id === data.id);

        if (rowIndex !== -1) {
          fundTableData[rowIndex] = updateFund;
    
          if (fundTable.current) {
           fundTable.current.dataTable.clear().rows.add(fundTableData).draw();
          }
        } 
      }else{
        Notify(alert,"danger",data?.errorMessage)
      }
      

    })
  }
  const loadFundsFunc=()=>{
    setTimeout(()=>{
      setLoadFunds(false)
    },1500)
  }
  const AddModalFund = () =>{
    setLoadFunds(true)
    const pov = new FormValidator(
      form.current,
      (type, message) => (Notify(alert, type, message), loadFundsFunc()),
      [
        {
          label: "Payment Option",
          property: "paymentOptionId",
          input: "paymentTypeId",
          required: true,
          noVal: "-1",
        },
        {
        label:"funds status",
        property:"active",
        input:"Fundstatus",
        defaultValue:true

        },
        
        // {
        //   label: "Funds",
        //   property: "funds",
        //   input: "fundAmount",
        //   required: true,
        //   conditions: [
        //     { op: "gt", value: "0" },
        //     { op: "lt", value: "10000000" },
        //   ],
        //   ignoreCondition: {
        //     input: "paymentTypeId",
        //     type: "select",
        //     negate: true,
        //     value: "2",
        //   },
        //   defaultValue: "0",
        // },
        // {
        //   label: "Credit Limit",
        //   property: "creditLimit",
        //   input: "creditLimit",
        //   required: true,
        //   conditions: [
        //     { op: "gt", value: "0" },
        //     { op: "lt", value: "10000000" },
        //   ],
        //   ignoreCondition: {
        //     input: "paymentTypeId",
        //     type: "select",
        //     negate: true,
        //     value: "3",
        //   },
        //   defaultValue: "0",
        // },
        // {
        //   label: "creditThreshold",
        //   property: "creditThreshold",
        //   input: "creditThreshold",
        //   required: true,
        //   conditions: [
        //     { op: "gt", value: "0" },
        //     { op: "lt", value: "10000000" },
        //   ],
        //   ignoreCondition: {
        //     input: "paymentTypeId",
        //     type: "select",
        //     negate: true,
        //     value: "4",
        //   },
        //   defaultValue: "0",
        // },
        // {
        //   label: "prepaidFunds",
        //   property: "prepaidFunds",
        //   input: "prepaidFunds",
        //   required: true,
        //   conditions: [
        //     { op: "gt", value: "0" },
        //     { op: "lt", value: "10000000" },
        //   ],
        //   ignoreCondition: {
        //     input: "paymentTypeId",
        //     type: "select",
        //     negate: true,
        //     value: "5",
        //   },
        //   defaultValue: "0",
        // },
        // {
        //    label : "currencyId",
        //    property: "currencyId",
        //    input: "currency",
        //    required: true,
        //    noVal: "-1",
        // },
      ]
    );

    
  


    // if (form.current.creditThreshold.value === "") {
    //   Notify(alert, "danger", "CreditThreshold can not be blank");
    //   return;
    // } else if (parseFloat(form.current.creditThreshold.value) < 0) {
    //   Notify(alert, "danger", "CreditThreshold can not be negative");
    //   return;
    // }


    // if (form.current.creditLimit.value === "") {
    //   Notify(alert, "danger", "Creditlimit can not be blank");
    //   return;
    // } else if (parseFloat(form.current.creditLimit.value) < 0) {
    //   Notify(alert, "danger", "CreditLimit can not be negative");
    //   return;
    // }


    // if (form.current.creditLimit.value < form.current.creditThreshold.value) {
    //   //Notify(alert, "danger", "CreditLimit can not be more than CreditThreshold");
    //   //return;
    // }

    // if (form.current.prepaidFunds.value === "") {
    //   Notify(alert, "danger", "PrepaidFunds can not be blank");
    //   return;
    // } else if (parseFloat(form.current.prepaidFunds.value) < 0) {
    //   Notify(alert, "danger", "PrepaidFunds can not be negative");
    //   return;
    // }
    const fundData = pov.getDTO()

    let obj ={
      "funds":addFundValue,
      "creditThreshold":addThresholdValue,
      "prepaidFunds":addPrepareValue,
      "creditLimit":addCreditValue,
      "currencyId":currencyID,
      "lowFundAlert":parseFloat(threshold)
    }
    Object.assign(fundData,obj)

    purchaserCtl.fundDetails(fundData,sendID,(data)=>{
      if(data && !data.error){
      Notify(alert,"success","Funds add successfully")
      loadFundsFunc()
        toggleAddFundModal()
        const newFund = {
          purchaserName: data?.purchaserName,
          funds: data?.funds,
          creditThreshold: data?.creditThreshold,
          currency: data?.currencyName,
          currencyID:data?.currencyId,
          prepaidFunds: data?.prepaidFunds,
          creditLimit: data?.creditLimit,
          lowFundAlert:data?.lowFundAlert
        };
    
        setFundTableData([...fundTableData, newFund]);
        
      }else {
        Notify(alert, "danger",data?.errorMessage)
        loadFundsFunc()
      }

    })
  }
  


  const handleStatus = () =>{
    setFundStat(!fundStat)
  }
  const updateBillAdd = (billData) => {
    purchaserCtl.updatebillingAddress(billData, purchaserId, (Bdata) => {
      // if(Bdata?.status === 403){
      //   toggleWarning();
      // }
      if (Bdata.errorMessage || Bdata.Error) {
        if(Bdata?.error === "Server error response code: 403. Unable to parse response body."){

        }else{
          Notify(alert, "danger", Bdata.errorMessage ?? Bdata.error);
        }
      } else {
        //Notify(alert, "info", "Edit Billing Address Successfully");
      }

    })
  }



  
  function validateAddress(service, form, operation, data) {
    const updateAddres =
      service.city === form.city &&
      service.postalCode === form.postalCode &&
      service.street === form.street &&
      service.countryId === form.countryId;

    if (!updateAddres) {
      purchaserCtl[operation](form, (addressData) => {
        // if(addressData?.status === 403){
        //   toggleWarning();
        // }
        if (addressData.errorMessage || addressData.error) {
          if(addressData?.error === "Server error response code: 403. Unable to parse response body."){

          }else{
            Notify(alert, "danger", addressData.errorMessage ?? addressData.error);
          }
        } else {
          sendContacts(
            contactTable.current.dataTable.data().toArray(),
            data,
            () => { }
          );
          Notify(alert, "info", "Purchaser saved successfully");
           toggle()
          // {(errorMessage?.length > 0)  || (allFieldsEmpty) &&  toggle()}
       
          
          
        }
      });
    } else {
      sendContacts(
        contactTable.current.dataTable.data().toArray(),
        data,
        () => { }
      );
      Notify(alert, "info", "Purchaser saved successfully");
      toggle()
      // {(errorMessage?.length > 0)  || (allFieldsEmpty) &&  toggle()}

    }
  }
  const handleTopUp = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setTopUp(value); 
    }
  };
  
  const depositeFundfile = () =>{
    setTimeout(() => {
      setDepositeLoader(false)
    }, 1500);
  }
  
  const fundPostData = () => {
   setDepositeLoader(true) 
    let obj = {
      "funds": topup,
      "reference": reference,
      "countryId": countryData,
      "street": address,
      "city": city,
      "postalCode": postal,
      "currencyId":currencyValue,
      "purchaserId":sendID
    }
    if (obj) {
      purchaseOrderCtl.fundDepositeAdmin(obj, (data) => {
        if(data?.status === 403){
        toggleWarning();
        depositeFundfile()
        }
        setApiDataAdd(true)
        if (data && !data.error) {
          const updatedData = {
            date: data.createdAt,
            type: data.type,
            number: data.orderNumber,
            currency: data.currency,
            reference: data.orderReference,
            status: data.status,
            amount: data.amount,
          };

          setUpdateData(updatedData)
          setTopUp("");
          setCity("");
          setPostal("");
          setReference("");
          depositeFundfile()
          Notify(alert, "success", "Fund deposite");
          setdropdownCall(false)
          toggleRegister()
        } else {
          if(data?.error === "Server error response code: 403. Unable to parse response body."){
            depositeFundfile()
          }else{
            Notify(alert, "danger", data.errorMessage ?? data.error);
            depositeFundfile()
          }
          // Notify(alert, "danger", data.errorMessage ?? data.error);
        }
      })
    }else{
      setDepositeLoader(false)
    }
  }
  function addBannedCards(id) {
    const bandsToReview = [];

    initialCardsByPurchaser.map((cardsInitial) => {
      if (cardsInitial.cards) {
        cardsInitial.cards.map((initialWithoutBand) => {
          bandsToReview.push(initialWithoutBand);
        });
      }
    });
    if (pendingBandActions.add.length > 0) {
      const brandsToBand = pendingBandActions.add.filter((banded) => {
        const initialBanned = bandsToReview.filter((initial) => {
          return initial.giftCardTypeId === banded.giftCardTypeId;
        });
        if (initialBanned.length === 0) {
          return banded;
        }
      });

      if (brandsToBand.length > 0) {
        callService(brandsToBand, 0, id);
      }
      setPendingBandActions((prev) => ({ add: [], delete: prev.delete }));
    }
  }

  function callService(brandsToBand, index, id) {
    brandsToBand[index].purchaserId = id;

    purchaserCtl.addCard(brandsToBand[index], (data) => {
      if (data.errorMessage || data.error) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        Notify(alert, "info", "Card banned saved successfully");
      }

      if (index < brandsToBand.length - 1) {
        callService(brandsToBand, index + 1, id);
      }
    });
  }

  function deleteBannedCards() {
    if (pendingBandActions.delete.length > 0) {
      pendingBandActions.delete.map((brandToDelete) => {
        purchaserCtl.removeCard(brandToDelete.id, (data) => {
          if (data.error || data.errorMessage) {
            Notify(alert, "danger", data.errorMessage ?? data.error);
          }
        });
      });
      setPendingBandActions((prev) => ({ add: prev.add, delete: [] }));
    }
  }

  function addEntryBannedBrand(id) {
    bannEntryBrand.map((band) => {
      band.purchaserId = id;
      purchaserCtl.addBrand(band, (data) => {
        if (data.error || data.errorMessage) {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        }
      });
    });
    setBannEntryBrand([]);
  }

  function sendContacts(contacts, data, done) {
    let iter = 0;
    if (contacts[iter]) {
      const saveContact = () => {
        if (contacts[iter].status === "new")
          contacts[iter].purchaserId = data.id;
        let op;

        switch (contacts[iter].status) {
          case "new":
            op = purchaserCtl.addContact.bind(purchaserCtl);
            break;
          case "edit":
            op = purchaserCtl.updateContact.bind(purchaserCtl);
            break;
          default:
            op = (data, cb) => cb(data);
        }

        op(data.id, contacts[iter], (contactData) => {
          // if(contactData?.status === 403){
          //   toggleWarning()
          // }
          if (contactData.errorMessage || contactData.error) {
            if(contactData?.error === "Server error response code: 403. Unable to parse response body."){

            }else{
              Notify(alert, "danger", contactData.errorMessage ?? contactData.error);
            }
          } else {
            if (data.purchaserContactTypeId === 1) {
            }
            if (contacts[++iter]) saveContact();
            else {
              sendBrands(
                brandTable.current.dataTable.data().toArray(),
                data,
                () => {
                  if (operativeRow) {
                    operativeRow.data(data).draw();
                  } else {
                    table.current.dataTable.row.add(data).draw();
                  }
                  done();
                }
              );
            }
          }
        });
      };
      saveContact();
    } else {
      sendBrands(brandTable.current.dataTable.data().toArray(), data, () => {
        if (operativeRow) {
          operativeRow.data(data).draw();
        } else {
          table.current.dataTable.row.add(data).draw();
        }
        done();
      });
    }
  }

  function sendSaveContacts(contacts, data, done) {
    let iter = 0;
    if (contacts[iter]) {
      const saveContact = () => {
        if (contacts[iter].status === "new")
          contacts[iter].purchaserId = data.id;
        let op;

        switch (contacts[iter].status) {
          case "new":
            op = purchaserCtl.addContact.bind(purchaserCtl);
            break;
          case "edit":
            op = purchaserCtl.updateContact.bind(purchaserCtl);
            break;
          default:
            op = (data, cb) => cb(data);
        }

        op(data, contacts[iter], (contactData) => {
          // if(contactData?.status === 403){
          //   toggleWarning()
          // }
          if (contactData.errorMessage || contactData.error) {
            if(contactData?.error === "Server error response code: 403. Unable to parse response body."){

            }else{
              Notify(alert, "danger", contactData.errorMessage ?? contactData.error);
            }
          } else {
            if (data.purchaserContactTypeId === 1) {
            }
            if (contacts[++iter]) saveContact();
            else {
              
              // sendBrands(
              //   brandTable.current.dataTable.data().toArray(),
              //   data,
              //   () => {
              //     if (operativeRow) {
              //       operativeRow.data(data).draw();
              //     } else {
              //       table.current.dataTable.row.add(data).draw();
              //     }
              //     done();
              //   }
              // );
              done();
            }

          }
        });
      };
      saveContact();
    } else {
      // sendBrands(brandTable.current.dataTable.data().toArray(), data, () => {
      //   if (operativeRow) {
      //     operativeRow.data(data).draw();
      //   } else {
      //     table.current.dataTable.row.add(data).draw();
      //   }
      //   done();
      // });
    }
  }
  function sendBrands(brands, purchaserData, done) {
    let brandIter = 0;
    if (brands[brandIter]) {
      const saveBrand = () => {
        brands[brandIter].purchaserId = purchaserData.id;
        let op;

        if (!brands[brandIter].cards) {
          if (brands[brandIter].status === "new") {
            op = purchaserCtl.addBrand.bind(purchaserCtl);

            op(brands[brandIter], (brandData) => {
              if (brandData.errorMessage || brandData.error) {
                Notify(
                  alert,
                  "danger",
                  brandData.errorMessage ?? brandData.error
                );
              } else {
                if (brands[++brandIter]) saveBrand();
                else done();
              }
            });
          } else {
            if (brands[++brandIter]) saveBrand();
            else done();
          }
        } else {
          const cardsToSend = brands[brandIter].cards;
          sendCardTypes(purchaserData, cardsToSend, () => {
            if (brands[++brandIter]) saveBrand();
            else done();
          });
        }
      };
      saveBrand();
    } else {
      done();
    }
  }

  function sendCardTypes(purchaserData, cardsToSend, done) {
    let cardIter = 0;
    if (cardsToSend[cardIter]) {
      const saveCard = () => {
        cardsToSend[cardIter].purchaserId = purchaserData.id;

        let op;

        switch (cardsToSend[cardIter].status) {
          default:
            op = (data, cb) => cb(data);
        }

        op(cardsToSend[cardIter], (cardData) => {
          if (cardData.errorMessage || cardData.error) {
            Notify(alert, "danger", cardData.errorMessage ?? cardData.error);
          } else {
            if (cardsToSend[++cardIter]) saveCard();
            else done();
          }
        });
      };
      saveCard();
    } else {
      done();
    }
  }

  function confirmDelete() {
    
    const purchaser = currentRow.data();
    purchaserCtl.remove(purchaser.id, (data) => {
      if(data?.status === 403){
        toggleWarning();
        return;
      }
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        currentRow.remove();
        toggleConfirm();
        triggerReload();
        Notify(alert, "success", "Purchaser succesfully removed");
      }
    });
  }

  function removeCardType(row) {

    
    const data = row.data();
    const { giftCardTypeId } = data;
    
    if(data?.id){
      purchaserCtl.removecardTypeBanned(data?.id,(data)=>{
        if(data && !data.error){
          Notify(alert,"success","Successfuly delete the giftcard")
          row.remove().draw();
          showPurchaserBrand()
        }else{
          Notify(alert,"danger",data?.errorMessage ?? data?.error)
        }
      })
    }

    // const newOpt = document.createElement("option");
    // newOpt.value = giftCardTypeId;
    // newOpt.text = data.productName;
    // cardTypeInput.current.add(newOpt);

    // const deleteTemporary = pendingBandActions.add.filter(
    //   (item) => item.giftCardTypeId === giftCardTypeId
    // );

    // if (deleteTemporary.length > 0) {
    //   setPendingBandActions((prev) => ({
    //     add: prev.add.filter((item) => item.giftCardTypeId !== giftCardTypeId),
    //     delete: prev.delete,
    //   }));
    // } else {
    //   let pendingToDelete = pendingBandActions.delete;
    //   pendingToDelete.push(data);
    //   setPendingBandActions((prev) => ({
    //     add: prev.add,
    //     delete: pendingToDelete,
    //   }));
    // }

   
    setShouldDeleteBand(data);
  }

  ////// API call function for get all purchaser best brand /////////////
  const purchaserBestBrand = () => {
    const rowData = operativeRow.data();
    setPurchaserIds(rowData.id)
    purchaserCtl.bestBrandsByPurchaser(rowData.id, (bannedBrandsData) => {
      if (
        bannedBrandsData &&
        !bannedBrandsData.error &&
        !bannedBrandsData.errorMessage
      ) {
        let bannedBrands = bannedBrandsData.map((brand) => ({
          id: brand.id,
          brandId: brand.brandId,
          brandName: brand?.brandName,
          supplier: brand?.supplierName === null ? "Inventory" : brand?.supplierName,
          supplierId: brand?.supplierId,
          Quantity:brand?.cumulativeQuantity,
          Value:brand?.cumulativeValue,
          time:brand?.timeLapse,
          priority:brand?.priority
        }));
        bannedBrands.forEach((brand) => {
          bestBrandTable.current.addRow(brand);
        });
      }

    });
  };

  const prepareForm = () => {
    if (form.current) {
      form.current.reset();
      Utils.FillDropdown(form.current.countryId, countries);
      Utils.FillDropdown(form.current.currency, currencies.sort((a, b) => a.name.localeCompare(b.name)), null, null, null, (cat) => cat.id);
      Utils.FillDropdown(form.current.billingCoutryId, countries);
      Utils.FillDropdown(form.current.paymentTypeId, paymentOptions.current, [
        "requiresAmount",
      ]);
      onPaymentTypeChange();

      if (activeOp === "Edit" && !!operativeRow.data) {
        const rowData = operativeRow.data();
        setSupplierInformation((prevSupplierInformation) => ({
          ...prevSupplierInformation,
          ...rowData,
        }));
        form.current.purchaserId.value = rowData.id;
        form.current.name.value = rowData.name;
        form.current.mainPhone.value = rowData.mainPhone;
        form.current.website.value = rowData.website;
        form.current.active.checked = rowData.active;
        form.current.paymentTypeId.value = rowData.paymentOptionId;
        onPaymentTypeChange();
        if (form.current.fundAmount)
          // form.current.fundAmount.value = rowData.funds;
        if (form.current.creditLimit)
          // form.current.creditLimit.value = rowData.creditLimit;
        if (form.current.creditThreshold)
          // form.current.creditThreshold.value = rowData.creditThreshold;

        if (form.current.prepaidFunds)
          // form.current.prepaidFunds.value = rowData.prepaidFunds;

        purchaserCtl.address(rowData.id, (data) => {
          if (data.errorMessage || data.error) {
            Notify(alert, "danger", data.errorMessage ?? data.error);
          } else {
            setPurchaserAddresTemp(data);
            setSupplierInformation((prevSupplierInformation) => ({
              ...prevSupplierInformation,
              ...data,
            }));
            form.current.street.value = data.street;
            form.current.city.value = data.city;
            form.current.zipcode.value = data.postalCode;
            form.current.countryId.value = data.countryId;
            form.current.purchaserAddressId.value = data.addressId;
            form.current.id.value = data.addressId;
            form.current.addressId.value = data.addresaddressId;
          }
        });

        purchaserCtl.billingaddress(rowData.id, (billingData) => {
          if (billingData.errorMessage || billingData.error) {
            // Notify(alert, "danger", billingData.errorMessage ?? billingData.error);
          } else {
            form.current.billingAddress.value = billingData.billingAddress;
            form.current.billingCity.value = billingData.billingCity;
            form.current.billingPostalCode.value = billingData.billingPostalCode;
            form.current.billingCoutryId.value = billingData.billingCoutryId;

          }
        })


        purchaserCtl.contacts(rowData.id, (data) => {
          if (data.errorMessage || data.error) {
            Notify(alert, "danger", data.errorMessage ?? data.error);
          } else {
            contactTable.current.dataTable.rows
              .add(data.map((item) => ({ ...item, status: "edit" })))
              .draw();
              setContacts(data)
          }
        });
        showPurchaserBrand();
        purchaserBestBrand();
      }
    }
  };

  const showPurchaserBrand = () => {
    const rowData = operativeRow.data();
    
    // Clear existing data before adding new data
    brandTable.current.dataTable.clear().draw();

    purchaserCtl.bannedBrandsByPurchaser(rowData.id, (bannedBrandsData) => {
        if (bannedBrandsData && !bannedBrandsData.error && !bannedBrandsData.errorMessage) {
            let bannedBrands = bannedBrandsData.map((brand) => ({
                id: brand.id,
                brandId: brand.brandId,
                name: brand.brand.name,
                cards: false,
            }));
            
            bannedBrands.forEach((brand) => {
                brandTable.current.addRow(brand);
            });
        }

        purchaserCtl.bannedCardsByPurchaser(rowData.id, (data) => {
            if (data.error || data.errorMessage) {
                Notify(alert, "danger", data.errorMessage ?? data.error);
            } else {
                let bannedCards = data.map((card) => {
                    let cardType = cardTypes.current.find(
                        (cardType) => cardType.id === card.giftCardTypeId
                    );
                    if (cardType) {
                        card.brandId = cardType.brandId ?? "brand not found";
                        return card;
                    }
                    card.brandId = "brand not found";
                    return card;
                });

                let cardBrands = brands.current.filter((brand) =>
                    bannedCards.map((card) => card.brandId).includes(brand.id)
                );

                cardBrands = cardBrands.map((brand) => {
                    brand.cards = bannedCards
                        .map((card) => (card.brandId === brand.id ? card : null))
                        .filter((card) => card !== null);
                    return brand;
                });

                cardBrands.forEach((brand) => {
                    brandTable.current.addRow({
                        brandId: brand.id,
                        name: brand.name,
                        cards: brand.cards,
                        status: "edited",
                    });
                });

                setInitialCardsByPurchaser(brandTable.current.dataTable.data().toArray());
            }
        });
    });
};

  function addContactLoader(){
    setTimeout(()=>{
      setButtonLoader(false)
    },1500)
  }

  function addContact() {
    setButtonLoader(true)
    if (!contactForm.current) return;

    const cv = new FormValidator(
      contactForm.current,
      (type, message) => Notify(alert, type, message),
      [
        {
          label: "Contact id",
          property: "id",
          input: "contactId",
          required: false,
        },
        {
          label: "Contact Type",
          property: "purchaserContactTypeId",
          input: "contactTypeId",
          required: true,
          noVal: "-1",
        },
        {
          label: "First Name",
          property: "contactFirstName",
          input: "contactFirstName",
          required: true,
        },
        {
          label: "Last Name",
          property: "contactLastName",
          input: "contactLastName",
          required: true,
        },
        {
          label: "Phone",
          property: "phone",
          input: "contactPhone",
          required: true,
          type: "phone",
        },
        {
          label: "Mobile",
          property: "mobile",
          input: "contactMobile",
          required: false,
          type: "phone",
        },
        {
          label: "Email",
          property: "email",
          input: "contactEmail",
          required: true,
          type: "email",
        },
      ]
    );

    if (!cv.isFormValid()){
      addContactLoader()
       return
      };

    const newContact = cv.getDTO();

    authCtl.checkIfUserExists(newContact.email, (data) => {
      if (data.valueOf()) {
        Notify(alert, "danger", "Email not available for this Contact");
        addContactLoader()
      } else {
        Notify(alert, "info", "Contact saved successfully");
                    
        if (!activeContact) {
          newContact.status = "new";
          newContact.userId = null;
          contactTable.current.dataTable.row.add(newContact).draw();
          contactForm.current.reset();
          setContactModal(false);
          addContactLoader()
        } else {
          if (!!activeContact.data().id) {
            newContact.status = "edit";
            newContact.id = parseInt(activeContact.data().id);
            activeContact.data(newContact).draw();
            setContactModal(false);
            addContactLoader()
          }
        }
      }
      addContactLoader()
    });
  }
  function updateContact() {
    setButtonLoader(true)
    if (!contactForm.current) return;

    const cv = new FormValidator(
      contactForm.current,
      (type, message) => Notify(alert, type, message),
      [
        {
          label: "Contact id",
          property: "id",
          input: "contactId",
          required: false,
        },
        {
          label: "Contact Type",
          property: "purchaserContactTypeId",
          input: "contactTypeId",
          required: true,
          noVal: "-1",
        },
        {
          label: "First Name",
          property: "contactFirstName",
          input: "contactFirstName",
          required: true,
        },
        {
          label: "Last Name",
          property: "contactLastName",
          input: "contactLastName",
          required: true,
        },
        {
          label: "Phone",
          property: "phone",
          input: "contactPhone",
          required: true,
          type: "phone",
        },
        {
          label: "Mobile",
          property: "mobile",
          input: "contactMobile",
          required: false,
          type: "phone",
        },
        {
          label: "Email",
          property: "email",
          input: "contactEmail",
          required: true,
          type: "email",
        },
      ]
    );

    if (!cv.isFormValid()){
      addContactLoader()
       return
      };

      const uv = new FormValidator(
        contactForm.current,
        (type, message) => Notify(alert, type, message),
        [
          {
            label: "Contact ID",
            property: "contactId",
            input: "contactId",
            required: false,
          },
          
          {
            label: "First Name",
            property: "newFirstName",
            input: "contactFirstName",
            required: true,
          },
          {
            label: "Last Name",
            property: "newLastName",
            input: "contactLastName",
            required: true,
          },
          {
            label: "Phone",
            property: "newPhone",
            input: "contactPhone",
            required: true,
            type: "phone",
          },
          
          {
            label: "Email",
            property: "newEmail",
            input: "contactEmail",
            required: true,
            type: "email",
          },
        ]
      );
   purchaserCtl.updateUserInfo(uv.getDTO(),(data)=>{
    if(data && !data.error){
      purchaserCtl.contacts(sendID, (data) => {
        if (data.error || data.errorMessage) {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        } else {
          contactTable.current.dataTable.clear().rows
          .add(data.map((item) => ({ ...item, status: "edit" })))
          .draw();
          setContacts(data);
        }
      });
    }else{

    }
   });
    const newContact = cv.getDTO();
    purchaserCtl.updateContactId(
      operativeRow.data().id,
      cv.getDTO(),
      (data) => {
        if (data.error || data.errorMessage) {
          Notify(alert, "danger", data.errorMessage);
          addContactLoader()
          // if(data.errorMessage.includes("bad syntax")){
          //   Notify(alert, "info", "Please Save The Data Before Update.");
          // }
          // else{
          //   Notify(alert, "danger", data.errorMessage);
          // }
        } else {
          Notify(alert, "info", "Contact successfully updated!!");
          addContactLoader()
          newContact.status = "edit";
          newContact.id = parseInt(activeContact.data().id);
          activeContact.data(newContact).draw();
          setContactModal(false);
        }
      }
    );
  }

  function prepareContactForm() {
    //setDisable(true)
    if (!contactForm.current) return;
    if (contactTable.current) {
      if (
        !!contactTable.current.dataTable
          .data()
          .toArray()
          .find((contact) => contact.purchaserContactTypeId === "1")
      ) {
        Utils.FillDropdown(
          contactForm.current.contactTypeId,
          contactType.filter((types) => types.id !== 1),
          null,
          null,
          "Select a contact type..."
        );
      } else {
        Utils.FillDropdown(
          contactForm.current.contactTypeId,
          contactType,
          null,
          null,
          "Select a contact type..."
        );
      }
    }

    if (activeContact) {
      if (activeContact.data().purchaserContactTypeId === 1) {
        Utils.FillDropdown(
          contactForm.current.contactTypeId,
          contactType,
          null,
          null,
          "Select a contact type..."
        );
      }
      // contactForm.current.contactEmail.disabled = true;

      authCtl.checkIfUserExists(activeContact.data().email, (data) => {
        // if(data.valueOf()){
        // 	Notify(alert, 'info', 'This contact\'s address Email is associated to a User and cannot be edited');
        // } else {
        // 	contactForm.current.contactEmail.disabled = false;
        // }
        // contactForm.current.contactEmail.disabled = false;
      });

      const d = activeContact.data();
      contactForm.current.contactTypeId.value =
        d.purchaserContactTypeId.toString();
      contactForm.current.contactFirstName.value = d.contactFirstName;
      contactForm.current.contactLastName.value = d.contactLastName;
      contactForm.current.contactPhone.value = d.phone;
      contactForm.current.contactMobile.value = d.mobile;
      contactForm.current.contactEmail.value = d.email;
      contactForm.current.contactId.value = d.id;
    }
  }

  function addBrand() {
    if (!brandForm.current) return;
if( brandForm.current.banBrand.checked === false){
  setBrandModal(false)

}else{
  const bv = new FormValidator(
    brandForm.current,
    (type, message) => Notify(alert, type, message),
    [
      {
        label: "Active",
        property: "active",
        required: false,
        defaultValue: true,
      },
      { property: "id", required: false, input: "purchaserBrandId" },
      { property: "approvalRequired", required: false, defaultValue: false },
      { property: "currency", required: false, defaultValue: "USD" },
      { property: "minimumAmount", required: false, defaultValue: 0 },
      { property: "maximumAmount", required: false, defaultValue: 0 },
      { property: "minimumQuantity", required: false, defaultValue: 0 },
      { property: "maximumQuantity", required: false, defaultValue: 0 },
      { property: "timeThreshold", required: false, defaultValue: "0" },
      { property: "purchaseDiscount", required: false, defaultValue: 0 },
      { property: "purchaseFee", required: false, defaultValue: 0 },
      { property: "minimumAmount", required: false, defaultValue: 0 },
      { property: "maximumAmount", required: false, defaultValue: 0 },
      { property: "minimumQuantity", required: false, defaultValue: 0 },
      { property: "maximumQuantity", required: false, defaultValue: 0 },
      
    ]
  );

  if (!bv.isFormValid()) return;

  if (brandSelect.current.getValue().length === 0) {
    return;
  }

  const newBrand = bv.getDTO();
  newBrand.brandId = brandSelect.current.getValue()[0].value;
  newBrand.name = brandSelect.current.getValue()[0].label;
  newBrand.cards =
    cardTypeTable.current.dataTable.data().toArray().length === 0
      ? false
      : cardTypeTable.current.dataTable.data().toArray();
  if (!newBrand.cards) {
    let newEntry = bannEntryBrand;
    newEntry.push(newBrand);
    setBannEntryBrand(newEntry);
  }
  Notify(alert, "info", "Brand saved successfully");
  setBrandOperation({});
  if (activeBrand) {
    newBrand.status = "edit";
    if (pendingBandActions.add.length > 0) {
      activeBrand.data(newBrand).draw();
    }
    setBrandModal(false);
    setActiveBrand(null);
  } else {
    newBrand.status = "new";
    brandTable.current.addRow(newBrand);
    brandForm.current.reset();
    cardTypeTable.current.dataTable.clear().draw();
    setBrandModal(false);
  }

  if (pendingBandActions.delete.length > 0) {
    const brandTableTemp = [];

    brandTable.current.dataTable
      .data()
      .toArray()
      .map((nb) => {
        const hasBrandIdCard = pendingBandActions.delete.filter(
          (pndToDelete) => pndToDelete.brandId === nb.brandId
        );
        if (hasBrandIdCard.length > 0) {
          if (nb.cards) {
            let cards = [];
            nb.cards.map((card) => {
              let deleteElemento = false;
              hasBrandIdCard.map((cardBaseToDelete) => {
                if (cardBaseToDelete.giftCardTypeId === card.giftCardTypeId) {
                  deleteElemento = true;
                }
              });
              if (!deleteElemento) {
                cards.push(card);
              }
            });

            const nbTemp = nb;
            nbTemp.cards = cards;
            brandTableTemp.push(nbTemp);
          }
        } else {
          brandTableTemp.push(nb);
        }
      });
    brandTable.current.dataTable.clear();
    brandTableTemp.map((item) => brandTable.current.addRow(item));
  }
  if(activeOp === "Edit"){
    addEntryBannedBrand(operativeRow?.data()?.id)
  }
}
   
    

    setShouldClean(true);
  }

const loaderSavingAll12=()=>{
  setTimeout(() => {
    setLoaderSave12(false);
  }, 1000);
}
  function addBestBrandFunc() {
    setLoaderSave12(true)
    if (selectedOption === null) {
      Notify(alert, "danger", "Please select a supplier");
      loaderSavingAll12()
    } else if (brandSelectedOption === null) {
      Notify(alert, "danger", "Please select a brand");
      loaderSavingAll12()
    } else if(quantityVal === null && value === null && timeLapse === ""){
      Notify(alert, "danger", "Please Enter Any one of these value Cumulative Quantity or cumulative Value or Time Lapse");
      loaderSavingAll12()
    } else if(priority === null){
      Notify(alert,"danger","Prority can not be selected");
      loaderSavingAll12()
      return;
    }else {
      if(edit){
        const timeStamp = new Date(timeLapse).getTime() 

        let body = {
          id:id,
          purchaserId: purchaserIDs,
          brandId: brandSelectedOption?.id,
          supplierId: purchaseId,
          cumulativeValue:value,
          cumulativeQuantity:quantityVal,
          timeLapse:timeStamp,
          priority:Number(priority)
        };
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
          body: JSON.stringify(body),
        };
        fetch(
          `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser-best-brand-detail/update`,
          requestOptions
        )
      .then((responseData) => responseData.json())
      .then((data) => {
           setBestBrandModal(false);
            if (data?.errorMessage) {
              Notify(alert, "danger", data?.errorMessage);
              loaderSavingAll12()
            }else if(data?.error){
              Notify(alert,"danger",data?.error)
              loaderSavingAll12()
            }else{
              loaderSavingAll12()
              Notify(alert, "info", "Brand Edit successfully");
              bestBrandTable.current.dataTable.clear();
              purchaserCtl.bestBrandsByPurchaser(purchaserIDs, (bannedBrandsData) => {
                if (
                  bannedBrandsData &&
                  !bannedBrandsData.error &&
                  !bannedBrandsData.errorMessage
                ) {
                  let bannedBrands = bannedBrandsData.map((brand) => ({
                    id: brand.id,
                    brandId: brand.brandId,
                    brandName: brand?.brandName,
                    supplier: brand?.supplierName === null ? "Inventory" : brand?.supplierName,
                    supplierId: brand?.supplierId,
                    Quantity:brand?.cumulativeQuantity,
                    Value:brand?.cumulativeValue,
                    time:brand?.timeLapse,
                    priority:brand?.priority
                  }));
  
                  // Add new rows to the cleared table
                  bannedBrands.forEach((brand) => {
                    bestBrandTable.current.addRow(brand);
                  });
                }
              });
            }
      })
      .catch((error) => {
        Notify(alert, "danger", "Something went wrong !!");
        loaderSavingAll12()
        console.error(`Error: ${error}`);
      });

      }else{
        const timeStamp = new Date(timeLapse).getTime() 

        let body = {
          purchaserId: purchaserIDs,
          brandId: brandSelectedOption?.id,
          supplierId: selectedOption?.id,
          cumulativeValue:value,
          cumulativeQuantity:quantityVal,
          timeLapse:timeStamp,
          // priority:Number(priority)
        };
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
          body: JSON.stringify(body),
        };
        fetch(
          `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser-best-brand-detail/create/${purchaserIDs}`,
          requestOptions
        )
          .then((responseData) => responseData.json())
          .then((data) => {
            setBestBrandModal(false);
            if (data?.errorMessage) {
              Notify(alert, "danger", data?.errorMessage);
              loaderSavingAll12()
            }else if(data?.error){
              Notify(alert,"danger",data?.error)
              loaderSavingAll12()
            }
            else {
  
              Notify(alert, "info", "Brand saved successfully");
              loaderSavingAll12()
              bestBrandTable.current.dataTable.clear();
              setBrandSelectedOption(null)
              setSelectedOption(null)
              // Add new rows to the table
              purchaserCtl.bestBrandsByPurchaser(purchaserIDs, (bannedBrandsData) => {
                if (
                  bannedBrandsData &&
                  !bannedBrandsData.error &&
                  !bannedBrandsData.errorMessage
                ) {
                  let bannedBrands = bannedBrandsData.map((brand) => ({
                    id: brand.id,
                    brandId: brand.brandId,
                    brandName: brand?.brandName,
                    supplier: brand?.supplierName === null ? "Inventory" : brand?.supplierName,
                    supplierId: brand?.supplierId,
                    Quantity:brand?.cumulativeQuantity,
                    Value:brand?.cumulativeValue,
                    time:brand?.timeLapse,
                    priority:brand?.priority
                  }));
  
                  // Add new rows to the cleared table
                  bannedBrands.forEach((brand) => {
                    bestBrandTable.current.addRow(brand);
                  });
                }
              });
            }
          })
          .catch((error) => {
            Notify(alert, "danger", "Something went wrong !!");
            loaderSavingAll12()
            console.error(`Error: ${error}`);
          });
      }
      }
   
  }



  const deleteBestBrandFunc = (row) => {
    let brand = row.data();
    if (brand?.id) {
      const requestOptions = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        }
      };
      fetch(
        `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser-best-brand-detail/${brand.id}`,
        requestOptions
      ).then((data) => {

        if (data.error ?? data.errorMessage) {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        } else {
          row.remove().draw();
        }
      });
    } else {
      Notify(
        alert,
        "danger",
        "Remove brand and save before attempting to delete"
      );
    }
  };



  function addCardType() {
    if (!cardTypeForm.current) return;


    const isShowing = cardTypeForm.current.style.display !== "none";
    if (!isShowing) {
      cardTypeForm.current.style.display = "block";
    } else {
      const ctv = new FormValidator(
        brandForm.current,
        (type, message) => Notify(alert, type, message),
        [
          {
            label: "Active",
            property: "active",
            required: false,
            defaultValue: true,
          },
          {
            label: "Gift card type",
            property: "giftCardTypeId",
            input: "cardTypeId",
            required: false,
            noVal: "-1",
          },
          { property: "minimumAmount", required: false, defaultValue: 0 },
          { property: "maximumAmount", required: false, defaultValue: 1 },
         
          { property: "timeThreshold", required: false, defaultValue: "0" },
          { property: "purchaseDiscount", required: false, defaultValue: 0 },
          { property: "purchaseFee", required: false, defaultValue: 0 },
         
          { property: "minimumQuantity", required: false, defaultValue: 0 },
          { property: "maximumQuantity", required: false, defaultValue: 1 },
          { property: "currencyId", required: false, defaultValue: 3 },  // Added currencyId
          { property: "countryId", required: false, defaultValue: 1 },
          
        ]
      );

      if (!ctv.isFormValid()) return;

      const newCardType = ctv.getDTO();
      
      newCardType.productName = productName
      newCardType.id = cardId
      
      newCardType.status = "new";
      newCardType.giftCardTypeId = parseInt(newCardType.giftCardTypeId);
       newCardType.purchaserId = sendID
      cardTypeTable.current.dataTable.row.add(newCardType).draw();
      
      cardTypeForm.current.style.display = "none";

      let appendAddAction = pendingBandActions.add || [];

      if(Object.keys(payload).length > 0 ){
       purchaserCtl.gifcardTypeBanned(payload,(data)=>{
        if(data && !data.error){
          Notify(alert,"success","Banned purchaser brand successfully")
          showPurchaserBrand()
        }else{
          Notify(alert,"danger",data?.errorMessage ?? data?.error)
        }
       })
      }

      if (pendingBandActions.add.length > 0) {
        const exist = false;
        pendingBandActions.add.map((im) => {
          if (im.giftCardTypeId === newCardType.giftCardTypeId) {
            exist = true;
          }
        });
        if (!exist) {
          appendAddAction.push(newCardType);
        }
      } else {
        appendAddAction.push(newCardType);
      }
      const appendDeleteAction = pendingBandActions.delete.filter(
        (del) => del.giftCardTypeId !== newCardType.giftCardTypeId
      );
      setPendingBandActions({
        add: appendAddAction,
        delete: appendDeleteAction,
      });
    }
  }

  function prepareBrandForm() {
    if (!brandForm.current) return;
    if (!brandTable.current) return;

    brandForm.current.banBrand.checked = true;

    if (!activeBrand) {
      setBrandFilter(
        brands.current
          .filter(
            (brand) =>
              !brandTable.current.dataTable
                .data()
                .toArray()
                .map((savedBrands) => parseInt(savedBrands.brandId))
                .includes(brand.id)
          )
          .map((brand) => ({ brandId: brand.id, name: brand.name }))
      );

     
    } else {
      setBrandFilter(
        brands.current.map((brand) => ({ brandId: brand.id, name: brand.name }))
      );
      
      const d = activeBrand.data();
      setBrandOperation({
        status: "edit",
        option: { value: d.brandId, label: d.name },
        brand: d,
      });

      if (d.cards) {
        brandForm.current.banBrand.checked = false;
        cardTypeTable.current.dataTable.rows
          .add(
            d.cards.map((card) => ({
              ...card,
              productName: cardTypes.current.find(
                (cardType) => cardType.id === parseInt(card.giftCardTypeId)
              ).productName,
              status: "edited",
            }))
          )
          .draw();
      } else {
        brandForm.current.banBrand.checked = true;
      }
    }
  }


  function onPaymentTypeChange() {
    const fundCtl = document.getElementById("fundCtl");
    const thresholdCtl = document.getElementById("thresholdCtl");
    const prepairCtl = document.getElementById("prepiaCtl");
    const creditCtl = document.getElementById("creditCtlOut");
    const creditFundCtl = document.getElementById("creditFundCtl");
    const CurrencyCtl = document.getElementById("CurrenctCtl")
    const table = document.getElementById("FundData");
    const AddButton = document.getElementById("addNew");
    const saveButton = document.getElementById("addSave");
   if (form.current.paymentTypeId.selectedIndex === 2) {
      setFundStat(true)
      fundCtl.style.display = "block";
      thresholdCtl.style.display = "block";
      thresholdCtl.style.marginTop = "-80px"
      prepairCtl.style.display = "block";
      // creditFundCtl.style.display = "block";
      creditCtl.style.display = "none";
      CurrencyCtl.style.display = "block"
      table.style.display = "block";
      AddButton.style.display = "block";
      saveButton.style.display = "none";
    } else if (form.current.paymentTypeId.selectedIndex === 3) {
      setFundStat(false)
      creditCtl.style.display = "block";
      prepairCtl.style.display = "none";
      // creditFundCtl.style.display = "none";
      thresholdCtl.style.display = "none";
      fundCtl.style.display = "none";
      CurrencyCtl.style.display = "none"
      table.style.display = "none";
      AddButton.style.display = "none";
      saveButton.style.display = "block";
    } else if(form.current.paymentTypeId.selectedIndex === 1){
      creditCtl.style.display = "none";
      prepairCtl.style.display = "none";
      // creditFundCtl.style.display = "none";
      thresholdCtl.style.display = "none";
      fundCtl.style.display = "none";
      CurrencyCtl.style.display = "none"
      table.style.display = "none";
      AddButton.style.display = "none";
      saveButton.style.display = "block"
    }else {
      setFundStat(false)
      creditCtl.style.display = "none";
      prepairCtl.style.display = "none";
      // creditFundCtl.style.display = "none";
      thresholdCtl.style.display = "none";
      fundCtl.style.display = "none";
      CurrencyCtl.style.display = "none"
      table.style.display = "none";
      AddButton.style.display = "none";
      saveButton.style.display = "none"
    }
  }

  const handleCurrencyChnage = (options) =>{
    const currencyoptions = options?.value
    setCurrencyID(currencyoptions)
  }

  const validateFile = (e) => {
    e.preventDefault();
    Papa.parse(e.target.files[0], {
      download: true,
      header: true,
      complete: (result) => {
        if (result.data.length) {
          setIsEmpty(false);
          setFundsFile(e.target.files[0]);
        } else {
          setIsEmpty(true);
        }
      },
    });
  };

  const uploadFile = () => {
    if (isEmpty) {
      Notify(alert, "danger", "File is Empty");
      return;
    } else {
      if (fundsFile) {
        const formData = new FormData();
        formData.append("file", fundsFile, fundsFile.name);
        purchaserCtl.uploadFundsFile(formData, (data) => {
          if (data) {
            if (data.error || data.errorMessage) {
              Notify(alert, "danger", data.errorMessage ?? data.error);
            } else {
              Notify(alert, "success", "File succesfully uploaded");
              setFundsFile(null);
              toggleUpdateFunds();
            }
          } else {
            Notify(alert, "danger", "Something went wrong");
          }
        });
      }
    }
  };

  function toggleNavbar(e) {
    e.preventDefault();
    switch (e.target.id) {
      case "contacts-navlink":
        setBrandsNav(false);
        setUsersNav(false);
        setNotificationNav(false);
        setContactNav(true);
        setCustomeMail([]);
        break;

      // case "brands-navlink":
      //   setContactNav(false);
      //   setUsersNav(false);
      //   setNotificationNav(false);
      //   setBrandsNav(true);
      //   setCustomeMail([]);

      //   break;

      case "users-navlink":
        setContactNav(false);
        setBrandsNav(false);
        setNotificationNav(false);
        setUsersNav(true);
        setCustomeMail([]);

        break;

      case "payment-navlink":
        setContactNav(false);
        setBrandsNav(false);
        setUsersNav(false);
        setNotificationNav(false);
        setCustomeMail([]);

        break;

      case "notification-navlink":
        setContactNav(false);
        setBrandsNav(false);
        setUsersNav(false);
        setNotificationNav(true);
        break;

      case "notifications-navlink":
        setContactNav(false);
        setBrandsNav(false);
        setUsersNav(false);
        setNotificationNav(false);
        setCustomeMail([]);

        break;

      default:
        setBrandsNav(false);
        setUsersNav(false);
        setNotificationNav(false);
        setContactNav(true);
        setCustomeMail([]);

        break;
    }
  }

  function toggleInvoceNavber(e) {
    e.preventDefault();
    switch (e.target.id) {
      case "paymenti-nvoice-navlink":
        setPaymentNav(true);
        setInvoiceNav(false);
        break;

      case "invoice-navlink":
        setPaymentNav(false);
        setInvoiceNav(true)

        break;

      default:
        setPaymentNav(true);
        setInvoiceNav(false);
    }
  }


  const purchaserBrandsDetails = (row) => {

    const purchaser = row.data();
    setPurchaserToManage(purchaser);
    getBrands(row);
    purchaserCtl.contacts(purchaser.id, (data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        setContacts(data);
      }
    });
  };
  const prepareDetails = (row) => {

    const purchaser = row.data();
    setPurchaserToManage(purchaser);
    toggleDetails();
    getBrands(row);
    purchaserCtl.contacts(purchaser.id, (data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        setContacts(data);
      }
    });
  };

  const addModal = (row) => {
    const purchaser = row.data();
    const purchaserId = purchaser.id
    setSendID(purchaserId)

    purchaserCtl.payment(purchaserId, (data) => {
      // toggleInvoice();
      setInvoiceModal(true)
      if (data.error || data.errorMessage) {

      } else {
        setPayment(data)
      }
    })

    purchaserCtl.invoice(purchaser.id, (data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        setInvoiceData(data)
      }
    })

    purchaseOrderCtl.purchaserBillingaddress(purchaserId, (data) => {
      if (data.errorMessage || data.error) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        setAddress(data.billingAddress);
        setCity(data.billingCity);

        // Assuming data.countryId is a string

        const countryIdGet = data.billingCoutryId

        setCountryData(countryIdGet);

        setPostal(data.billingPostalCode);
      }
    });

  }



  ////////////////////////////////////////////
  const allNotificationContact = (row) => {
    const purchaser = row.data();
    setPurchaserToManage(purchaser);
    toggleDetails();
    getBrands(row);
    purchaserCtl.allNotificationContact(purchaser.id, (data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        setContacts(data);
      }
    });
  };
  ////////////////////////////////////////////

  const handleFeeBrandChange = (e) => {
    setBrandRSelect(e);

    const rowData = operativeRow.data();
    const id = rowData.id;
    supplierCtl.bestRateForPurchaserBrand(id, e.value, (data) => {
      if (data.error || data.errorMessage) {
        setbestSupplier("Not Available");
      } else {
        let currency = currencies.find(
         //(currency) => data.currencyId === currency.id
          (currency) => data.currency === currency.code
        );
        const currencyFormat = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: currency?.code ?? "USD",
        });
        let supplier = data?.supplierName ?? "Not Available";
        let fee = data?.purchaseFee ?? 0;
        let discount = data?.purchaseDiscount ?? 0;
        setbestSupplier(
          `${supplier}: Discount ${Utils.percentFormat(
            discount / 100
          )} - Fee ${currencyFormat.format(fee)}`
        );
      }
    });
  };

  const handleFeeBrandChangeThreshold = (event) =>{
   setBrandValue(event)
   setBrandSelectThreshold(event.value)
   const rowData = operativeRow.data();
   const id = rowData.id;
   supplierCtl.bestRateForPurchaserBrand(id, event.value, (data) => {
     if (data.error || data.errorMessage) {
      
       } else {
       
       setPassCurrency(data?.currency)
      }
   });
   

  }

  const removePurchaser = (row) => {
    setCurrentRow(row)
    setOperativeRow(row);
    toggleConfirm();
  };

  const preparePurchaseOrder = (e) => {
    e.preventDefault();
    if(accessRoles.includes("ACCOUNTANT_MANAGER") ||  accessRoles.includes("COMMERCIAL_MANAGER") || accessRoles.includes("CUSTOMER_SERVICE")) {
      toggleWarning();
      return;
    }
    setname(`PCSR-PO-${+new Date()}`);
    toggleCreatePurchaseOrder();
  };

  const removeBrand = (row) => {
    let brand = row.data();
  
   if(brand?.cards){
   Notify(alert,"danger","Click on modify icon and then you can delete the cardtypes individualy")
   return;
   }
    
    if (brand?.id) {
      purchaserCtl.removeBrand(brand.id, (data) => {
        if (data.error ?? data.errorMessage) {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        } else {
          row.remove().draw();
        }
      });
    } else {
      Notify(
        alert,
        "danger",
        "Remove cards from brand and save before attempting to delete"
      );
    }
  };

  useEffect(() => {
    isMounted.current = true;
    purchaserCtl.all(setPurchasers);
    catalogsCtl.countries((data) => {
      if (data && !data.error) {
        if (isMounted.current) setCountries(data);
        data.forEach((item) => {
          countriesInfo.current.push(item);
        });
        if (form.current) {
          const tempVal = form.current.countryId.value;
          Utils.FillDropdown(form.current.countryId, countriesInfo.current);
          form.current.countryId.value = tempVal;

          const tembilVal = form.current.billingCoutryId.value;
          Utils.FillDropdown(form.current.billingCoutryId, countriesInfo.current);
          form.current.billingCoutryId.value = tembilVal;
        }
      } else {
        Notify(alert, "danger", data.error);
      }
    });
    purchaserCtl.contactTypes((data) => {
      if (data && !data.error) {
        if (isMounted.current) setContactType(data);
      } else {
        Notify(alert, "danger", data.error);
      }
    });
    brandsCtl.all((data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        brands.current = data.result ?? [];
        const brandOptions = data?.result.map((brand) =>({ value: brand.id, label: brand.name })).sort((a, b) => a.label.localeCompare(b.label)); 
        // setBrandOption(brandOptions)
      }
    });
    brandsCtl.purchaseAll((data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
       
        const brandOptions = data?.map((brand) =>({ value: brand.id, label: brand.name }))
        setBrandOption(brandOptions)
      }
    });
    cardTypeCtl.all((data) => (cardTypes.current = data));

    catalogsCtl.paymentOptions((data) => {
      paymentOptions.current = data;
    });

    return () => (isMounted.current = false);
  }, [reload, brandsCtl, cardTypeCtl, catalogsCtl, purchaserCtl]);

  const modelChange = (initial, endModel) => {
    let changed = false;
    Object.entries(initial).forEach(([key, value]) => {
      if (endModel[mapKeys[key]] && value !== endModel[mapKeys[key]].value) {
        changed = true;
        return;
      }
    });
    //changed = changed || orderThreshold || brandDisc || brandFee || brandRSelect
    // changed = changed || orderThreshold || brandDisc || brandFee || brandRSelect || minimumAmount || maximumAmount || minimumQuantity || maximumQuantity
    changed =
      changed ||
      brandDisc ||
      brandFee ||
      brandRSelect ||
      minimumAmount ||
      maximumAmount ||
      minimumQuantity ||
      maximumQuantity;
    return changed;
  };

  const leaveAllModal = () => {
    setShowAlertMessage(false);
    setModal(false);
    setContacts([])
  };

  const buttonProps = !accessRoles.includes("ACCOUNTANT_MANAGER")
    ? {
      addEditButton: { callback: prepareToEdit, viewMode: false },
      addRemoveButton: { callback: removePurchaser, viewMode: false },
    }
    : null;

  useEffect(() => {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }, []);

  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setFileCsv(event.target.files[0]);
  };

  const handleCancelFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Clear the input field value
    }
  };

  const handleFileUpload = async (event) => {
    event.preventDefault();
    const rowData = operativeRow.data();
    const id = rowData.id;
    const formData = new FormData();
    formData.append("file", selectedFile);

    const datas = await purchaserCtl.uploadBrandLimits(id, formData, (res) => {
      setIsProcessing(true);
      if (selectedFile === null) {
        Notify(alert, "danger", "please upload a file");
        setIsProcessing(false);
        return false;
      } else if (res === undefined) {
        Notify(alert, "danger", "please upload a file");
        setIsProcessing(false);
        return false;
      } else if (res.status === false) {
        Notify(alert, "danger", res.message);
        setIsProcessing(false);
        return false;
      } else if (res.status === true) {
        setUpload(!upload);
        //Notify(alert, 'success', 'File Succesfully Uploaded')
        Notify(alert, "success", res.message);
        purchaserCtl.getAllBrandsLimits(id, (dat) => {
          if (dat && !dat.error) {
            setBrandsFromPurchaser(dat);
          } else {
            setBrandsFromPurchaser([]);
          }
        });
        setIsProcessing(false);
        setFileCsv(null);
        setSelectedFile(null);
      }
    });
  };

  const suppliers = supplierName?.map((brand) => ({
    value: brand.name,
    label: brand.name,
    id: brand.id,
  }));

  const suppliersTwo = supplierName?.map((brand) => ({
    value: brand.name,
    label: brand.name,
    id: brand.id,
  }));

  const firstSupplier = {
    value: "Select All",
    label: "Select All",
    id: 159,
  };
  // const inventorySupplier ={
  //   value:"Inventory",
  //   label:"Inventory",
  //   id: 0,
  //   val: purchaserIDs
  // }

  if (suppliers) {
    suppliers.unshift(firstSupplier);
   
  }
  // if(suppliersTwo){
  //   suppliersTwo.unshift(inventorySupplier); 
  // }

  const [selvalue, setSelValue] = useState("");
  const [supplierID, setSupplierID] = useState("");
  const supplierChange = (val, operation) => {
    switch (operation.action) {
      case "select-option":
        setSupplierID(val.id);
        setSelValue(val.value);
        break;
      case "clear":
        setSelValue(null);
        setSupplierID(null);
        break;
      default:
    }
  };


const loaderSavingAll6 = () => {
  setTimeout(() => {
    setLoaderSave6(false);
  }, 1500);
};

  const createPurchaserSupplierDetail = () => {
    setLoaderSave6(true)
    let url;
    const rowData = operativeRow.data();
    const id = rowData.id;
    const requestBody = {
      supplierId: supplierID,
      purchaserId: id,
    };
    if (selvalue === "Select All") {
      url = `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser-supplier-detail/addAll/${id}`;
    } else {
      url = `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser-supplier-detail/create/${id}`;
    }

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }
        setSupplyLoad(true);
        return response.json();
      })
      .then((responseData) => {

        setPurchaserIds(responseData.purchaserId);
        getSuppliers(operativeRow);
        setSupplierModal(false);
      })
      .catch((error) => {
        console.error(`Error: ${error}`);
        loaderSavingAll6()
      });
    Notify(alert, "success", "Supplier successfully added");
    loaderSavingAll6();
  };

  /*  
  function to select Email for notification tab
      */

  const [selectMail, setSelectMail] = useState("");

  const onDatataClickFunc = (row) => {
    setSelectMail(row);
  };

  /*  
     function to Apply with select API Email  for notification tab
         */
  const [customeEmail, setCustomeMail] = useState([]);
  const [contactsList, setContactsList] = useState([]);
  const contactListApiCall = () => {
    if(purchaserToManage?.id){
      purchaserCtl.purchaserNotificationList(purchaserToManage?.id, (data) => {
        if (data.error || data.errorMessage) {
          // Notify(alert, 'danger', data.errorMessage ?? data.error);
        } else {
          // let arr = data?.filter((e) => e?.customEmail == false);
          let arr2 = data?.filter((e) => e?.customEmail == true);
          setContactsList(data);
          setCustomeMail(arr2);
        }
      });
    }
    
  };


  useEffect(() => {
    catalogsCtl.countries((data) => {
      if (data && !data.error) {
        setCountry(data);
      } else {
        Notify(alert, "danger", data.error);
      }
    });
  }, [])

  useEffect(() => {
    contactListApiCall();
  }, [notificationNav]);



useEffect(() => {
  const notificationsObject = {};
  contactsList.forEach(item => {
    const { email, purchaserId, cardDelivery, orderConfirmation, proformaInvoice, orderInvoice } = item;
    // setId(purchaserId);

    // Define custom names for each notification type
    const names = {
      cardDelivery: 'cardDelivery',
      orderConfirmation: 'orderConfirmation',
      proformaInvoice: 'proformaInvoice',
      orderInvoice: 'orderInvoice'
    };

    // Initialize arrays for each notification type if they don't exist
    if (!notificationsObject[names.cardDelivery]) {
      notificationsObject[names.cardDelivery] = [];
    }
    if (!notificationsObject[names.orderConfirmation]) {
      notificationsObject[names.orderConfirmation] = [];
    }
    if (!notificationsObject[names.proformaInvoice]) {
      notificationsObject[names.proformaInvoice] = [];
    }
    if (!notificationsObject[names.orderInvoice]) {
      notificationsObject[names.orderInvoice] = [];
    }

    // Push email and value object to the respective notification type array
    if (cardDelivery) {
      notificationsObject[names.cardDelivery].push({ email, value: cardDelivery });
    }
    if (orderConfirmation) {
      notificationsObject[names.orderConfirmation].push({ email, value: orderConfirmation });
    }
    if (proformaInvoice) {
      notificationsObject[names.proformaInvoice].push({ email, value: proformaInvoice });
    }
    if (orderInvoice) {
      notificationsObject[names.orderInvoice].push({ email, value: orderInvoice });
    }
  });
  setSelectedRadio(notificationsObject);
}, [contactsList]);




  const onApplyByMailFunc = () => {
    setLoaderSave14(true)
    // my state for the selected radio per row.
    let body = {
      ...selectedRadio,
      purchaserId : purchaserId
      
    }
    purchaserCtl.allnotification(body, (data) => {
      if(data?.status ===  403){
        toggleWarning();
        setTimeout(()=>{
          setLoaderSave14(false);
        }, 1500)
        return;
      }
      if (data && !data.error) {
      Notify(alert, "success", "Notification Send successfully")
      setTimeout(()=>{
        setLoaderSave14(false);
      }, 1500)
      } else {
        Notify(alert, "danger", data.error)
        setTimeout(()=>{
          setLoaderSave14(false);
        }, 1500)
      }
    })
  };

  const onclickModal = () => {
    setIsOpen(!isOpen);
    setSelectMail("");
  };

  /* 
on submit custome Email API call function
  */
  const [error, setError] = useState("");
  const onSubmitButton = (e) => {
    if(selectMail === "" ||  selectMail === undefined){
      setError("Please provide Email");
      return;
    }
    setLoaderSave13(true);
    let mail = /\S+@\S+\.\S+/.test(selectMail);
    if (!mail) {
      setError("Email is invalid");
      setTimeout(()=>{
        setLoaderSave13(false);
      }, 1500)
    } else {
      setError(null);

      fetch(
        `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser/enable/customEmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            customEmail: true,
            email: selectMail,
            purchaserId: purchaserToManage?.id,
          }),
        }

      )
        .then((responseData) => {
          contactListApiCall()
          onclickModal();
          Notify(alert, "success", "Email added succesfully!!");
          setTimeout(()=>{
            setLoaderSave13(false);
          }, 1500)
          // toggleDetails();
        })
        .catch((error) => {
          Notify(alert, "danger", "Something went wrong !!");
          setTimeout(()=>{
            setLoaderSave13(false);
          }, 1500)
        });
    }
  };


  const handleOrderSelectChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    if (selectedOptions.length === 0) {
      tableDiscFee.current.dataTable.clear().rows.add(brandsFeeDisc).draw();
      return;
    }
    const filteredRows = brandsFeeDisc.filter((row) => {
      return selectedOptions.some((option) => {
        return String(row.brandName) === String(option.label);
      });
    });
    setFilteredData(filteredRows);
    if (filteredRows) {
      tableDiscFee.current.dataTable.clear().rows.add(filteredRows).draw();
    }
  };


  /* 
on delete custome Email API call function
  */

  const onDeleteEmailButton = (mail) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser/deleteCustomEmail/${purchaserToManage?.id}/${customeEmail[0]?.email}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      }
    )
      .then((responseData) => {
        setShowEmail(false);
        setError(null);
        setCustomeMail([]);
        Notify(alert, "success", "Email deleted succesfully!!");
        // onclickModal();
        // toggleDetails();
      })
      .catch((error) => {
        Notify(alert, "danger", "Something went wrong !!");
      });
  };
  const [cardDelivery, setCardDelivary] = useState(false);
  const [orderConfirmation, setOrderConfirmation] = useState(false);
  const [proFormaInvoice, setProForaInvoice] = useState(false);
  const [orderInvoice, setOrderInvoice] = useState(false);
  const [isAddressInfoOpen, setIsAddressInfoOpen] = useState(false);
  const [isBillingAddressInfoOpen, setIsBillingAddressInfoOpen] = useState(false);
  const [isThirdPartyInfoOpen,setIsThirdPartyInfoOpen] =useState(false)
  const [isPaymentOptions,setIsPaymentOptions]= useState(false)
  const [isContactInfoOpen,setIsContactInfoOpen]= useState(false)
    const [isSupplierOpen,setIsSupplierOpen]= useState(false)
    const[isBannedBrandInfo,setIsBannedBrandInfoOpen]= useState(false)
     const[isInventoryBannedBrandInfo,setIsInventoryBannedBrandInfoOpen]= useState(false);
     const [isInventoryWhiteListInfo,setIsInventoryWhiteListInfo] = useState(false)
     const [isOrderThreshold,setIsOrderThreshold] = useState(false)
      const[isSupplierPriorityOpen,setIsSupplierPriorityOpen]= useState(false)
  const[isPurchaserFeesOpen,setIsPurchaserFeesOpen]= useState(false)

  const handleRadioChange = (e) => {
    setCardDelivary(e.target.checked)
  }

  const handleOrderRadio = (e) => {
    setOrderConfirmation(e.target.checked)
  }

  const handleProfoRadio = (e) => {
    setProForaInvoice(e.target.checked)
  }

  const handleOrderInvoice = (e) => {
    setOrderInvoice(e.target.checked)
  }

  /* Third Party Information */


 const handleCountry = (options) =>{
  setDefaultCountryThird(options)
  const optionsValue = options?.label
  const optionId = options?.value
  setThirdCountryValue(optionsValue)
  setThirdCountryId(optionId)
  if(optionId && optionId > 0){
    purchaserCtl.thirdinforegion(optionId,(data)=>{
      if (data && !data.error){
       const regionoptions = data?.map(item=>({
        value:item?.id,
        label:item?.code
       }))
       setRegionOption(regionoptions)
      }else{
        setRegionOption([]);
      }
    })
  }

 }

const handleRegionChnage = (selectOptions) =>{
  setDefaultRegion(selectOptions)
  const regionValue = selectOptions?.label
  const regionId = selectOptions?.value
  setThirdRegionValue(regionValue)
  setThirdRegionId(regionId)

}

const EditThirdInfo = () =>{

}

const deleteThirdInfo = () =>{

}

const deleteContact = (row) =>{
  purchaserCtl.disableUser(sendID, row.data().id, (data) => {
    if (data && !data.error) {
        row.remove().draw();
        setContacts(contactTable.current.dataTable.rows().data().toArray())
              Notify(alert,"success","Contact delete successfully")
    } else {
      Notify(alert, 'danger', data.errorMessage);
    }
  });

}

useEffect(()=>{
  if(sendID){
    purchaserCtl.getInverntoryBrands(sendID,(data)=>{
    if(data && !data?.status){
     
      setInventoryData(data)
    }
    })
  }

},[sendID])

useEffect(()=>{
  if(sendID){
    purchaserCtl.getInventoryBrandsWhite(sendID,(data)=>{
      if(data && !data?.status){
        setInventoryWhiteData(data)
      }
    })
  }

},[sendID])

useEffect(()=>{
if(sendID){
  purchaserCtl.getOrderThreshold(sendID,(data)=>{
    if(data && !data.error){
      setOrderThresData(data)
    }
  })
}
},[sendID])

useEffect(()=>{
  setBrandData(
    inventoryData.map((i)=>({
     brandName:i.brandName,
     id:i.id,
     brandId:i.brandId,
     refid:i.referenceIdsAsString
    }))
  )

},[inventoryData])

useEffect(()=>{
  setWhiteBrandData(
    inventoryWhiteData.map((i)=>({
     brandName:i.brandName,
     id:i.id,
     brandId:i.brandId,
     refid:i.referenceIdsAsString
    }))
  )

},[inventoryWhiteData])

useEffect(()=>{
  
setGetThresholdData(
  orderThresData.map((i)=>({
    id:i?.id,
    maximumQuantity:i?.maximumQuantity,
    minimumQuantity:i?.minimumQuantity,
    maximumAmount:i?.maximumAmount,
    minimumAmount:i?.minimumAmount
  }))
)
},[orderThresData])

useEffect(()=>{
  if(inventoryBrandTable.current){
    inventoryBrandTable.current.dataTable.clear().rows.add(brandData).draw();
   }
},[brandData])

useEffect(()=>{
if(inventoryWhiteBrandTable.current){
  inventoryWhiteBrandTable.current.dataTable.clear().rows.add(whiteBrandData).draw()
}
},[whiteBrandData])


useEffect(()=>{
if(orderThresholdTable.current){
  orderThresholdTable.current.dataTable.clear().rows.add(getThresholdData).draw()
}
},[getThresholdData])

const handleBrandSelect = (selectOption) =>{
  setBrandDataTwo(selectOption)
  const optionId = selectOption?.value;
  const optionValue = selectOption?.label;
  setBrandId(optionId);
  setBrandName(optionValue);
  purchaserCtl.orderReferenceId(optionId,(data)=>{
    if(data && !data.error){
      const referenceOptions = data.map((id) => ({
        value: id,
        label: id,
      })).sort((a, b) => a.label.localeCompare(b.label)); 

      setRefOption(referenceOptions)
    }
  })
}

const handleWhiteBrandSelect = (selectOption) =>{
  setBrandDataWhiteTwo(selectOption)
  const optionId = selectOption?.value;
  const optionValue = selectOption?.label;
  setBrandIdTwo(optionId);
  setBrandNameTwo(optionValue);
  purchaserCtl.orderReferenceId(optionId,(data)=>{
    if(data && !data.error){
      const referenceOptions = data.map((id) => ({
        value: id,
        label: id,
      }));

      setRefOption(referenceOptions)
    }
  })
}

const handleRefSelect = (option) =>{
  if (!option) return; 
  if (Array.isArray(option)) {
    // Multi-select mode: handle multiple selected options
    const selectedIds = option.map((opt) => opt.value); 
    const selectedLabels = option.map((opt) => opt.label); 
    setRefID(selectedIds);
    setRefLabel(selectedLabels);
  } else {
    
    const refID = option.value; 
    const refLabel = option.label; 
    setRefID(refID);
    setRefLabel(refLabel);
  }

}
const handleRefWhiteSelect = (option) =>{
  if (!option) return; 
  if (Array.isArray(option)) {
    // Multi-select mode: handle multiple selected options
    const selectedIds = option.map((opt) => opt.value); 
    const selectedLabels = option.map((opt) => opt.label); 
    setRefIDTwo(selectedIds);
    } else {
    const refID = option.value; 
    const refLabel = option.label; 
    setRefIDTwo(refID);
    
  }

}

const handleRefSelectEdit = (option) =>{
  if (!option) return; 
  setSelectedRefIds(option)
  if (Array.isArray(option)) {
    // Multi-select mode: handle multiple selected options
    const selectedIds = option.map((opt) => opt.value); 
    const selectedLabels = option.map((opt) => opt.label); 
    setRefID(selectedIds);
    setRefLabel(selectedLabels);
  } else {
    
    const refID = option.value; 
    const refLabel = option.label; 
    setRefID(refID);
    setRefLabel(refLabel);
  }

}

const handleRefWhiteSelectEdit = (option) =>{
  if (!option) return; 
  setSelectedWhiteRefIds(option)
  if (Array.isArray(option)) {
    // Multi-select mode: handle multiple selected options
    const selectedIds = option.map((opt) => opt.value); 
    const selectedLabels = option.map((opt) => opt.label); 
    setRefIDTwo(selectedIds);
    } else {
    const refID = option.value; 
    const refLabel = option.label; 
    setRefIDTwo(refID);
    
  }

}
  const loaderSavingAll7=()=>{
    setTimeout(() => {
      setLoaderSave7(false);
    }, 1000);
  }

const handleInventoryBrand = () =>{
  setLoaderSave7(true)
  let inventoryObj = {
    brandId:brandId,
    purchaserId:sendID,
    brandName:brandName,
    purchaserName:purchaserName,
    referenceIds:refID

  }

  if (!refID) {
    delete inventoryObj.referenceIds;
  }
  if(inventoryObj){
    purchaserCtl.InventoryBrand(inventoryObj,(data)=>{
       if(data && !data.error){
        Notify(alert,"success","Add Brands Successfully")
        loaderSavingAll7()
        const brand ={
          brandName:data?.brandName,
          id:data?.id,
          brandId:data?.brandId,
          refid:data?.referenceIdsAsString
        }
        const updatedBrandData = [...brandData, brand];
        setBrandData(updatedBrandData);
        toggleInventoryBrand();
        if (inventoryBrandTable.current) {
          inventoryBrandTable.current.dataTable.clear().rows.add(updatedBrandData).draw();
          loaderSavingAll7()
        }
       }else{
        Notify(alert,"danger",data?.errorMessage)
        loaderSavingAll7()
       }
    })
  }
}

const loaderSavingAll9=()=>{
  setTimeout(() => {
    setLoaderSave9(false);
  }, 1500);
}

const handleInventoryWhiteBrand = () =>{
  setLoaderSave9(true)
  let inventoryObj = {
    brandId:brandIdTwo,
    purchaserId:sendID,
    brandName:brandNameTwo,
    purchaserName:purchaserName,
    referenceIds:refIDTwo

  }

  if (!refIDTwo) {
    delete inventoryObj.referenceIds;
  }
  if(inventoryObj){
    purchaserCtl.InventoryWhiteBrand(inventoryObj,(data)=>{
       if(data && !data.error){
        Notify(alert,"success","Add Brands Successfully")
        loaderSavingAll9()
        const brand ={
          brandName:data?.brandName,
          id:data?.id,
          brandId:data?.brandId,
          refid:data?.referenceIdsAsString
        }
        const updatedBrandData = [...whiteBrandData, brand];
        setWhiteBrandData(updatedBrandData);
        toggleInventoryWhite();
        if (inventoryWhiteBrandTable.current) {
          inventoryWhiteBrandTable.current.dataTable.clear().rows.add(updatedBrandData).draw();
          loaderSavingAll9()
        }
       }else{
        Notify(alert,"danger",data?.errorMessage)
        loaderSavingAll9()
       }
    })
  }
}

const loaderSavingAll8=()=>{
  setTimeout(() => {
    setLoaderSave8(false);
  }, 1500);
}
const handleInventoryBrandEdit = () =>{
  setLoaderSave8(true)
  let inventoryObj = {
    id:rowId,
    brandId:brandId,
    purchaserId:sendID,
    brandName:inventoryBrandName,
    purchaserName:purchaserName,
    referenceIds:refID

  }

  if (!refID) {
    delete inventoryObj.referenceIds;
  }
  if(inventoryObj){
    purchaserCtl.InventoryBrandEdit(inventoryObj,(data)=>{
       if(data && !data.error){
        Notify(alert,"success","Add Brands Successfully")
        loaderSavingAll8()
        toggleInventoryBrandEdit();
        const brand ={
          brandName:data?.brandName,
          id:data?.id,
          brandId:data?.brandId,
          refid:data?.referenceIdsAsString
        }
        const updatedData = brandData.map((item) =>
          item.id === data.id ? brand : item
        );
  
        setBrandData(updatedData);
  
        // Update the table directly after state change
        if (inventoryBrandTable.current) {
          inventoryBrandTable.current.dataTable.clear().rows.add(updatedData).draw();
            loaderSavingAll8()
        }
        
        setRefID('')
        
       }else{
        Notify(alert,"danger",data?.errorMessage)
        loaderSavingAll8()
       }
    })
  }
}
const loaderSavingAll10=()=>{
  setTimeout(() => {
    setLoaderSave10(false);
  }, 1500);
}
const handleInventoryWhiteBrandEdit = () =>{
  setLoaderSave10(true)
  let inventoryObj = {
    id:rowIdWhite,
    brandId:brandIdTwo,
    purchaserId:sendID,
    brandName:inventoryWhiteBrandName,
    purchaserName:purchaserName,
    referenceIds:refIDTwo

  }

  if (!refIDTwo) {
    delete inventoryObj.referenceIds;
  }
  if(inventoryObj){
    purchaserCtl.InventoryWhiteBrandEdit(inventoryObj,(data)=>{
       if(data && !data.error){
        Notify(alert,"success","Add Brands Successfully")
        loaderSavingAll10()
        toggleInventoryWhiteEdit();
        const brand ={
          brandName:data?.brandName,
          id:data?.id,
          brandId:data?.brandId,
          refid:data?.referenceIdsAsString
        }
        const updatedData = brandData.map((item) =>
          item.id === data.id ? brand : item
        );
  
        setWhiteBrandData(updatedData);
  
        // Update the table directly after state change
        if (inventoryWhiteBrandTable.current) {
          inventoryWhiteBrandTable.current.dataTable.clear().rows.add(updatedData).draw();
          loaderSavingAll10()
        }
        
        setRefIDTwo('')
        
       }else{
        Notify(alert,"danger",data?.errorMessage)
        loaderSavingAll10()
       }
    })
  }
}

const removeInventoryBrand = (row) =>{
  
  const id = row.data().id
   purchaserCtl.deleteBrandInventory(id,(data)=>{
    if(data && !data.error){
      row.remove().draw();
      setBrandData(inventoryBrandTable.current.dataTable.rows().data().toArray())
      Notify(alert,"success","Brand delete successfully")
    }
   })
}

const removeInventoryWhiteBrand = (row) =>{
  
  const id = row.data().id
   purchaserCtl.deleteWhiteBrandInventory(id,(data)=>{
    if(data && !data.error){
      row.remove().draw();
      setWhiteBrandData(inventoryWhiteBrandTable.current.dataTable.rows().data().toArray())
      Notify(alert,"success","Brand delete successfully")
    }
   })
}
  const editInventoryBrand = (row) =>{
    setBrandDiabled(true)
    toggleInventoryBrandEdit()
    const rowid = row.data().id
    setRowId(rowid)
    setInventoryBrandName(row?.data().brandName)
    const id = row.data().brandId
    const brandoption ={
      value:row.data().brandId,
      label:row.data().brandName
    }

    const refIdsString = row.data().refid; // e.g., "Prepaid Ref 1,Prepaid Ref 2"
  const refIdArray = refIdsString ? refIdsString.split(",") : []; // Convert to array

  const referenceOptions = refIdArray.map((id) => ({
    value: id.trim(), 
    label: id.trim(), 
  }));

  setSelectedRefIds(referenceOptions)
    setBrandDataTwo(brandoption)
    purchaserCtl.orderReferenceId(id,(data)=>{
      if(data && !data.error){
        const referenceOptions = data.map((id) => ({
          value: id,
          label: id,
        }));
  
        setRefOption(referenceOptions)
      }
    })



  }
  const editInventoryWhiteBrand = (row) =>{
    toggleInventoryWhiteEdit()
    const rowid = row.data().id
    setRowIdWhite(rowid)
    setInventoryWhiteBrandName(row?.data().brandName)
    const id = row.data().brandId
    const brandoption ={
      value:row.data().brandId,
      label:row.data().brandName
    }

    const refIdsString = row.data().refid; // e.g., "Prepaid Ref 1,Prepaid Ref 2"
  const refIdArray = refIdsString ? refIdsString.split(",") : []; // Convert to array

  const referenceOptions = refIdArray.map((id) => ({
    value: id.trim(), 
    label: id.trim(), 
  }));

  setSelectedWhiteRefIds(referenceOptions)
  setBrandDataWhiteTwo(brandoption)
    purchaserCtl.orderReferenceId(id,(data)=>{
      if(data && !data.error){
        const referenceOptions = data.map((id) => ({
          value: id,
          label: id,
        }));
  
        setRefOption(referenceOptions)
      }
    })



  }


  const handleOpenAddressInfo=(e)=>{
    e.preventDefault();
    setIsAddressInfoOpen(!isAddressInfoOpen)
    
  }
  const handleBillingAddressInfo=(e)=>{
      e.preventDefault();
      setIsBillingAddressInfoOpen(!isBillingAddressInfoOpen)
  }
  const thirdPartyInfo=(e)=>{
      e.preventDefault();
      setIsThirdPartyInfoOpen(!isThirdPartyInfoOpen)
  }
  const handlePaymentOptions=(e)=>{
    e.preventDefault();
    setIsPaymentOptions(!isPaymentOptions)
  }
    const handleContactInfo=(e)=>{
      e.preventDefault();
    setIsContactInfoOpen(!isContactInfoOpen)
    }
    const supplier=(e)=>{
      e.preventDefault();
      setIsSupplierOpen(!isSupplierOpen)
      }
  const handlePurchaseBannedBrandInfo=(e)=>{
    e.preventDefault();
   setIsBannedBrandInfoOpen(!isBannedBrandInfo)
  }
   const handleInventoryBannedBrandInfo=(e)=>{
    e.preventDefault();
    setIsInventoryBannedBrandInfoOpen(!isInventoryBannedBrandInfo)
    }

    const handleInventoryWhiteListInfo = (e)=>{
      e.preventDefault();
      setIsInventoryWhiteListInfo(!isInventoryWhiteListInfo)
    }
     const handleSupplierBrandPriority=(e)=>{
      e.preventDefault();
      setIsSupplierPriorityOpen(!isSupplierPriorityOpen)
      }
      const handlePurchaserFeesAndDiscounts=(e)=>{
        e.preventDefault();
        setIsPurchaserFeesOpen(!isPurchaserFeesOpen)
       }

       const handleOrderThreshold = (e) =>{
        e.preventDefault();
        setIsOrderThreshold(!isOrderThreshold)
       }
       const generalInformation = ()=>{
        toggleEditFinishModal();
       }

       const orderInformation = () =>{
        toggleOrderThreshold()
       }
       const loaderSavingAll=()=>{
        setTimeout(()=>{
          setLoaderSave(false)
        },1500)
       }
       const saveInformation = () =>{
        setLoaderSave(true)
        const fv = new FormValidator(
          form.current,
          (type, message) => Notify(alert, type, message),
          [
            { label: "Purchaser Name", property: "name", required: true },
            {
              label: "Main Phone",
              property: "mainPhone",
              required: true,
              type: "phone",
            },
            { label: "Website", property: "website", required: false, type: "url" },
            {
              label: "Active Purchaser",
              property: "active",
              required: false,
              type: "check",
            },
            {
              label: "Purchase Fee",
              property: "purchaseFee",
              required: false,
              type: "n",
            },
          ]
        );
    
        if (!fv.isFormValid()){
          loaderSavingAll();
          return
        };
        const FOV = new FormValidator(
          form.current,
          (type, message) => Notify(alert, type, message),
          [
            {
              label: "Payment Option",
              property: "paymentOptionId",
              input: "paymentTypeId",
              required: true,
              noVal: "-1",
            },
            {
              label: "Credit Limit",
              property: "creditLimit",
              input: "creditLimit",
              required: true,
              conditions: [
                { op: "gt", value: "0" },
                { op: "lt", value: "10000000" },
              ],
              ignoreCondition: {
                input: "paymentTypeId",
                type: "select",
                negate: true,
                value: "3",
              },
              defaultValue: "0",
            },
          ]
        );
        
        if (!FOV.isFormValid()) {
          loaderSavingAll();
          return
        }
        
        const purchaserData = {
          ...FOV.getDTO(),
          ...fv.getDTO(),
          purchaseDiscount: 0,
          purchaseFee: 0,
        };

        purchaserData.id = operativeRow.data().id;
        purchaserData.purchaserAddressId = purchaserAddresTemp.addressId;
        purchaserData.purchaserAddressId = parseInt(
          purchaserData.purchaserAddressId
        );
       purchaserCtl.update(purchaserData, (data) => {
           if(data?.status === 403){
            toggleWarning();
           }
          if (data.errorMessage || data.error) {
            if(data?.error === "Server error response code: 403. Unable to parse response body."){

            }else{
              Notify(alert, "danger", data.errorMessage ?? data.error);
              loaderSavingAll()
            }
            
          }else{
            Notify(alert, "success", "General information added successfully");
            loaderSavingAll()
            toggleEditFinishModal();
          }
        })

       }
       const loaderSavingAll1=()=>{
        setTimeout(()=>{
          setLoaderSave1(false)
        },1500)
       }
       const purchaserAdress = () =>{
        toggleAdressFinishModal();
       }
       const saveAddress = () =>{
        setLoaderSave1(true)
        const av = new FormValidator(
          form.current,
          (type, message) => Notify(alert, type, message),
          [
            { label: "Street and Number", property: "street", required: true },
            { label: "City", property: "city", required: true },
            {
              label: "Postal or Zip Code",
              property: "postalCode",
              input: "zipcode",
              required: true,
            },
            {
              label: "Country",
              property: "countryId",
              required: true,
              noVal: "-1",
            },
          ]
        );
        if (!av.isFormValid()) {
          loaderSavingAll1();
          return
        };
        const addressInfo = av.getDTO();
        addressInfo.id = purchaserAddresTemp.addressId;
        addressInfo.addressId = purchaserAddresTemp.addressId;
        addressInfo.purchaserId = operativeRow?.data()?.id;
        addressInfo.countryId = parseInt(addressInfo.countryId);

        const updateAddres =
        purchaserAddresTemp.city === addressInfo.city &&
        purchaserAddresTemp.postalCode === addressInfo.postalCode &&
        purchaserAddresTemp.street === addressInfo.street &&
        purchaserAddresTemp.countryId === addressInfo.countryId;

      const operation = purchaserAddresTemp.addressId
      ? "updateAddress"
      : "addAddress";


      if (!updateAddres) {
        purchaserCtl[operation](addressInfo, (addressData) => {
          // if(addressData?.status === 403){
          //   toggleWarning();
          // }
          if (addressData.errorMessage || addressData.error) {
            if(addressData?.error === "Server error response code: 403. Unable to parse response body."){
  
            }else{
              Notify(alert, "danger", addressData.errorMessage ?? addressData.error);
              loaderSavingAll1()
            }
          } else {
            
            Notify(alert, "info", "Purchaser saved successfully");
            loaderSavingAll1()
            toggleAdressFinishModal()
            // {(errorMessage?.length > 0)  || (allFieldsEmpty) &&  toggle()}
         
            
            
          }
        });
      }
      loaderSavingAll1()

       }
       const loaderSavingAll2=()=>{
        setTimeout(()=>{
          setLoaderSave2(false)
        },1500)
       }
       const purchaseBilling = () =>{
        toggleBillingFinishModal();
       }

       const saveBillingAdress = () =>{
        setLoaderSave2(true)
        const billingValidator = new FormValidator(
          form.current,
          (type, message) => Notify(alert, type, message),
          [
    
            { label: "Address", property: "billingAddress", required: true },
            { label: "City", property: "billingCity", required: true },
            {
              label: "Postal or Zip Code",
              property: "billingPostalCode",
              input: "billingPostalCode",
              required: true,
            },
            {
              label: "Country",
              property: "billingCoutryId",
              required: true,
              noVal: "-1",
            },
          ]
        );

        const billingAdressinfo = billingValidator.getDTO()

        purchaserCtl.updatebillingAddress(billingAdressinfo, purchaserId, (Bdata) => {
          // if(Bdata?.status === 403){
          //   toggleWarning();
          // }
          if (Bdata.errorMessage || Bdata.Error) {
            if(Bdata?.error === "Server error response code: 403. Unable to parse response body."){
    
            }else{
              Notify(alert, "danger", Bdata.errorMessage ?? Bdata.error);
              loaderSavingAll2()
            }
          } else {
            Notify(alert, "success", "Edit Billing Address Successfully");
            loaderSavingAll2()
            toggleBillingFinishModal();
          }
    
        })
        loaderSavingAll2()
        
       }

       const paymentOption = () =>{
        togglepaymentoptins()
       }

       const loaderSavingAll3=()=>{
        setTimeout(()=>{
          setLoaderSave3(false)
        },1500)
       }
      const savePayment = () =>{
      setLoaderSave3(true)
      const fv = new FormValidator(
        form.current,
        (type, message) => Notify(alert, type, message),
        [
          { label: "Purchaser Name", property: "name", required: true },
          {
            label: "Main Phone",
            property: "mainPhone",
            required: true,
            type: "phone",
          },
          { label: "Website", property: "website", required: false, type: "url" },
          {
            label: "Active Purchaser",
            property: "active",
            required: false,
            type: "check",
          },
          {
            label: "Purchase Fee",
            property: "purchaseFee",
            required: false,
            type: "n",
          },
        ]
      );
  
      if (!fv.isFormValid()) {
        loaderSavingAll3();
        return};
      const FOV = new FormValidator(
        form.current,
        (type, message) => Notify(alert, type, message),
        [
          {
            label: "Payment Option",
            property: "paymentOptionId",
            input: "paymentTypeId",
            required: true,
            noVal: "-1",
          },
          {
            label: "Credit Limit",
            property: "creditLimit",
            input: "creditLimit",
            required: true,
            conditions: [
              { op: "gt", value: "0" },
              { op: "lt", value: "10000000" },
            ],
            ignoreCondition: {
              input: "paymentTypeId",
              type: "select",
              negate: true,
              value: "3",
            },
            defaultValue: "0",
          },
        ]
      );
      
      if (!FOV.isFormValid()) {
        loaderSavingAll3();
        return};
      
      const purchaserData = {
        ...FOV.getDTO(),
        ...fv.getDTO(),
        purchaseDiscount: 0,
        purchaseFee: 0,
      };

      purchaserData.id = operativeRow.data().id;
      purchaserData.purchaserAddressId = purchaserAddresTemp.addressId;
      purchaserData.purchaserAddressId = parseInt(
        purchaserData.purchaserAddressId
      );
     purchaserCtl.update(purchaserData, (data) => {
         if(data?.status === 403){
          toggleWarning();
          loaderSavingAll3()
         }
        if (data.errorMessage || data.error) {
          if(data?.error === "Server error response code: 403. Unable to parse response body."){

          }else{
            Notify(alert, "danger", data.errorMessage ?? data.error);
            loaderSavingAll3()
          }
          
        }else{
          Notify(alert, "success", "Payment option change successfully");
          togglepaymentoptins();
          loaderSavingAll3()
        }
      })
      loaderSavingAll3()
     }

   const contactinformation = () =>{
      toggleContactFinishModal();
     }
     const loaderSavingAll5=()=>{
      setTimeout(()=>{
        setLoaderSave5(false)
      },1500)
     }
    const saveContacts = () =>{
      setLoaderSave5(true)
      const count = contactTable.current.dataTable
      .data()
      .toArray()
      .filter(
        (purchaserContactType) =>
          purchaserContactType.purchaserContactTypeId === 1
      ).length;
    if (count > 1) {
      Notify(alert, "danger", "Cannot Be More Then One Primary Contact");
      loaderSavingAll5()
      return;
    }
    sendSaveContacts(
        contactTable.current.dataTable.data().toArray(),
        sendID,
        () => {
          Notify(alert, "info", "Purchaser saved successfully");
          loaderSavingAll5()
          toggleContactFinishModal()
          // {(errorMessage?.length) > 0 || (allFieldsEmpty) &&  toggle()}
         }
      );
      loaderSavingAll5()
    }

    const loaderSavingAll11=()=>{
      setTimeout(()=>{
        setLoaderSave11(false)
      },1500)
     }
    const saveOrderThreshold = () =>{
    setLoaderSave11(true)
    if(minimumAmountOrder < 0 || minimumAmountOrder == 0 ){
     Notify(alert,"warning","maximumAmount can not be negative or 0");
     loaderSavingAll11()
     toggleOrderThreshold()
      return;
     }

     if(maximumAmountOrder < 0 || maximumAmountOrder == 0 ){
      Notify(alert,"warning","maximumAmount can not be negative or 0");
      loaderSavingAll11()
      toggleOrderThreshold()
      return;
     }
     if(minimumQuantityOrder < 0 || minimumQuantityOrder == 0 ){
      Notify(alert,"warning","maximumAmount can not be negative or 0");
      loaderSavingAll11()
      return;
     }
     if(maximumQuantityOrder < 0 || maximumQuantityOrder == 0 ){
      Notify(alert,"warning","maximumAmount can not be negative or 0");
      loaderSavingAll11()
      toggleOrderThreshold()
      return;
     }

    let body = {
      purchaserId: sendID,
      // brandId: brandSelectThreshold,
      // currency:passCurrency,
      minimumQuantity:minimumQuantityOrder,
      maximumQuantity:maximumQuantityOrder,
      minimumAmount:minimumAmountOrder,
      maximumAmount:maximumAmountOrder

    }

    purchaserCtl.createOrderThreshold(body,(data)=>{
      if(data && !data.error){
        Notify(alert,"success","Order threshold created")
        loaderSavingAll11()
         const orderData = {
          id:data?.id,
          
          maximumQuantity:data?.maximumQuantity,
          minimumQuantity:data?.minimumQuantity,
          maximumAmount:data?.maximumAmount,
          minimumAmount:data?.minimumAmount
         }
         setGetThresholdData([orderData]);
       toggleOrderThreshold();
      }else{
        Notify(alert,"danger",data?.errorMessage ?? data?.error)
        loaderSavingAll11()
        toggleOrderThreshold();
      }
    })
     
    }

    const removethresholdBrand = (row) =>{
   
      
      const id = row.data().id
      purchaserCtl.deleteOrderThreshold(id,(data)=>{
       if(data && !data.error){
         row.remove().draw();
         setGetThresholdData(orderThresholdTable.current.dataTable.rows().data().toArray())
         Notify(alert,"success","Brand delete successfully")
       }
      })
    }

    useEffect(()=>{
      if(activeOp === "Add New"){
        setIsAddressInfoOpen(true);
        setIsBillingAddressInfoOpen(true);
        setIsThirdPartyInfoOpen(true);
        setIsPaymentOptions(true);
        setIsContactInfoOpen(true);
        setIsBannedBrandInfoOpen(true);
        setIsInventoryBannedBrandInfoOpen(true);
      }

    },[activeOp,sendID])

    const modifyCredit = () =>{
     toggleCreditThreshold()
    }

    const handleCreditType = (value) =>{
       setCreditType(value)
    }

   

    const showNewThreshold = (e) => {
      const value = e.target.value;
      setUpdateCreditValue(value)
      const numericValue = Number(value);
      const numericThresholdValue = Number(thresholdValue);
    if(creditType === "Deduct"  && thresholdValue === 0){
      Notify(alert,"danger","You can not deduct from 0");
      return;
    }
    
      if (creditType === "Add") {
        setNewValue(numericValue ? numericValue + numericThresholdValue : ""); 
      }

      if (creditType === "Deduct") {
        setNewValue(numericValue ? numericThresholdValue - numericValue : ""); 
      }
    };
    
    const saveUpdatedThreshold = () =>{
    const uov = new FormValidator(
        form.current,
        (type,message) => Notify(alert,type,message),
        [
          {
            label: "Payment Option",
            property: "paymentOptionId",
            input: "paymentTypeId",
            required: true,
            noVal: "-1",
          },
          {
            label: "funds status",
            property: "active",
            input: "Fundstatus",
            defaultValue: true
          },
          
        ]
      )
  
      const fundData = uov.getDTO()
      
      let obj ={
        "funds": parseFloat(fundValue),
        "creditThreshold":parseFloat(thresholdValue),
        "prepaidFunds":parseFloat(prepareValue),
        "creditLimit":parseFloat(creditValue),
        "currencyId":currencyID,
        "purchaserId":sendID,
        "lowFundAlert":parseFloat(threshold),
        ...(creditType === "Add" ? { "addAmount": Number(updateCreditValue) } : { "removeAmount": Number(updateCreditValue) })
      }
      Object.assign(fundData,obj)

      purchaserCtl.newUpdateFunds(fundData,fundID,(data)=>{
        if(data && !data.error){
          Notify(alert,"success","Crdit Threshold update successfully")
          toggleCreditThreshold();
          toggleFund();
          purchaserCtl.getFundDetails(sendID,(data)=>{
            if(data && !data.error){
              setFundDetailsData(data)
              setUpdateCreditValue('');
              setNewValue('')
            }
          })
        }else{
          Notify(alert,"danger",data?.errorMessage ?? data.error)
        }
      })
     
      
    }

   const handleRegisterClsoe = () =>{
    setTopUp("");
    setReference("");
    toggleRegister()
    setdropdownCall(false)
    }

    // const editSupplierBrandPriority = (row) =>{
    //   const rowData = row?.data()
    //  setQuantityVal(rowData?.Quantity)
    //   setValue(rowData?.Value);
    //   const timestamp = rowData?.time;
    //    const formattedDate = new Date(timestamp).toISOString().split("T")[0];
    //   setTimeLapse(formattedDate)
    //   setPriority(rowData?.priority)
    //   setEdit(true);
    //   setId(rowData?.id)
    //   setBestBrandModal(true);
    //   setPurchaseId(rowData?.supplierId)
    //   const brand = {
    //     value : rowData?.brandName,
    //     label: rowData?.brandName,
    //     id:rowData?.brandId
    //   }
    //   setBrandSelectedOption(brand)

    //   const supplier = {
    //     value: rowData?.supplier,
    //     label: rowData?.supplier,
    //     id: rowData?.supplierId
    //   }
    //   setSelectedOption(supplier) 
      
    // }


    const handleFeeChange = (value) =>{
      setFeeInput(value)
    }

  return (
    <>
      <NotificationAlert ref={alert} />
      <ConfirmationAlert
        stayModal={stayModal}
        openModal={showAlertMessage}
        leaveModal={leaveAllModal}
      />
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="d-flex justify-content-between">
                <Row>
                      <CardTitle tag="h5">Ncentiva Platform Purchaser Management</CardTitle>
                </Row>
                <Row className="justify-content-end">
                  {/* {!accessRoles.includes("ACCOUNTANT_MANAGER") ? ( */}
                    <>
                      <Col md="auto" className={"align-content text-right"}>
                        <MotionButton
                          initial={{ x: "-500%", opacity: 0 }}
                          animate={{
                            x: 0,
                            opacity: 1,
                            transition: { delay: 0.4, duration: 0.5 },
                          }}
                          // color="primary"
                          onClick={prepareToAdd}
                          className="purchaser_view btn btn-primaryTwo"
                        >
                          <i className="fas fa-plus" /> Add new purchaser
                        </MotionButton>
                      </Col>
                      <Col md="auto" className={"align-content text-right"}>
                        <MotionButton
                          initial={{ x: "-500%", opacity: 0 }}
                          animate={{
                            x: 0,
                            opacity: 1,
                            transition: { delay: 0.4, duration: 0.5 },
                          }}
                          // color="primary"
                          onClick={togglePurchaseOrders}
                          className="purchaser_view btn btn-primaryTwo"
                        >
                          <i className="fas fa-folder-open" /> View order
                          History
                        </MotionButton>
                      </Col>
                      <Col md="auto" className={"align-content text-right"}>
                        <MotionButton
                          initial={{ x: "-500%", opacity: 0 }}
                          animate={{
                            x: 0,
                            opacity: 1,
                            transition: { delay: 0.4, duration: 0.5 },
                          }}
                          // color="primary"
                          onClick={preparePurchaseOrder}
                          className="purchaser_view btn btn-primaryTwo"
                        
                        >
                          <i className="fas fa-shopping-cart"/> Create purchase
                          order
                        </MotionButton>
                      </Col>
                    </>
               
                  {/* {![
                    "SYSTEM_MANAGER",
                    "INTERNAL_MANAGER",
                    "INTERNAL",
                    "COMMERCIAL_MANAGER",
                  ].some((role) => accessRoles.includes(role)) ? (
                    <Col md="auto" className={"align-content text-right"}>
                      <MotionButton
                        initial={{ x: "-500%", opacity: 0 }}
                        animate={{
                          x: 0,
                          opacity: 1,
                          transition: { delay: 0.4, duration: 0.5 },
                        }}
                        color="primary"
                        onClick={toggleUpdateFunds}
                      >
                        <i className="fas fa-upload" /> Update Funds
                      </MotionButton>
                    </Col>
                  ) : null} */}
                </Row>
              </CardHeader>
              <CardBody>
                <br />
                {loader ? 
								<div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
							:	
                <div className="data_table">
                <DataTable
                  ref={table}
                  columns={header}
                  className={"purchaser_class"}
                  data={null}
                  options={{
                    dom: "tip",
                    createdRow: onRowCreated,
                    drawCallback: onDraw,
                    saveState: true,
                    lengthMenu: [
                      [20, 25, 50, -1],
                      [20, 25, 50, "All"],
                    ],
                    saveState: false,
                   
                  }}
                  onChildRowChange={onChildRow}
                  enableSelectFilters={true}
                  addmaindropdown={[{ callback: handleMainDropdownChange, selector: 'select.dropdown_value' }]}
                />
                </div>
               }
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ModalHistorySKU
          modalHistory={modalHistory}
          toggleModalHistory={toggleModalHistory}
          token={token}
        />
        <Modal
          isOpen={modal}
          toggle={toggle}
          onClosed={() => {
            cleanFeeDisc();
            cleanTemporaryBanedCards();
            setContacts([])
          }}
          backdrop="static"
          centered={true}
          size="xxlg"
          style={{ maxWidth: "80% !important" }}
          onOpened={prepareForm}
        >
          <ModalHeader toggle={cancelOperation} className="custom_header_colourTwo">
            {activeOp} Purchaser
          </ModalHeader>

          <ModalBody>
            <Form innerRef={form}>
              <p className="card-just-text">{activeOpText}</p>
              <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-1 d-flex align-items-center">
                General Purchaser Information
              </h6>
              <Input
                type="hidden"
                name="purchaserId"
                id="purchaserId"
                value=""
              />
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="name">Purchaser Name<span className="required-asterisk">*</span></Label>
                    <Input
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Name of the company"
                      maxLength="70"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="mainPhone">Main Phone<span className="required-asterisk">*</span></Label>
                    <Input
                      type="tel"
                      name="mainPhone"
                      id="mainPhone"
                      placeholder="Company's main phone number"
                      maxLength="14"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="website">Website<span className="required-asterisk">*</span></Label>
                    <Input
                      type="url"
                      name="website"
                      id="website"
                      placeholder="Company website address"
                      maxLength="250"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="active">
                      Is purchaser active in the platform?
                    </Label>
                    <CustomInput
                      id="active"
                      name="active"
                      type="switch"
                      label="Active Purchaser"
                    />
                  </FormGroup>
                </Col>
               
              </Row>
              {
                activeOp === "Add New" ? null
                :
              
              <Row>
              <Col md={12} className="d-flex justify-content-end">
                <Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={generalInformation}>Save </Button>
                </Col>
              </Row>
              }
           
              <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo cursor-pointer d-flex align-items-center py-1" onClick={activeOp === "Add New" ? null : handleOpenAddressInfo}>
              {activeOp !== "Add New" && (
          <>
            <i
              className={
                  isAddressInfoOpen
                      ? "fas fa-chevron-up"
                      : "fas fa-chevron-down"
              }
          />
          &nbsp;&nbsp;
      </>
    )}Purchaser Address Information
              </h6>
               <Collapse isOpen={isAddressInfoOpen}>
               <Input
                type="hidden"
                name="purchaserAddressId"
                id="purchaserAddressId"
                value=""
              />
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="street">Street and Number<span className="required-asterisk">*</span></Label>
                    <Input
                      type="text"
                      name="street"
                      id="street"
                      placeholder="Street name, number and internal number"
                      maxLength="70"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="city">City<span className="required-asterisk">*</span></Label>
                    <Input
                      type="text"
                      name="city"
                      id="city"
                      placeholder="City"
                      maxLength="50"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="zipcode">Postal or Zip Code<span className="required-asterisk">*</span></Label>
                    <Input
                      type="text"
                      name="zipcode"
                      id="zipcode"
                      placeholder="Zip Code"
                      maxLength="7"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="countryId">Country<span className="required-asterisk">*</span></Label>
                    <Input type="select" name="countryId" id="countryId">
                      <option value="-1">Select a country</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              {
                activeOp === "Add New" ? null 

                : 
               <Row>
              <Col md={12} className="d-flex justify-content-end">
                <Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={purchaserAdress}>Save</Button>
                </Col>
              </Row>}
               </Collapse>
             
               
          
             

              <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo d-flex align-items-center py-1" onClick={activeOp === "Add New" ? null : handleBillingAddressInfo}>
              {activeOp !== "Add New" && (
                  <>
                      <i
                          className={
                              isBillingAddressInfoOpen
                                  ? "fas fa-chevron-up"
                                  : "fas fa-chevron-down"
                          }
                      />
                      &nbsp;&nbsp;
                  </>
              )}
              Purchaser Billing Address Information
              </h6>
             <Collapse isOpen={isBillingAddressInfoOpen}>
 {/* <Input
                type="hidden"
                name="purchaserAddressId"
                id="purchaserAddressId"
                value=""
              /> */}


          <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="billingAddress">Address</Label>
                    <Input
                      type="text"
                      name="billingAddress"
                      id="billingAddress"
                      placeholder="Home Address"
                      maxLength="70"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="billingCity">City</Label>
                    <Input
                      type="text"
                      name="billingCity"
                      id="billingCity"
                      placeholder="City"
                      maxLength="50"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="billingPostalCode">Postal or Zip Code</Label>
                    <Input
                      type="text"
                      name="billingPostalCode"
                      id="billingPostalCode"
                      placeholder="Zip Code"
                      maxLength="7"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="billingCoutryId">Country</Label>
                    <Input type="select" name="billingCoutryId" id="billingCoutryId">
                      <option value="-1">Select a country</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              {
                activeOp === "Add New" ? null 
                :
              <Row>
              <Col md={12} className="d-flex justify-content-end">
                <Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={purchaseBilling}>Save</Button>
                </Col>
              </Row>
               }
             </Collapse>
             
              

              <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo" onClick={activeOp === "Add New" ? null : thirdPartyInfo}>
              {activeOp !== "Add New" && (
                      <>
                          <i
                              className={
                                  isThirdPartyInfoOpen
                                      ? "fas fa-chevron-up"
                                      : "fas fa-chevron-down"
                              }
                          />
                          &nbsp;&nbsp;
                      </>
                  )}
                  Third Party Info
              </h6>

              <Collapse isOpen={isThirdPartyInfoOpen}>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="taxId">Tax Id</Label>
                    <Input
                      type="number"
                      name="taxId"
                      // id="taxId"
                      value={taxId}
                      onChange={(e)=>setTaxId(e.target.value)}
                      placeholder="Tax Id"
                      maxLength="70"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="clientProgramNumber">Client Program Number</Label>
                    <Input
                      type="number"
                      name="clientProgramNumber"
                      // id="clientProgramNumber"
                      value={clientProgramNumber}
                      onChange={(e)=>setClientProgramNumber(e.target.value)}
                      placeholder="Client Program Number"
                      maxLength="50"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="company">Company</Label>
                    <Input
                      type="text"
                      name="company"
                      // id="company"
                      value={company}
                      onChange={(e)=>setCompany(e.target.value)}
                      placeholder="Company"
                      maxLength="70"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="contact">Contact</Label>
                    <Input
                      type="text"
                      name="contact"
                      // id="contact"
                      value={contact}
                      onChange={(e)=>setContact(e.target.value)}
                      placeholder="Contact"
                      maxLength="50"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="line1"> Line 1</Label>
                    <Input
                      type="text"
                      name="line1"
                      // id="company"
                      value={lineOne}
                      onChange={(e)=>setLineOne(e.target.value)}
                      placeholder="Enter Line 1 Address"
                      maxLength="70"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="Line2">Line 2</Label>
                    <Input
                      type="text"
                      name="Line2"
                      // id="contact"
                      value={lineTwo}
                      onChange={(e)=>setLineTwo(e.target.value)}
                      placeholder="Enter Line 2 Address"
                      maxLength="50"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="line3"> Line 3</Label>
                    <Input
                      type="text"
                      name="line3"
                      // id="company"
                      value={lineThree}
                      onChange={(e)=>setLineThree(e.target.value)}
                      placeholder="Enter Line 3 Address"
                      maxLength="70"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="City">City</Label>
                    <Input
                      type="text"
                      name="City"
                      // id="contact"
                      value={thirdPartyCity}
                      onChange={(e)=>setThirdPartyCity(e.target.value)}
                      placeholder="Enter City"
                      maxLength="50"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
              <Col md={6}>
                  <FormGroup>
              <Label for="Country">Country</Label>
              <Select 
                options={currencyOptionThird} 
                value={defaultCountryThird?.value ? defaultCountryThird : null} 
                onChange={handleCountry}
                placeholder="Select Country"
              />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
              <Label for="region">Region</Label>
              <Select 
                options={regionOption} 
                value={defaultRegion?.value ? defaultRegion : null} 
                onChange={handleRegionChnage}
                placeholder="Select Region"
              />
                  </FormGroup>
                </Col>
               
              </Row>
             <Row form>
             <Col md={6}>
                  <FormGroup>
                    <Label for="postal">Postal Code</Label>
                    <Input
                      type="number"
                      name="postal"
                      // id="contact"
                      value={postalCodeThird}
                      onChange={(e)=>setPostalCodeThird(e.target.value)}
                      placeholder="Enter Postal Code"
                      maxLength="50"
                    />
                  </FormGroup>
                </Col>
             <Col md={6}>
                  <FormGroup>
                    <Label for="postalExt">Postal Code Ext</Label>
                    <Input
                      type="number"
                      name="postalExt"
                      // id="contact"
                      value={postalExt}
                      onChange={(e)=>setPostalExt(e.target.value)}
                      placeholder="Enter Postal Code Ext"
                      maxLength="50"
                    />
                  </FormGroup>
                </Col>
               
               
             </Row>
             <Row form>
              <Col md={12} className="d-flex justify-content-end">
              <Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={handleThirdPartyinfo} disabled={loadThirdParty}>{!loadThirdParty && "Save"} {loadThirdParty && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />} </Button>
              </Col>
             </Row>
              </Collapse>
              
              
             
         

            <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo d-flex align-items-center py-1" onClick={activeOp === "Add New" ? null : handlePaymentOptions}>
                {activeOp !== "Add New" && (
                    <>
                        <i
                            className={
                                isPaymentOptions
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                            }
                        />
                        &nbsp;&nbsp;
                    </>
                )}
                Purchaser Payment Options
              </h6>
            <Collapse isOpen={isPaymentOptions}> 
            <Input
                type="hidden"
                name="paymentOptId"
                id="paymentOptId"
                value=""
              />
              
              <Input 
              type="hidden"
              name="purchaserID"
              id="purchaserID"
              />
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="paymentTypeId">Payment Option<span className="required-asterisk">*</span></Label>
                    <Input
                      type="select"
                      name="paymentTypeId"
                      id="paymentTypeId"
                      onChange={onPaymentTypeChange}
                    >
                      <option value="-1">Select a payment type</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6} className="">
                  <FormGroup id="fundCtl" className="d-none">
                    <Label for="fundAmount">Funds</Label>
                    <Input
                      type="number"
                      name="fundAmount"
                      id="fundAmount"
                      placeholder="Funds on account"
                    />
                  </FormGroup>
                  <FormGroup id="creditCtlOut">
                    <Label for="creditLimit">Credit limit</Label>
                    <Input
                      type="number"
                      name="creditLimit"
                      id="creditLimit"
                      placeholder="Credit limit"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="threshold d-none">
                <Col md={6} >

                  <FormGroup id="thresholdCtl">
                    <Label for="creditThreshold">Credit Threshold</Label>
                    <Input
                      type="number"
                      name="creditThreshold"
                      id="creditThreshold"
                      placeholder="Credit Threshold"
                    />
                  </FormGroup>
                  <FormGroup id="prepiaCtl">
                    <Label for="prepaidFunds">Prepaid Funds</Label>
                    <Input
                      type="number"
                      name="prepaidFunds"
                      id="prepaidFunds"
                      placeholder="Prepaid Funds"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                <FormGroup id="CurrenctCtl">
                  <label for="currency">Currency</label>
                  <Input 
                  type="select"
                  name="currency"
                  id="currency"
                  onChange={handleCurrencyChnage}
                 
                  >
                    <option value="-1">Select a Currency Type</option>
                  </Input>
                </FormGroup>
                <FormGroup className="d-none">
                <Input 
                type="checkbox"
                name="Fundstatus"
                id="Fundstatus"
                value={fundStat}
                onChange={handleStatus}
                
              />
                </FormGroup>
                </Col>


              </Row>
              <Row>
                <FormGroup id="addNew">
                <Col md={12}  className="d-flex align-item-center justify-content-end">
                  <Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={AddFundDetails}>Add New</Button>
                  {activeOp === "Add New" ? null 
                  : 
                  <Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={paymentOption}>Save</Button>
                  }
                  </Col>
                </FormGroup>
              </Row>
              
              <Row>
                <FormGroup id="addSave">
                {activeOp === "Add New" ? null 
                 :
                <Col md={12}  className="d-flex align-item-center justify-content-end">
                  <Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={paymentOption}>Save</Button>
                </Col>
               }
                </FormGroup>
              </Row>
              
              <Row>
                <Col md={12}>
                  <FormGroup id="FundData">
                    <div className="table-responsive">
                  <DataTable 
                  ref={fundTable}
                   data={fundTableData}
                         options={{ dom: "tip" }}
                    columns={[
                      { title: "Purchaser Name", data: "purchaserName" },
                      {title:"Fund",data:"funds", render:(data)=>{
                        const formattedData = data.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                          return `$${formattedData}`;
                       
                      }},
                      { title: "Credit Threshold", data: "creditThreshold",render:(data)=>{
                        const formattedData = data.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                       return `$${formattedData}`;
                      } },
                      { title: "Currency", data: "currency" },
                      { title: "Prepaid Funds", data: "prepaidFunds",render:(data)=>{
                        const formattedData = data.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                       return `$${formattedData}`;
                      } },
                      { title: "Credit Limit", data: "creditLimit",render:(data)=>{
                        const formattedData = data.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        return `$${formattedData}`;
                      } },

                      {
                        title: "Threshold Amount",data:"lowFundAlert",render:(data) =>{
                       const formattedData = data?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                          return `$${formattedData}`;
                        }
                      }
                    
                      
                    ]}
              
                    addEditButton={{
                      callback: EditFundData,
                      viewMode: false,
                      
                    }}
                    addRemoveButton={{
                      callback: deleteFundLimit,
                      viewMode: false,
                    }}
                  />
                  </div>
                  </FormGroup>
                </Col>
              </Row>
            </Collapse>
              
            
              {activeOp === "Edit" && (
                <>
                  <h6
                    className="ncentiva-form-section-header text-light custom_header_colourTwo d-flex align-items-center py-1"
                    onClick={handlePurchaserFeesAndDiscounts}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={
                        isPurchaserFeesOpen
                          ? "fas fa-chevron-up"
                          : "fas fa-chevron-down"
                          
                      }
                    />
                    &nbsp;&nbsp;Purchaser Fees and Discounts
                  </h6>
                <Collapse isOpen={isPurchaserFeesOpen}>
                <Input type="hidden" name="feeId" id="feeId" value="" />
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="purchaseFee">Purchase Brand</Label>
                        <Select
                          value={brandRSelect}
                          name="brandSelect"
                          options={brandsPurchaserClean}
                          onChange={handleFeeBrandChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Best supplier discount</Label>
                        <p className="border py-2 pl-2 rounded">
                          {bestSupplier === ""
                            ? "Select a Brand"
                            : bestSupplier}
                        </p>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                    
                    </Col>
                    

                    <Col md={6}>
                    <div className="d-flex  align-items center">
                    <div>
                      <p style={{fontSize:"15px",fontWeight:'500'}}>Select purchaser fee:</p>
                     </div>
                    <div className="d-flex justify-content-center align-items center ms-3">
                      <div>
                      <FormGroup className="mb-0 d-flex">
                      <Label className="mb-0">Fee as amount</Label>
                     <input className="ms-1" type="radio" value={feeInput} checked={feeInput === "AMOUNT"} onChange={()=>handleFeeChange("AMOUNT")}/>
                     </FormGroup>
                      </div>
                    <div className="ms-3">
                    <FormGroup className="mb-0 d-flex">
                      <Label className="mb-0">Fee as percentage</Label>
                     <input className="ms-1" type="radio" value={feeInput} checked={feeInput === "PERCENTAGE"} onChange={()=>handleFeeChange("PERCENTAGE")} />
                     </FormGroup>
                    </div>
                    
                    </div>
                    </div>
                  </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="purchaseDiscount">
                          Purchase Discount (in percentage e.g. 15 for 15%)
                        </Label>
                        <Input
                          type="number"
                          value={brandDisc}
                          onChange={(e) => setBrandDisc(e.target.value)}
                          placeholder="Discount"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                    <FormGroup>
                        <Label for="purchaseDiscount">Purchase Fee {` ${feeInput === "AMOUNT" ? "(as amount)":"(in percentage e.g. 10 for 10%)"  }`}</Label>
                        <Input
                          type="number"
                          value={brandFee}
                          onChange={(e) => setBrandFee(e.target.value)}
                          placeholder="Fee"
                        />
                      </FormGroup>
                      </Col>
                  </Row>
                  <h6
                    className="ncentiva-form-section-header text-light custom_header_colourTwo"
                    onClick={() => setApiCredInfo(!apiCredInfo)}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={
                        apiCredInfo
                          ? "fas fa-chevron-up"
                          : "fas fa-chevron-down"
                          
                      }
                    />
                    &nbsp;&nbsp;Add Limit
                  </h6>
                  <Collapse isOpen={apiCredInfo}>
                    <Row>
                      {/* <Col md={6}>
												<FormGroup>
													<Label for="purchaseDiscount">Order Threshold</Label>
													<Input type="number" value={orderThreshold} onChange={(e) => setOrderThreshold(e.target.value)} placeholder="Order threshold" />
												</FormGroup>
											</Col> */}
                      <Col md={6}>
                        <FormGroup>
                          <Label for="purchaseDiscount">Minimum Amount</Label>
                          <Input
                            type="number"
                            value={minimumAmount || 1}
                            onChange={(e) => setMinimumAmount(e.target.value)}
                            placeholder="Minimum Amount"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="purchaseDiscount">Maximum Amount</Label>
                          <Input
                            type="number"
                            value={maximumAmount || 100000}
                            onChange={(e) => setMaximumAmount(e.target.value)}
                            placeholder="Maximum Amount"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="purchaseDiscount">Minimum Quantity</Label>
                          <Input
                            type="number"
                            value={minimumQuantity || 1}
                            onChange={(e) => setMinimumQuantity(e.target.value)}
                            placeholder="Minimum Quantity"
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label for="purchaseDiscount">Maximum Quantity</Label>
                          <Input
                            type="number"
                            value={maximumQuantity || 100000}
                            onChange={(e) => setMaximumQuantity(e.target.value)}
                            placeholder="Maximum Quantity"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Collapse>
                  {/* <Row>
										<Col md={5} className='d-flex align-items-center justify-content'>
											<input type="file" name="file" onChange={handleFileChange} />
                                            <Button type="button" color="primary" onClick={handleFileUpload}>Upload</Button>
										</Col>
										<Col md={2} className='d-flex align-items-end justify-content'>
											<Button type="button" color="primary" onClick={() => { downloadBrandLimit(operativeRow) }}>DOWNLOAD</Button>
										</Col>
										<Col md={5} className='d-flex align-items-end justify-content-end'>
											<Button type="button" color="primary" onClick={() => { addBrandToBrandList(operativeRow); setbestSupplier('') }}>Save brand discount</Button>
										</Col>
									</Row> */}
                  {/* <Row >
										<Col md={6} className='d-flex align-items-center justify-content-start' >

											<Row >
												<Col  md="12" className="justify-content-start text-left">
												<Button type="button" color="primary" onClick={() => { downloadBrandLimit(operativeRow) }}>DOWNLOAD</Button>
												</Col>
											<Col  md="12" style={{display:'flex',flexDirection:'row',alignItems:'center',zIndex:'999'}} className="justify-content-start text-left">
												<input type="file" name="file" onChange={handleFileChange} ref={fileInputRef} />
												{selectedFile && (
                                               <Button style={{ cursor: 'pointer' }} type="button" color="secondary" size="sm" onClick={handleCancelFile}>x</Button>)}
												<Button style={{cursor:'pointer'}} type="button" color="primary" onClick={handleFileUpload}>Uploads</Button>


											</Col>	
											</Row>
										</Col>

										<Col md={6} className='d-flex align-items-center justify-content-end'>
										<Row >
										<Col  md="12" className="justify-content-end text-right">
											<Button type="button" color="primary" onClick={() => { addBrandToBrandList(operativeRow); setbestSupplier('') }}>Save brand discount</Button>
										</Col>
										</Row>
										</Col>
									</Row> */}
                  <Row>
                    <Col
                      md={6}
                      className="d-flex align-items-center justify-content-start"
                    >
                      <div className="" style={{ width: "100%" }} >
                        <Select
                          options={brandSelects}
                          onChange={handleOrderSelectChange}
                          value={selectedOptions}
                          isMulti={true}
                        />
                      </div>
                    </Col>
                    <Col
                      md={6}
                      className="d-flex align-items-center justify-content-end"
                    >
                      <Row>
                        <Col md="12">
                          <div className="d-flex align-items-center justify-content-end flex-row">
                            <Button
                              className="mr-3 btn btn-primaryTwo"
                              style={{ cursor: "pointer" }}
                              type="button"
                              // color="primary"
                              onClick={() => toggleUpload()}
                            >
                              UPLOAD FILE
                            </Button>
                            <Button
                              type="button"
                              // color="primary"
                              onClick={() => {
                                addBrandToBrandList(operativeRow);
                                setbestSupplier("");
                              }}
                              className="btn btn-primaryTwo"
                              disabled={loaderSave4}
                            >
                              {!loaderSave4 && "Save brand discount"}{loaderSave4 && 
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{
                                  margin: "0px 8px"
                                }}
                              />}
                            </Button>
                          </div>
                        </Col>
                        <Col md="12" className="justify-content-end text-right">
                          {/* <input type="file" name="file" onChange={handleFileChange} ref={fileInputRef} />
												{selectedFile && (
												<Button style={{ cursor: 'pointer' }} type="button" color="secondary" size="sm" onClick={handleCancelFile}>x</Button>
												)} */}
                        </Col>
                        <Col
                          md="12"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            zIndex: "999",
                          }}
                          className="justify-content-end text-right"
                        >
                          {/* <Button type="button" color="primary" onClick={() => { downloadBrandLimit(operativeRow) }}>DOWNLOAD</Button> */}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                    
                      {loaderTwo ? 
                        <div className='d-flex justify-content-center align-items-center flex-column vh-50'>
                           <div className="spinner-border text-muted text-center"></div>
                        </div>
                      :	
                    
                    <div className="table-responsive">
                      <DataTable
                        ref={tableDiscFee}
                        data={brandsFeeDisc}
                        columns={[
                          { title: "Brand Name", data: "brandName" },
                          { title: "Purchaser Fee", data: "purchaserFee" },
                          {
                            title: "Purchaser Discount",
                            data: "purchaserDiscount",
                          },
                         { title: "Currency", data: "currency" },
                          // {title: 'Order Threshold', data: 'orderThreshold'},
                          { title: "Minimum Amount", data: "minimumAmount" },
                          { title: "Miximum Amount", data: "maximumAmount" },
                          {
                            title: "Minimum Quantity",
                            data: "minimumQuantity",
                          },
                          {
                            title: "Maximum Quantity",
                            data: "maximumQuantity",
                          },
                        ]}
                        options={{ dom: "tip" }}
                        addRemoveButton={{
                          callback: deleteBrandLimit,
                          viewMode: false,
                        }}
                      />
                      </div>
}
                    </Col>
                  </Row>
                </Collapse>
                  
                  
                  
                  <Modal
                    isOpen={upload}
                    toggle={toggleUpload}
                    backdrop="static"
                    centered={true}
                    size="xl"
                  >
                    <ModalHeader toggle={toggleUpload} className="custom_header_colourTwo">
                      {activeOp} Order
                    </ModalHeader>
                    <Form>
                      <ModalBody>
                        <div className={modalCSVcss.container}>
                          <div className="text">
                          <div className="tooltip-container" onMouseEnter={() => setShowTooltip(true)}
									       onMouseLeave={() => setShowTooltip(false)} style={{ cursor: "pointer",marginLeft:"32px" }}>
                      <p
                        className="text-center tooltip-trigger mb-0"
                        
                      >
                        <BsInfoCircle size={20}  />
                      </p>
                      {showTooltip && (
                        <div className="tooltip-content">
                        <p>
                        You can download a template, identify  the brands and gift cards and  just need to modify (Purchase fees and Discounts) information on those you selected. 
                          </p>
                        <p>Please select a file of type CSV and press Save.</p>
                        </div>
                      )}
                      </div>
                    <p className="text_format">Instructions</p>
                          
                          </div>
                          <label
                            htmlFor="file"
                            className={modalCSVcss.formContainer}
                          >
                            <UploadIcon />
                            <span>File Upload CSV</span>
                            <input
                              type="file"
                              name=""
                              id="file"
                              className={modalCSVcss.dn}
                              onChange={handleFileChange}
                              // ref={file}
                              accept=".csv"
                            />
                          </label>

                          {fileCsv?.name && (
                            <div className={modalCSVcss.fileSelected}>
                              <p>
                                {fileCsv.name}{" "}
                                <span className="arrow">
                                  <img src={okIMG} alt="" />
                                </span>
                              </p>
                            </div>
                          )}
                          {/* {isProcessing && (
                      <div className="d-flex align-items-center">
                        <p className="mr-2 mb-0 font-weight-bold">Order is processing</p>
                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
            )} */}
                        </div>
                        <p
                          className="dbuttonc"
                          style={{
                            color: "#2665F2",
                            fontWeight: "900",
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                        
                          onClick={() => {
                            downloadBrandLimit(operativeRow);
                          }}
                        >
                          Download Template
                        </p>
                      </ModalBody>
                      <ModalFooter>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={toggleUpload}
                        >
                          Cancel
                        </Button>{" "}
                        <Button
                          type="submit"
                          // color="primary"
                          className="btn btn-primaryTwo"
                          onClick={handleFileUpload}
                        >
                          Save
                        </Button>
                      </ModalFooter>
                    </Form>
                  </Modal>

                

                </>
              )}

              <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo d-flex align-items-center py-1" onClick={activeOp === "Add New" ? null : handleContactInfo}>
                {activeOp !== "Add New" && (
                  <>
                   <i
                      className={
                        isContactInfoOpen
                          ? "fas fa-chevron-up"
                          : "fas fa-chevron-down"
                          
                      }
                    /> &nbsp;&nbsp;
                  </>
                )}
              Purchaser Personal Contact Information<span className="required-asterisk">*</span>
              </h6>
             <Collapse isOpen={isContactInfoOpen}>
             <Row form className="justify-content-end">
                <Col md={12}>
                <div className="table-responsive">
                  <DataTable
                    ref={contactTable}
                    data={contacts}
                    columns={[
                      {
                        title: "Contact Type",
                        data: "purchaserContactTypeId",
                        render: (data) => {
                          const ct = contactType.find(
                            (item) => item.id === parseInt(data)
                          );
                          return !!ct
                            ? ct.name
                            : contactType.length > 0
                              ? "No Contact Type"
                              : "Loading...";
                        },
                      },
                      { title: "First Name", data: "contactFirstName" },
                      { title: "Last Name", data: "contactLastName" },
                      {title: "Email",data: "email",
                        render: (data) => data.toLowerCase()
                      },
                    ]}
                    addEditButton={{
                      callback: (row) => {
                        setActiveContact(row);
                        setContactModal(true);
                        setContactActionType({ action: "edit" });
                      },
                      viewMode: false,
                    }}
                    addRemoveButton={{callback:deleteContact}}
                    options={{ dom: "tr" }}
                  />
                  </div>

                  {contactActionType.action === "add" ? (
                    <BaseModal
                      okButtonTag="Add Contact"
                      cancelButtonTag="Close"
                      onOk={addContact}
                      onCancel={() => {setContactModal(false) ; addContactLoader()}}
                      trigger={contactModal}
                      toggle={() => setContactModal(!contactModal)}
                      onOpened={prepareContactForm}
                      size="lg"
                      hideCancel={!!activeContact}
                      title="Add Purchaser Contacts"
                      buttonLoader={buttonLoader}
                    >
                      <ContactsCtl formRef={contactForm} />
                    </BaseModal>
                  ) : (
                    <BaseModal
                      okButtonTag="Update Contact"
                      cancelButtonTag="Close"
                      onOk={updateContact}
                      onCancel={() => setContactModal(false)}
                      trigger={contactModal}
                      toggle={() => setContactModal(!contactModal)}
                      onOpened={prepareContactForm}
                      size="lg"
                      hideCancel={!!activeContact}
                      title="Update Purchaser Contacts"
                      buttonLoader={buttonLoader}
                    >
                      <ContactsCtl formRef={contactForm}/>
                    </BaseModal>
                  )}
                </Col>
              </Row>
              <Row form>
                <Col md="12" className="justify-content-end text-right">
                  <Button
                    type="button"
                    // color="primary"
                    className="btn btn-primaryTwo"
                    onClick={() => {
                      setActiveContact(null);
                      setContactModal(true);
                      setContactActionType({ action: "add" });
                    }}
                  >
                    Add contact
                  </Button>
                  {contactTable.current?.dataTable
                    .data()
                    .toArray()
                    .length > 0 && activeOp !== "Add New" ? <Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={contactinformation}>Save</Button> : ""}
                  
                </Col>
              </Row>
             </Collapse>
              
              
              {/* Supplier Table To be done */}
              {activeOp === "Edit" && (
                <>
                  <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo" onClick={supplier}>
                  <i
                      className={
                        isSupplierOpen
                          ? "fas fa-chevron-up"
                          : "fas fa-chevron-down"
                          
                      }
                    /> &nbsp;&nbsp;Supplier
                  </h6>
                  <Collapse isOpen={isSupplierOpen}>
                  <Row form>
                    {supplyLoad ? (
                      ""
                    ) : (
                      <Col md="12">
                        {supplierNameData ? (
                          <div className="table-responsive">
                          <DataTable
                            ref={supplierNameData}
                            data={supplierNameData}
                            columns={[{ title: "Name", data: "supplierName" }]}
                            addRemoveButton={{ callback: deleteBrandLimits }}
                            //   {
                            // 	{ callback: (supplierNameData) =>
                            // 	 deleteBrandLimits({data:"supplierName"})
                            // 	 }
                            // 	}
                            options={{ dom: "tip" }}
                          />
                          </div>
                        ) : (
                          ""
                        )}
                      </Col>
                    )}

                    {/* work herer 3erer er */}

                    <Col md="12" className="justify-content-end text-right">
                      <Button
                        type="button"
                        className="btn btn-primaryTwo"
                        onClick={() => {
                          setSupplierModal(true);
                        }}
                      >
                        Add Supplier
                      </Button>
                    </Col>
                  </Row>
                  </Collapse>
                  
                  
                </>
              )
              }
           

              <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-1 d-flex align-items-center" onClick={activeOp === "Add New" ? null : handlePurchaseBannedBrandInfo} style={{cursor:"pointer"}}>
                {activeOp !== "Add New" && (
                  <>
                    <i
                      className={
                        isBannedBrandInfo
                          ? "fas fa-chevron-up"
                          : "fas fa-chevron-down"
                          
                      }
                    /> &nbsp;&nbsp;
                  </>
                )}
             Purchaser Banned Brand Information
              </h6>
              <Collapse isOpen={isBannedBrandInfo}>
              <Row form>
                <Col md={12}>
                <div className="table-responsive">
                  <DataTable
                    ref={brandTable}
                    data={null}
                    columns={[
                      {
                        title: "Brand",
                        data: "name",
                        sortable: true,
                      },
                      {
                        title: "Card Types",
                        data: "cards",
                        render: (data) => {
                          if (data) {
                            return (
                              "<ul>" +
                              data
                                .map((item) => {
                                  const cardType = cardTypes.current.find(
                                    (card) =>
                                      card.id === parseInt(item.giftCardTypeId)
                                  );
                                  return `<li>${!!cardType
                                    ? cardType.productName
                                    : "Invalid card type"
                                    } /  ${!!cardType.sku
                                      ? cardType.sku
                                      : "Not available"
                                    }</li>`;
                                })
                                .join("") +
                              "</ul>"
                            );
                          }
                          return "Banned Brand";
                        },
                      },
                    ]}
                    addEditButton={{
                      callback: (row) => {
                        setActiveBrand(row);
                        setBrandModal(true);
                      },
                      viewMode: false,
                    }}
                    addRemoveButton={{ callback: removeBrand }}
                    options={{ dom: "tip" }}
                  />
                  </div>
                  <BaseModal
                    okButtonTag="Save"
                    cancelButtonTag="Close"
                    onOk={addBrand}
                    onCancel={() => {
                      setBrandModal(false);
                      setActiveBrand(null);
                      setBrandOperation(null);
                      cleanTemporaryBanedCards();
                    }}
                    trigger={brandModal}
                    toggle={() => {
                      setBrandModal(!brandModal);
                    }}
                    onOpened={prepareBrandForm}
                    size="lg"
                    title="Ban purchaser Brands"
                  >
                    <BrandsCtl
                      token={token}
                      formRef={brandForm}
                      cardTypes={cardTypes.current}
                      brandOperation={brandOperation}
                      cardTypeTable={cardTypeTable}
                      removeCardType={removeCardType}
                      cardTypeInput={cardTypeInput}
                      cardTypeForm={cardTypeForm}
                      addCardType={addCardType}
                      shouldDelete={setShouldDeleteBand}
                      brandList={brandFilter}
                      brandTable={brandTable}
                      selectRef={brandSelect}
                      payload={payload}
                      setPayload={setPayload}
                      purchaserId={sendID}
                      productName= {productName}
                      setProductName={setProductName}
                      cardId={cardId}
                      setCardId={setCardId}
                    />
                  </BaseModal>
                  <BaseModal
                    okButtonTag="Save"
                    cancelButtonTag="Close"
                    onOk={() => createPurchaserSupplierDetail(supplierID)}
                    onCancel={() => {
                      setSupplierModal(false);
                      setActiveBrand(null);
                      setBrandOperation(null);
                      cleanTemporaryBanedCards();
                    }}
                    trigger={supplierModal}
                    toggle={() => {
                      setSupplierModal(!supplierModal);
                    }}
                    // onOpened={prepareBrandForm}
                    size="lg"
                    title="Add Suppliers"
                    buttonLoader={loaderSave6}
                  >
                    <>
                      <ReactNotificationAlert ref={alert} />
                      <Form innerRef={props.formRef}>
                        <Row form>
                          <Col md="12" style={{ position: "relative" }}>
                            <FormGroup>
                              <Label for="brandId">Supplier</Label>
                              <Select
                                onChange={supplierChange}
                                name="supplierId"
                                id="supplierId"
                                options={suppliers}
                                isClearable={true}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Form>
                    </>
                  </BaseModal>
                </Col>
              </Row>
              <Row form>
                <Col md="12" className="justify-content-end text-right">
                  <Button
                    type="button"
                    // color="primary"
                    className="btn btn-primaryTwo"
                    onClick={() => {
                      setBrandModal(true);
                    }}
                  >
                    Add Brand
                  </Button>
                </Col>
              </Row>
              </Collapse>
              
              
              <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-1 d-flex align-items-center" onClick={activeOp === "Add New" ? null : handleInventoryBannedBrandInfo} style={{cursor:"pointer"}}>
                {activeOp !== "Add New" && (
                  <>
                   <i
                      className={
                        isInventoryBannedBrandInfo
                          ? "fas fa-chevron-up"
                          : "fas fa-chevron-down"
                          
                      }
                    /> &nbsp;&nbsp;
                  </>
                )}
             Inventory Banned Brand Information
            </h6>
            <Collapse isOpen={isInventoryBannedBrandInfo}>
            <Row form>
                <Col md={12}>
                <div className="table-responsive">
                    <DataTable
                        ref={inventoryBrandTable}
                        data={inventoryData}
                        columns={[
                            {
                                title: "Brand",
                                data: "brandName",
                                sortable: true,
                            },
                            {
                              title: "RefID",
                              data: "refid",
                            
                              sortable: true,
                              render: data =>{
                                if(data){
                                  return data
                                }else return ''
                                },
                          }
                          
                        ]}
                        addEditButton={{callback:editInventoryBrand}}
                        addRemoveButton={{ callback: removeInventoryBrand }}
                        options={{ dom: "tip" }}
                    />
                    </div>
                </Col>
            </Row>
            <Row form>
                <Col md="12" className="justify-content-end text-right">
                    <Button
                        type="button"
                        // color="primary"
                        className="btn btn-primaryTwo"
                        onClick={() => {
                          toggleInventoryBrand();
                          
                        }}
                    >
                        Add Brand
                    </Button>
                </Col>
            </Row>
            </Collapse>

            <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-1 d-flex align-items-center" onClick={activeOp === "Add New" ? null : handleInventoryWhiteListInfo} style={{cursor:"pointer"}}>
                {activeOp !== "Add New" && (
                  <>
                   <i
                      className={
                        isInventoryWhiteListInfo
                          ? "fas fa-chevron-up"
                          : "fas fa-chevron-down"
                          
                      }
                    /> &nbsp;&nbsp;
                  </>
                )}
             Inventory whiteList Brand Information
            </h6>
            <Collapse isOpen={isInventoryWhiteListInfo}>
            <Row form>
                <Col md={12}>
                <div className="table-responsive">
                    <DataTable
                        ref={inventoryWhiteBrandTable}
                        data={inventoryWhiteData}
                        columns={[
                            {
                                title: "Brand",
                                data: "brandName",
                                sortable: true,
                            },
                            {
                              title: "RefID",
                              data: "refid",
                            
                              sortable: true,
                              render: data =>{
                                if(data){
                                  return data
                                }else return ''
                                },
                          }
                          
                        ]}
                        addEditButton={{callback:editInventoryWhiteBrand}}
                        addRemoveButton={{ callback: removeInventoryWhiteBrand }}
                        options={{ dom: "tip" }}
                    />
                    </div>
                </Col>
            </Row>
            <Row form>
                <Col md="12" className="justify-content-end text-right">
                    <Button
                        type="button"
                        // color="primary"
                        className="btn btn-primaryTwo"
                        onClick={() => {
                          toggleInventoryWhite();
                          
                        }}
                    >
                        Add Brand
                    </Button>
                </Col>
            </Row>
            </Collapse>
            {
              activeOp === "Edit" && (
                <>
                <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-1 d-flex align-items-center" onClick={activeOp === "Add New" ? null : handleOrderThreshold} style={{cursor:"pointer"}}>
                {activeOp !== "Add New" && (
                  <>
                   <i
                      className={
                        isOrderThreshold
                          ? "fas fa-chevron-up"
                          : "fas fa-chevron-down"
                          
                      }
                    /> &nbsp;&nbsp;
                  </>
                )}
            Order Threshold
            </h6>
            <Collapse isOpen={isOrderThreshold}>
         
            <Row>
            <Col md={6}>
              <FormGroup>
              <Label for="purchaseDiscount">Minimum Amount</Label>
              <Input
                type="number"
                value={minimumAmountOrder}
                onChange={(e) => setMinimumAmountOrder(e.target.value)}
                placeholder="Minimum Amount"
              />
             </FormGroup>
              </Col>
              <Col md={6}>
              <FormGroup>
                <Label for="purchaseDiscount">Maximum Amount</Label>
                 <Input
                 type="number"
                  value={maximumAmountOrder}
                  onChange={(e) => setMaximumAmountOrder(e.target.value)}
                  placeholder="Maximum Amount"
                />
                </FormGroup>
                </Col>
            </Row>
            <Row>
            <Col md={6}>
              <FormGroup>
              <Label for="purchaseDiscount">Minimum Quantity</Label>
                  <Input
                  type="number"
                  value={minimumQuantityOrder}
                  onChange={(e) => setMinimumQuantityOrder(e.target.value)}
                  placeholder="Minimum Quantity"
                  />
                </FormGroup>
                </Col>

               <Col md={6}>
                <FormGroup>
                  <Label for="purchaseDiscount">Maximum Quantity</Label>
                  <Input
                  type="number"
                  value={maximumQuantityOrder}
                  onChange={(e) => setMaximumQuantityOrder(e.target.value)}
                  placeholder="Maximum Quantity"
                    />
                  </FormGroup>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="d-flex justify-content-end">
                <Button type="button" className="btn btn-primaryTwo" style={{cursor:"pointer"}} onClick={orderInformation}>Save</Button>
                </Col>
              </Row>
               <Row form>
                <Col md={12}>
                <div className="table-responsive">
                    <DataTable
                        ref={orderThresholdTable}
                        data={brandData}
                        columns={[
                            
                          { title: "Minimum Amount", data: "minimumAmount" },
                          { title: "Miximum Amount", data: "maximumAmount" },
                          {
                            title: "Minimum Quantity",
                            data: "minimumQuantity",
                          },
                          {
                            title: "Maximum Quantity",
                            data: "maximumQuantity",
                          },
                          ]}
                       
                        addRemoveButton={{ callback: removethresholdBrand }}
                        options={{ dom: "tip" }}
                    />
                    </div>
                </Col>
            </Row> 
            </Collapse>
                </>
                
          
              )}
           
           {activeOp === "Edit" && (
                <>
                  <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo" onClick={handleSupplierBrandPriority}  style={{cursor:"pointer"}}>
                  <i
                      className={
                        isSupplierPriorityOpen
                          ? "fas fa-chevron-up"
                          : "fas fa-chevron-down"
                          
                      }
                    /> &nbsp;&nbsp;Supplier's Brand Priority
                  </h6>
                  <Collapse isOpen={isSupplierPriorityOpen}>
                  <Row form>
                    <Col md={12}>
                    <div className="table-responsive">
                      <DataTable
                        ref={bestBrandTable}
                        data={null}
                        columns={[
                          {
                            title: "Supplier",
                            data: "supplier",
                            sortable: true,
                          },
                          {
                            title: "Brand",
                            data: "brandName",

                          },
                          {
                            title:"Cumulative Quantity",
                            data:'Quantity',
                          },
                          {
                            title:"Cumulative Value",
                            data:"Value",
                          },
                          {
                            title:"Time Lapse",
                            data:"time",
                            render: (data) =>{
                              if(data){
                                return `${new Date(data).toLocaleDateString('en-US', {timeZone: 'UTC'})}`
                              }else{
                                return ''
                              }

                            }
                          },
                          //  {
                          //    title:"Priority",
                          //  data:"priority",
                          //   render : (data) =>{
                          //      if(data){
                          //        return data
                          //     }else{
                          //       return ``
                          //      }
                          //   }
                          //  }
                        ]}

                        addRemoveButton={{ callback: deleteBestBrandFunc }}
                        // addEditButton={{callback:editSupplierBrandPriority}}
                        options={{ dom: "tip" }}
                      />
                      </div>
                      <BaseModal
                        okButtonTag="Save"
                        cancelButtonTag="Close"
                        onOk={addBestBrandFunc}
                        onCancel={() => {
                          setBestBrandModal(false);
                          setBrandSelectedOption(null)
                          setSelectedOption(null)
                          setQuantityVal(null)
                          setEdit(false)
                          setValue(null)
                          setTimeLapse("")
                          setPriority()
                        }}
                        trigger={bestBrandModal}
                        toggle={() => {
                          setBestBrandModal(!bestBrandModal);
                        }}
                        onOpened={prepareBrandForm}
                        size="lg"
                        title={edit ? "Edit Brands" : "Add Brands"}
                        buttonLoader={loaderSave12}
                      >
                        <BestBrandsCtl
                          token={token}
                          formRef={bestBrandForm}
                          selectRef={bestBrandSelect}
                          supplierSelectRef={supplierSelect}
                          quantitySelectRef={quantity}
                          ValueSelectRef={ValueRef}
                          dateSelectRef={DateRef}
                          prioritySelectRef ={priorityRef}
                          suppliersList={suppliersTwo}
                          setSelectedOption={setSelectedOption}
                          setQuantityVal={setQuantityVal}
                          setValue={setValue}
                          value={value}
                          setTimeLapse={setTimeLapse}
                          timeLapse={timeLapse}
                          setPriority={setPriority}
                          priority={priority}
                          editOption={edit}
                          setEdit={setEdit}
                          quantityVal={quantityVal}
                          setBrandSelectedOption={setBrandSelectedOption}
                          brandSelectedOption={brandSelectedOption}
                          selectedOption={selectedOption}
                          purchaserIDs={purchaserIDs}
                          purchaseId={purchaseId}
                          setPurchaseId={setPurchaseId}
                        />
                      </BaseModal>
                    </Col>
                  </Row>
                  <Row form>
                    <Col md="12" className="justify-content-end text-right">
                      <Button
                        type="button"
                        // color="primary"
                        className="btn btn-primaryTwo"
                        onClick={() => {
                          setBestBrandModal(true);
                        }}
                      >
                        Add Brand
                      </Button>
                    </Col>
                  </Row>
                  
                  </Collapse>
                 
             
                </>
              )}


            </Form>
          </ModalBody>
          <ModalFooter className="flex-nowrap">
            {activeOp === "Add New" ?
            <Col md={6} className="justify-content-end text-right">
              <Button
                type="submit"
                className="mr-3"
                color="secondary"
                onClick={cancelOperation}
              >
                Cancel
              </Button>
              <Button type="button" className="btn btn-primaryTwo" onClick={openConfirmforSave}>
                Save
              </Button>
            </Col>
            :
            <Col md={6} className="d-flex justify-content-end" style={{padding:"0px"}}>
              <Button
                type="submit"
                // className="mr-3"
                color="secondary"
                onClick={cancelOperation}
              >
                Close
              </Button>
            </Col>}
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={purchaseOrdersModal}
          toggle={togglePurchaseOrders}
          backdrop="static"
          centered={true}
          size="xl"
          style={{ maxWidth: "85% !important" }}
          className="kjlnblk"
        >
          <ModalHeader toggle={togglePurchaseOrders} className="custom_header_colourTwo">
            Purchase Orders
          </ModalHeader>
          <ModalBody>
            <PurchaseOrdersByPurchaser token={token} accessRoles={accessRoles}/>
            {/* <PurchaserOrders token={token} /> */}
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="secondary"
              onClick={togglePurchaseOrders}
            >
              Cancel
            </Button>{" "}
          </ModalFooter>
        </Modal>

        {/* csv modal */}

        {/* <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal> */}

        {/* csv modal */}

        <Modal
          isOpen={createPurchaseOrderModal}
          toggle={toggleCreatePurchaseOrder}
          backdrop="static"
          centered={true}
          size="xl"
          style={{ maxWidth: "85% !important" }}
        >
          <ModalHeader toggle={toggleCreatePurchaseOrder} className="custom_header_colourTwo">
            Create purchase order
          </ModalHeader>
          <ModalBody>
            <InternalPurchaseOrderForm
              name={name}
              token={token}
              setData={setDataModalConfirm}
              onReferenceValueChange={handleReferenceValueChange}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="secondary"
              className="mr-3"
              onClick={toggleCreatePurchaseOrder}
            >
              Cancel
            </Button>
            <Button type="button" className="btn btn-primaryTwo" onClick={modalOrderToConfirm}>
              Next
            </Button>
          </ModalFooter>
        </Modal>

        <ModalConfirm
          isOpen={modalConfirm}
          toggle={modalConfirmToggle}
          onBack={onModalConfirmBack}
          onConfirm={onModalConfirmDone}
          data={dataModalConfirm}
          termsShow={termsofUseShow}
          token={token}
        />
        <Modal
          isOpen={detailsModal}
          toggle={toggleDetails}
          backdrop="static"
          centered
          size={brandsNav ? "xl" : "lg"}
        >
          <ModalHeader className="custom_header_colourTwo" toggle={()=>{
            toggleDetails()
            setContacts([]);
            setContactNav(true);
            setNotificationNav(false);
            setUsersNav(false)
          }}>
            Purchaser Details
          </ModalHeader>
          <ModalBody>
            <Container>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    id="contact-navlink"
                    className="text-decoration-none text-reset"
                    active={contactNav}
                    onClick={toggleNavbar}
                  >
                    Contacts
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    id="users-navlink"
                    className="text-decoration-none text-reset"
                    active={usersNav}
                    onClick={toggleNavbar}
                  >
                    Users
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink
                    id="brands-navlink"
                    className="text-decoration-none text-reset"
                    active={brandsNav}
                    onClick={toggleNavbar}
                  >
                    Brands
                  </NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink
                    id="notification-navlink"
                    className="text-decoration-none text-reset"
                    active={notificationNav}
                    onClick={toggleNavbar}
                  >
                    Notification
                  </NavLink>
                </NavItem>
              </Nav>
              {contactNav ? (
                <ContactManager
                  token={token}
                  contacts={contacts}
                  contactType={contactType}
                  purchaser={purchaserToManage}
                />
              )

                /* brandsNav ? (
                  <BrandList
                    token={token}
                    purchaser={purchaserToManage}
                    brandPurchaser={brandsFeeDisc}
                  />
                )  */
                : usersNav ? (
                  <PurchaserManager
                    token={token}
                    formRef={purchaserUsersForm}
                    usersTable={purchaserUsersTable}
                    purchaser={purchaserToManage}
                    contactTypes={contactType}
                  />
                ) : notificationNav &&  Object.keys(selectedRadio).length > 0 ? (
                  <PurchaserNotification
                    // const [selectedRadio, setSelectedRadio] = React.useState({});
                    setSelectedRadio={setSelectedRadio}
                    selectedRadio={selectedRadio}
                    onModalCliclk={onclickModal}
                    purchaser={purchaserToManage}
                    token={token}
                    onDatataClickFunc={onDatataClickFunc}
                    onDatataClick={onDeleteEmailButton}
                    contactType={contactType}
                    customeEmail={customeEmail}
                    isOpen={isOpen}
                    contacts={contactsList}
                  />
                ) : null}
            </Container>
          </ModalBody>
          <ModalFooter>
            {notificationNav && (
              <button
                class="btn btn-primaryTwo"
                type="button"
                // color="secondary"
                onClick={() => {
                  onclickModal();
                }}
              >
                Add mail
              </button>
            )}
            {notificationNav && (
              <button
                class="btn btn-primaryTwo"
                type="button"
                // color="secondary"
                onClick={() => {
                  onApplyByMailFunc();
                  setContacts([]);
                }}
                disabled={loaderSave14}
              >
                {!loaderSave14 && "Apply"} {loaderSave14 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}
              </button>
            )}
            {notificationNav == false && (
              <button
                type="button"
                class="btn btn-primaryTwo"
                onClick={() => {
                  toggleDetails();
                  // setContacts([]);
                }}
              >
                Apply
              </button>
            )}
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                toggleDetails();
                setContacts([]);
                setContactNav(true);
                setNotificationNav(false);
              }}
            >
              Close
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={invoiceModal}
          toggle={toggleInvoice}
          backdrop="static"
          centered
          size={invoiceNav ? "xl" : "lg"}
        >
          <ModalHeader className="custom_header_colourTwo" toggle={toggleInvoice}>
            Payment Details
          </ModalHeader>
          <ModalBody>
            <Container className="mt-5">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    id="paymenti-nvoice-navlink"
                    className="text-decoration-none text-reset"
                    active={paymentNav}
                    onClick={toggleInvoceNavber}
                  >
                    Payment
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    id="invoice-navlink"
                    className="text-decoration-none text-reset"
                    active={invoiceNav}
                    onClick={toggleInvoceNavber}
                  >
                    Invoice
                  </NavLink>
                </NavItem>

              </Nav>
              {
                paymentNav ? (
                  <PaymentManager
                    token={token}
                    payment={payment}
                    sendId={sendID}
                    apidata={apiDataAdd}
                    updatedData={updateData}
                    setInvoice={setInvoiceModal}
                    paymentModalTwo={paymentModalTwo}
                    cancelOrder={cancelOrder}
                    setPaymentModalTwo={setPaymentModalTwo} 
                    setCancelOrder={setCancelOrder} 
                    dropdownCall={dropdownCall}
                    setdropdownCall={setdropdownCall}
                   
                       
                  />


                ) : invoiceNav ?
                  (
                    <InvoiceManeger
                      token={token}
                      invoice={invoiceData}

                    />
                  ) :
                  null}
            </Container>
          </ModalBody>
          <ModalFooter className={paymentNav ? "justify-content-between" : "justify-content-end "}>
            {paymentNav ?
              <Row>
                <Col className={"align-content text-right"}>
                  <MotionButton
                    className="btn btn-primaryTwo"
                    // color="primary"
                    onClick={addPayment}
                  >
                    <i className="fas fa-shopping-cart" /> Register Payment
                  </MotionButton>
                </Col>
              </Row> : ""
            }

            <Row>
              <Col md="4" className="d-flex">
                <button
                  type="button"
                  className="btn btn-primaryTwo"
                  onClick={() => setInvoiceModal(false)}
                >
                  Apply
                </button>
                <Button type="button"
                  color="secondary"
                  onClick={toggleInvoice}
                >
                  close
                </Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={confirmModal}
          toggle={toggleConfirm}
          backdrop="static"
          centered={true}
        >
          <ModalHeader className="custom_header_colour align-items-center" toggle={toggleConfirm}>
            <h3 className="mb-0" style={{ fontSize: '20px' }}>Remove Purchaser</h3>
          </ModalHeader>
          <ModalBody>
            <p className="card-just-text">
              Are you sure you want to remove the Purchaser "
              {!!operativeRow && !!operativeRow.data
                ? operativeRow.data().name
                : ""}
              "?
            </p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={toggleConfirm}>
              Cancel
            </Button>{" "}
            <Button type="button" className="btn btn-primaryTwo" onClick={confirmDelete}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={updateFunds}
          toggle={toggleUpdateFunds}
          backdrop="static"
          size="sm"
          centered={true}
        >
          <ModalHeader toggle={toggleUpdateFunds}>Add file</ModalHeader>
          <ModalBody>
            <Form innerRef={form}>
              <Row form>
                <Col md={12}>
                  <FormGroup>
                    <Label for="file">Upload file</Label>
                    <CustomInput
                      label="choose file..."
                      accept=".csv"
                      type="file"
                      name="file"
                      id="fileInput"
                      onChange={validateFile}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleUpdateFunds}>
              Cancel
            </Button>{" "}
            <Button className="btn btn-primaryTwo" onClick={uploadFile}>
              Upload
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={isOpen} backdrop="static" centered>
          {/* {showmail == true ? (
            <>
              <ModalHeader className=""> mail id</ModalHeader>
              <ModalBody>{selectMail}</ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={() => onDeleteEmailButton()}>
                  Delete
                </Button>{" "}
                <Button color="primary" onClick={() => onApplyByMailFunc()}>
                  Apply
                </Button>
              </ModalFooter>
            </>
          ) : (
            <> */}
          <ModalHeader className="custom_header_colourTwo"> <h4 className="mb-0 mt-0">Enter mail id</h4> </ModalHeader>
          <ModalBody>
            <Form encType="multipart/form-data">
              <Input type="hidden" name="cardTypeId" />
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="email"
                  onChange={(e) => setSelectMail(e.target.value)}
                  name="email"
                  id="email"
                />
              </FormGroup>



              {error && <h6 style={{ color: "red" }}>{error}</h6>}
            </Form>
            {/* <div className="d-flex justify-content-evenly ">
              <div>
              <p>cardDelivary</p>
                <Radio
                  color="primary"
                  name={'cardDelivery'}
                  onChange={(e)=>handleRadioChange(e)}
                  value="cardDelivery"
                  checked={cardDelivery}
                 
                />
                </div>
                <div>
                <p>orderConfirmation</p>
                  <Radio
                  color="primary"
                  name={'orderConfirmation'}
                  onChange={(e)=>handleOrderRadio(e)}
                  
                checked={orderConfirmation}
                 
                />
                </div>
                <div>
                  <p>proFormaInvoice</p>
                  <Radio
                  color="primary"
                  name={'proFormaInvoice'}
                  onChange={(e)=>handleProfoRadio(e)}
                  
                checked={proFormaInvoice}
                 
                />
                </div>
                <div>
                  <p>orderInvoice</p>
                  <Radio
                  color="primary"
                  name={'orderinvoice'}
                  onChange={(e)=>handleOrderInvoice(e)}
                  
                  checked={orderInvoice}
                 
                />
                </div>
            </div> */}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => onclickModal()}>
              Cancel
            </Button>{" "}
            <Button className="btn btn-primaryTwo" onClick={() => onSubmitButton()} disabled={loaderSave13}>
              {!loaderSave13 && "Submit"} {loaderSave13 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}
            </Button>
          </ModalFooter>
          {/* </>
          )} */}
        </Modal>

        <Modal
          isOpen={paymentModal}
          toggle={toggleRegister}
          backdrop="static"
          centered={true}
          size="lg"
        >
          <ModalHeader toggle={handleRegisterClsoe} className="custom_header_colourTwo">
            Deposite Funds
          </ModalHeader>
          <Form>
            <ModalBody>
              <Form className="container-fluid">
                <Row>
                  <Col md="6" style={{ position: "relative" }}>
                    <FormGroup>
                      <Label for="topup">Topup Amount</Label>
                      <Input
                        type="number"
                        id="topup"
                        value={topup}
                        onChange={(e) => handleTopUp(e)}
                        onKeyDown={(e) => {
                         if (
                            ["e", "E", "+", "-", " "].includes(e.key) || 
                            (e.key === "." && e.target.value.includes(".")) 
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter Topup Amount"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" style={{ position: "relative" }}>
                  <FormGroup>
                  <label for="Currency">Currency </label>
                  <Select 
                  // value={defaultCategory}
                  options={categoryOption}
                  isMulti={false}
                  onChange={handleCurrency}
                  isClearable={true} 
                  id="Currency"/>
                </FormGroup>
                  </Col>


                  <h6
                    className="ncentiva-purchase-header-section text-dark"
                    onClick={() => setBillingInfo(!billingInfo)}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={
                        billingInfo
                          ? "fas fa-chevron-down"
                          : "fas fa-chevron-up"
                      }
                    />
                    &nbsp;&nbsp;Billing Address
                  </h6>

                  <Collapse isOpen={billingInfo} >
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-address"
                          >
                            Address
                          </label>
                          <Input
                            className="form-control-alternative bg-white"
                            id="input-address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="Home Address"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-city"
                          >
                            City
                          </label>
                          <Input
                            className="form-control-alternative bg-white"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            id="input-city"
                            placeholder="City"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup>
                          <Label for="countryIds">Country</Label>
                          <Input type="select" name="countryIds" id="countryIds" onChange={handleCountryChange} value={countryData} >
                            <option value="-1">Select a country</option>
                            {country.map((count) => (
                              <option key={count.id} value={count.id}>
                                {count.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-country"
                          >
                            Postal code
                          </label>
                          <Input
                            className="form-control-alternative bg-white"
                            value={postal}
                            onChange={(e) => setPostal(e.target.value)}
                            id="input-postal-code"
                            placeholder="Postal code"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Collapse>

                  <Col md="12" style={{ position: "relative" }}>
                    <FormGroup>
                      <Label for="reference">Your reference</Label>
                      <Input
                        type="text"
                        id="reference"
                        value={reference}
                        onChange={(e) => setReference(e.target.value)}
                        placeholder="Enter Reference"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
            <ModalFooter className="justify-content-start">
              <Row>
                <Col md="12" >
                  <button type="button" className="btn btn-primaryTwo" onClick={fundPostData} disabled={depositeLoader}>
                    Deposit Funds{
                      depositeLoader &&
                      <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{marginLeft:"5px"}}
                                     />
                    }
                  </button>
                </Col>
              </Row>

            </ModalFooter>
          </Form>
        </Modal>
        <Modal
          isOpen={showBrandsNav}
          toggle={onBrandNavClick}
          backdrop="static"
          centered
          size={brandsNav ? "xl" : "lg"}
        >
          <ModalHeader className="custom_header_colourTwo" toggle={onBrandNavClick}>
            Brands List
          </ModalHeader>
          <ModalBody>
            <Container>

              <BrandList
                token={token}
                purchaser={purchaserToManage}
                brandPurchaser={brandsFeeDisc}
              />

            </Container>
          </ModalBody>
          <ModalFooter>

            <Button
              type="button"
              color="secondary"
              onClick={() => {
                onBrandNavClick();
              }}
            >
              Close
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <Modal
    isOpen={fundShow}
    toggle={toggleFund}
    backdrop="static"
    centered={true}
    size="xl"
    
>
    <ModalHeader toggle={toggleFund} className="custom_header_colourTwo">
        Edit Funds
    </ModalHeader>
    <Form>
        <ModalBody>
            <h6 className=" text-dark">
                Purchaser Payment Options
            </h6>
            <Input
                type="hidden"
                name="paymentOptId"
                id="paymentOptId"
                value=""
            />
            <Input 
                type="hidden"
                name="purchaserID"
                id="purchaserID"
            />
            <Row form>
               <Col md={6}>
                    <FormGroup id="fundCtl">
                        <Label for="fundAmount">Funds</Label>
                        <Input
                            type="number"
                            // name="fundAmount"
                            value={fundValue}
                             onChange={(e)=>setFundValue(e.target.value)}
                            placeholder="Funds on account"
                            
                        />
                    </FormGroup>
                    
                </Col>
                <Col md={6} >
                    <FormGroup id="thresholdCtl" className="" >
                        <Label for="creditThreshold">Credit Threshold</Label>
                        <div className="position-relative">
                        <Input
                            type="number"
                            // name="creditThreshold"
                            // id="creditThreshold"
                            value={thresholdValue}
                            onChange={(e)=>setThresholdValue(e.target.value)}
                            placeholder="Credit Threshold"
                            className="custom_input"
                            disabled
                        />
                        <Button type="button" className="position-absolute h-100 top-0 end-0 my-0"
                        color="secondary" onClick={modifyCredit}>Modify</Button>
                        </div>
                    </FormGroup>
                    </Col>
            </Row>
            <Row form>
               
                    <Col md={6}>
                    
                    <FormGroup id="creditCtl">
                        <Label for="creditLimit">Remaining Credit</Label>
                        <Input
                            type="number"
                            // name="creditLimit"
                            // id="creditLimit"
                            value={creditValue}
                            onChange={(e)=>setCreditValue(e.target.value)}
                            placeholder="Credit limit"
                          
                        />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup id="prepiaCtl">
                        <Label for="prepaidFunds">Prepaid Funds</Label>
                        <Input
                            type="number"
                            // name="prepaidFunds"
                            // id="prepaidFunds"
                            value={prepareValue}
                            onChange={(e)=>setPrepareValue(e.target.value)}
                            placeholder="Prepaid Funds"
                            
                        />
                    </FormGroup>
                  </Col>
                </Row>
                <Row form> 
                 
                <Col md={6}>
                    <FormGroup id="CurrenctCtl">
                        <label for="currency">Currency</label>
                        <Select 
                          //  name="currency"
                            // id="currency"
                            options={currOption}
                            value={defaultCurrency}
                            isMulti={false}
                            onChange={handleCurrencyChnage}
                            isDisabled={true}
                        />
                            
                        
                    </FormGroup>
                    <FormGroup className="d-none">
                        <Input 
                            type="checkbox"
                            name="Fundstatus"
                            id="Fundstatus"
                            value={fundStat}
                            onChange={handleStatus}
                        />
                    </FormGroup>
                </Col>
                <Col md={6}>
                <FormGroup className="">
                <label for="threshold">Set Lowfund Alert</label>
                        <Input 
                            type="number"
                            // name="threshold"
                            // id="Fundstatus"
                            value={threshold}
                            onChange={(e)=>setThreshold(e.target.value)}
                            placeholder="Enter threshold amount"
                        />
                    </FormGroup>
                </Col>
            </Row>
            
        </ModalBody>
        <ModalFooter>
            <Button
                type="button"
                color="secondary"
                onClick={toggleFund}
            >
                Cancel
            </Button>{" "}
            <Button
                type="button"
                // color="primary"
                className="btn btn-primaryTwo"
                onClick={UpdateFundDetails}
            >
                Update Fund
            </Button>
        </ModalFooter>
    </Form>
</Modal>
<Modal
    isOpen={addFund}
    toggle={toggleAddFundModal}
    backdrop="static"
    centered={true}
    size="xl"
    
>
    <ModalHeader toggle={toggleAddFundModal} className="custom_header_colourTwo">
        Add Funds
    </ModalHeader>
    <Form>
        <ModalBody>
        
          <>
            
            <Input
                type="hidden"
                name="paymentOptId"
                id="paymentOptId"
                value=""
            />
            <Input 
                type="hidden"
                name="purchaserID"
                id="purchaserID"
            />
            <Row form>
               
                <Col md={6}>
                    <FormGroup id="fundCtl">
                        <Label for="fundAmount">Funds</Label>
                        <Input
                            type="number"
                            // name="fundAmount"
                            // id="fundAmount"
                            value={addFundValue}
                            onChange={(e)=>setAddFundValue(e.target.value)}
                            placeholder="Funds on account"
                            disabled
                        />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup id="thresholdCtl">
                        <Label for="creditThreshold">Credit Threshold</Label>
                        <Input
                            type="number"
                            // name="creditThreshold"
                            // id="creditThreshold"
                            value={addThresholdValue}
                            onChange={(e)=>setAddThresholdValue(e.target.value)}
                            placeholder="Credit Threshold"
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="" form>
                
                <Col md={6}>
                    <FormGroup id="creditCtl">
                        <Label for="creditLimit">Credit limit</Label>
                        <Input
                            type="number"
                            // name="creditLimit"
                            // id="creditLimit"
                            value={addCreditValue}
                            onChange={(e)=>setAddCreditValue(e.target.value)}
                            placeholder="Credit limit"
                            disabled
                        />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup id="prepiaCtl">
                        <Label for="prepaidFunds">Prepaid Funds</Label>
                        <Input
                            type="number"
                            // name="prepaidFunds"
                            // id="prepaidFunds"
                            value={addPrepareValue}
                            onChange={(e)=>setAddPrepareValue(e.target.value)}
                            placeholder="Prepaid Funds"
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row form> 
               
                <Col md={6}>
                    <FormGroup id="CurrenctCtl">
                        <Label for="currency">Currency</Label>
                        <Select 
                            options={currOption}
                            isMulti={false}
                            isClearable={true}
                            name="currency"
                            // id="currency"
                            onChange={handleCurrencyChnage}
                        />
                           
                    </FormGroup>
                    <FormGroup className="d-none">
                        <Input 
                            type="checkbox"
                            name="Fundstatus"
                            id="Fundstatus"
                            value={fundStat}
                            onChange={handleStatus}
                        />
                    </FormGroup>
                </Col>
                <Col md={6}>
                <FormGroup className="">
                <label for="threshold">Set Lowfund Alert</label>
                        <Input 
                            type="number"
                            // name="threshold"
                            // id="Fundstatus"
                            value={threshold}
                            onChange={(e)=>setThreshold(e.target.value)}
                            placeholder="Enter threshold amount"
                        />
                    </FormGroup>
                </Col>
            </Row>
            </>
           
        </ModalBody>
        <ModalFooter>
            <Button
                type="button"
                color="secondary"
                onClick={toggleAddFundModal}
            >
                Cancel
            </Button>{" "}
            <Button
                type="button"
                // color="primary"
                className="btn btn-primaryTwo"
                onClick={AddModalFund}
                disabled={loadFunds}
            >
                {!loadFunds && "Save"}{loadFunds && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />} 
            </Button>
        </ModalFooter>
    </Form>
</Modal>
      <Modal isOpen={finishOpen} toggle={toggleFinishModal} backdrop="static" centered>
          <ModalHeader className="custom_header_colourTwo" toggle={toggleFinishModal}>Confirm {activeOp} changes</ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              {activeOp === "Add New" ? "Do you want to save this as new purchaser" : "Do you want to save the changes to this purchaser"}
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleFinishModal}>Close</Button>
            <Button className="btn btn-primaryTwo" onClick={finishOperation} disabled={loadConfirmFinish}>{!loadConfirmFinish && "Confirm"}{loadConfirmFinish && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
          </ModalFooter>
			</Modal>

      <Modal isOpen={inventoryBrandModal} toggle={toggleInventoryBrand} backdrop="static" centered>
    <ModalHeader className="custom_header_colourTwo" toggle={toggleInventoryBrand}>
        Banned Brands
    </ModalHeader>
    <ModalBody>
        <Row form>
            <Col md="6" style={{ position: "relative" }}>
                <FormGroup>
                    <Label for="brandId">Brand</Label>
                    <Select
                       name="brandId"
                        id="brandId"
                        options={brandOption}
                        onChange={handleBrandSelect}
                        isClearable={true}
                    />
                </FormGroup>
            </Col>
            <Col md="6" style={{ position: "relative" }}>
                <FormGroup>
                    <Label for="refId">Ref ID</Label>
                    <Select
                       name="refId"
                        id="refId"
                        isMulti={true}
                        options={refOption}
                        onChange={handleRefSelect}
                        isClearable={true}
                    />
                </FormGroup>
            </Col>
        </Row>
    </ModalBody>
    <ModalFooter>
        <Button className="btn btn-primaryTwo" onClick={handleInventoryBrand} disabled={loaderSave7}>{!loaderSave7 && "Save"}{loaderSave7 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
    </ModalFooter>
</Modal>

<Modal isOpen={inventoryEditBrandModal} toggle={toggleInventoryBrandEdit} backdrop="static" centered>
    <ModalHeader className="custom_header_colourTwo" toggle={toggleInventoryBrandEdit}>
     Update Banned Brands
    </ModalHeader>
    <ModalBody>
        <Row form>
            <Col md="6" style={{ position: "relative" }}>
                <FormGroup>
                    <Label for="brandId">Brand</Label>
                    <Select
                       name="brandId"
                        id="brandId"
                        isDisabled={true}
                        value={barndDataTwo}
                        options={brandOption}
                        onChange={handleBrandSelect}
                        isClearable={true}
                    />
                </FormGroup>
            </Col>
            <Col md="6" style={{ position: "relative" }}>
                <FormGroup>
                    <Label for="refId">Ref ID</Label>
                    <Select
                       name="refId"
                        id="refId"
                        isMulti={true}
                        value={selectedRefIds}
                        options={refOption}
                        onChange={handleRefSelectEdit}
                        isClearable={true}
                    />
                </FormGroup>
            </Col>
        </Row>
    </ModalBody>
    <ModalFooter>
        <Button className="btn btn-primaryTwo" onClick={handleInventoryBrandEdit} disabled={loaderSave8}>{!loaderSave8 && "Save"}{loaderSave8 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
    </ModalFooter>
</Modal>
<Modal isOpen={inventoryWhiteModal} toggle={toggleInventoryWhite} backdrop="static" centered>
    <ModalHeader className="custom_header_colourTwo" toggle={toggleInventoryWhite}>
        WhiteList Brands
    </ModalHeader>
    <ModalBody>
        <Row form>
            <Col md="6" style={{ position: "relative" }}>
                <FormGroup>
                    <Label for="brandId">Brand</Label>
                    <Select
                        name="brandId"
                        id="brandId"
                        options={brandOption}
                        onChange={handleWhiteBrandSelect}
                        isClearable={true}
                    />
                </FormGroup>
            </Col>
            <Col md="6" style={{ position: "relative" }}>
                <FormGroup>
                    <Label for="refId">Ref ID</Label>
                    <Select
                        name="refId"
                        id="refId"
                        isMulti={true}
                        options={refOption}
                        onChange={handleRefWhiteSelect}
                        isClearable={true}
                    />
                </FormGroup>
            </Col>
        </Row>
    </ModalBody>
    <ModalFooter>
        <Button className="btn btn-primaryTwo" onClick={handleInventoryWhiteBrand} disabled={loaderSave9}>{!loaderSave9 && "Save"} {loaderSave9 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
    </ModalFooter>
</Modal>

<Modal isOpen={inventoryWhiteEditModal} toggle={toggleInventoryWhiteEdit} backdrop="static" centered>
    <ModalHeader className="custom_header_colourTwo" toggle={toggleInventoryWhiteEdit}>
        Update WhiteList Brands
    </ModalHeader>
    <ModalBody>
        <Row form>
            <Col md="6" style={{ position: "relative" }}>
                <FormGroup>
                    <Label for="brandId">Brand</Label>
                    <Select
                        name="brandId"
                        id="brandId"
                        isDisabled={true}
                        value={brandDataWhiteTwo}
                        options={brandOption}
                        onChange={handleWhiteBrandSelect}
                        isClearable={true}
                    />
                </FormGroup>
            </Col>
            <Col md="6" style={{ position: "relative" }}>
                <FormGroup>
                    <Label for="refId">Ref ID</Label>
                    <Select
                        name="refId"
                        id="refId"
                        isMulti={true}
                        value={selectedWhiteRefIds}
                        options={refOption}
                        onChange={handleRefWhiteSelectEdit}
                        isClearable={true}
                    />
                </FormGroup>
            </Col>
        </Row>
    </ModalBody>
    <ModalFooter>
        <Button className="btn btn-primaryTwo" onClick={handleInventoryWhiteBrandEdit} disabled={loaderSave10}>{!loaderSave10 && "Save"} {loaderSave10 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
    </ModalFooter>
</Modal>


<Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="custom_header_colourTwo" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
        </Modal>

        <Modal isOpen={editFinish} toggle={toggleEditFinishModal} backdrop="static" centered>
          <ModalHeader className="custom_header_colourTwo" toggle={toggleEditFinishModal}>Confirm {activeOp} changes</ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              Do you want to save the general information changes to this purchaser
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleEditFinishModal}>Close</Button>
            <Button className="btn btn-primaryTwo" onClick={saveInformation} disabled={loaderSave}>{!loaderSave && "Confirm"}{loaderSave && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
          </ModalFooter>
			</Modal>

      <Modal isOpen={addressModal} toggle={toggleAdressFinishModal} backdrop="static" centered>
          <ModalHeader className="custom_header_colourTwo" toggle={toggleAdressFinishModal}>Confirm {activeOp} changes</ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              Do you want to save the address information changes to this purchaser
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleAdressFinishModal}>Close</Button>
            <Button className="btn btn-primaryTwo" onClick={saveAddress} disabled={loaderSave1}>{!loaderSave1 && "Confirm"}{loaderSave1 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
          </ModalFooter>
			</Modal>
      <Modal isOpen={billingModal} toggle={toggleBillingFinishModal} backdrop="static" centered>
          <ModalHeader className="custom_header_colourTwo" toggle={toggleBillingFinishModal}>Confirm {activeOp} changes</ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              Do you want to save the Billing address information changes to this purchaser
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleBillingFinishModal}>Close</Button>
            <Button className="btn btn-primaryTwo" onClick={saveBillingAdress}disabled={loaderSave2}>{!loaderSave2 && "Confirm"}{loaderSave2 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
          </ModalFooter>
			</Modal>
      <Modal isOpen={paymentOptionModal} toggle={togglepaymentoptins} backdrop="static" centered>
          <ModalHeader className="custom_header_colourTwo" toggle={togglepaymentoptins}>Confirm {activeOp} changes</ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              Do you want to save the payment option changes to this purchaser
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={togglepaymentoptins}>Close</Button>
            <Button className="btn btn-primaryTwo" onClick={savePayment}disabled={loaderSave3}>{!loaderSave3 && "Confirm"}{loaderSave3 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
          </ModalFooter>
			</Modal>
      <Modal isOpen={contactFinishModal} toggle={toggleContactFinishModal} backdrop="static" centered>
          <ModalHeader className="custom_header_colourTwo" toggle={toggleContactFinishModal}>Confirm {activeOp} changes</ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              Do you want to save the contact information changes to this purchaser
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleContactFinishModal}>Close</Button>
            <Button className="btn btn-primaryTwo" onClick={saveContacts}disabled={loaderSave5}>{!loaderSave5 && "Confirm"}{loaderSave5 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
          </ModalFooter>
			</Modal>
      <Modal isOpen={orderThresholdModal} toggle={toggleOrderThreshold} backdrop="static" centered>
          <ModalHeader className="custom_header_colourTwo" toggle={toggleOrderThreshold}>Confirm {activeOp} changes</ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              Do you want to save the Order Threshold information changes to this purchaser
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleOrderThreshold}>Close</Button>
            <Button className="btn btn-primaryTwo" onClick={saveOrderThreshold} disabled={loaderSave11}>{!loaderSave11 && "Confirm"} {loaderSave11 && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
          </ModalFooter>
			</Modal>
      <Modal isOpen={creditModal} toggle={toggleCreditThreshold} backdrop="static" centered>
      <ModalHeader className="custom_header_colourTwo" toggle={toggleCreditThreshold}>Edit Credit Threshold</ModalHeader>
      <ModalBody>
       <p style={{fontSize:"18px",fontWeight:"600"}}>
        You can Add or Deduct the Credit Threshold
       </p>
       <Row >
        
        <Col md={4} style={{ position: "relative" }}>
        <FormGroup>
        <Label for="AddValue" style={{fontWeight:"500"}}>Add</Label>
        <Input type="checkbox" id="AddValue" name="AddValue" style={{marginLeft:"10px",marginTop:"3px"}} value={creditType} checked={creditType === "Add"} onChange={()=>handleCreditType("Add")} />
        </FormGroup>
        </Col>
        <Col md={4} className="dynamic_radio">
        <FormGroup>
        <Label style={{fontWeight:"500"}}>Deduct</Label>
        <Input type="checkbox" id="deductValue" style={{marginLeft:"10px",marginTop:"3px"}}  value={creditType} checked={creditType === "Deduct"} onChange={()=>handleCreditType("Deduct")} />
       </FormGroup>
        </Col>
        <Col md={4}>
        </Col>
        {/* <Col md={3}>
        </Col> */}
       </Row>
       <Row>
        <Col md={12}>
        <Label for="creditValue" style={{fontWeight:"500"}}>Value</Label>
        <Input type="number" id="creditValue" placeholder="Enter value" value={updateCreditValue} onChange={showNewThreshold}/>
        </Col>
       </Row>
       <Row className="mt-2">
        <Col md={6}>
        <FormGroup>
          <Label for="currentValue">Current Value</Label>
          <Input type="number" id="currentValue" placeholder="Enter current value" value={thresholdValue} />
        </FormGroup>
        </Col>
        <Col md={6}>
        <FormGroup>
          <Label for="NewValue">New Value</Label>
          <Input type="number" id="NewValue" placeholder="Enter current value" value={newValue} />
        </FormGroup>
        </Col>
       </Row>
      </ModalBody>
      <ModalFooter>
      <Button color="secondary" onClick={toggleCreditThreshold}>Close</Button>
      <Button className="btn btn-primaryTwo" onClick={saveUpdatedThreshold}>Save</Button>
      </ModalFooter>
      </Modal>
      </div>
    </>
  );
}

export default PurchaserView;
